/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const config = {
    imagePath: 'https://wwg-cdn.s3.eu-west-2.amazonaws.com/logos',
};

const imagePath$x = config.imagePath;
const cdsbGroup = [
    {
        code: 'cdsb-req01',
        shortName: 'CDSB REQ-01',
        name: 'CDSB REQ-01',
        subtitle: 'CDSB REQ-01 Governance',
        officialCode: '1',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req02',
        shortName: 'CDSB REQ-02',
        name: 'CDSB REQ-02',
        subtitle: 'CDSB REQ-02 Management’s environmental policies, strategy and targets',
        officialCode: '2',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req03',
        shortName: 'CDSB REQ-03',
        name: 'CDSB REQ-03',
        subtitle: 'CDSB REQ-03 Risks and opportunities',
        officialCode: '3',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req04',
        shortName: 'CDSB REQ-04',
        name: 'CDSB REQ-04',
        subtitle: 'CDSB REQ-04 Sources of environmental impact',
        officialCode: '4',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req05',
        shortName: 'CDSB REQ-05',
        name: 'CDSB REQ-05',
        subtitle: 'CDSB REQ-05 Performance and comparative analysis',
        officialCode: '5',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req06',
        shortName: 'CDSB REQ-06',
        name: 'CDSB REQ-06',
        subtitle: 'CDSB REQ-06 Outlook',
        officialCode: '6',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req07',
        shortName: 'CDSB REQ-07',
        name: 'CDSB REQ-07',
        subtitle: 'CDSB REQ-07 Organisational boundary',
        officialCode: '7',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req08',
        shortName: 'CDSB REQ-08',
        name: 'CDSB REQ-08',
        subtitle: 'CDSB REQ-08 Reporting policies',
        officialCode: '8',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req09',
        shortName: 'CDSB REQ-09',
        name: 'CDSB REQ-09',
        subtitle: 'CDSB REQ-09 Reporting period',
        officialCode: '9',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req10',
        shortName: 'CDSB REQ-10',
        name: 'CDSB REQ-10',
        subtitle: 'CDSB REQ-10 Restatements',
        officialCode: '10',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req11',
        shortName: 'CDSB REQ-11',
        name: 'CDSB REQ-11',
        subtitle: 'CDSB REQ-11 Conformance',
        officialCode: '11',
        src: `${imagePath$x}/cdsb.png`,
    },
    {
        code: 'cdsb-req12',
        shortName: 'CDSB REQ-12',
        name: 'CDSB REQ-12',
        subtitle: 'CDSB REQ-12 Assurance',
        officialCode: '12',
        src: `${imagePath$x}/cdsb.png`,
    },
];

const imagePath$w = config.imagePath;
const secGroup = [
    {
        code: 'labor',
        shortName: 'Labor',
        name: 'Labor Practices',
        subtitle: 'SEC Human Capital Disclosure - Labor Practices',
        officialCode: '1',
        src: `${imagePath$w}/sec.png`,
    },
    {
        code: 'h-and-s',
        shortName: 'Employee H&S',
        name: 'Employee Health & Safety',
        subtitle: 'SEC Human Capital Disclosure - Labor Practices',
        officialCode: '2',
        src: `${imagePath$w}/sec.png`,
    },
    {
        code: 'diversity',
        shortName: 'Diversity',
        name: 'Employee Engagement, Diversity and Inclusion',
        subtitle: 'SEC Human Capital Disclosure - Employee Engagement, Diversity and Inclusion',
        officialCode: '3',
        src: `${imagePath$w}/sec.png`,
    },
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$v = config.imagePath;
const seeGroup = [
    {
        code: 'see-social',
        src: `${imagePath$v}/see-social.png`,
        shortName: 'Social',
        name: 'Social',
        tooltip: 'This question is grouped under Social',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        description: 'Social (S): Social questions are based upon a variety of frameworks that help companies identify their contribution to those SDGs which aim to fulfil social objectives.'
    },
    {
        code: 'see-economic',
        src: `${imagePath$v}/see-economic.png`,
        shortName: 'Economic',
        name: 'Economic',
        tooltip: 'This question is grouped under Economic',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        description: 'Economic (E): Economic questions are based upon a variety of frameworks that help companies identify their contribution to those SDGs which are centred around economic benefit.'
    },
    {
        code: 'see-environment',
        src: `${imagePath$v}/see-environment.png`,
        shortName: 'Environment',
        name: 'Environment',
        tooltip: 'This question is grouped under Environment',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        description: 'Environment (E): Environment questions are based upon a variety of frameworks that help companies identify their contribution to the delivery of the SDGs which combat climate change and its impacts as well as environmental impacts in society.'
    }
];

const imagePath$u = config.imagePath;
const tcfdGroup = [
    {
        code: 'governance',
        shortName: 'TCFD V1 Governance',
        name: 'TCFD V1 Governance',
        subtitle: 'Task Force on Climate-related Financial Disclosures',
        officialCode: '1',
        src: `${imagePath$u}/tcfd_gov.png`,
    },
    {
        code: 'strategy',
        shortName: 'TCFD V1 Strategy',
        name: 'TCFD V1 Strategy',
        subtitle: 'Task Force on Climate-related Financial Disclosures',
        officialCode: '2',
        src: `${imagePath$u}/tcfd_strategy.png`,
    },
    {
        code: 'risk-management',
        shortName: 'TCFD V1 Risk Management',
        name: 'TCFD V1 Risk Management',
        subtitle: 'Task Force on Climate-related Financial Disclosures',
        officialCode: '3',
        src: `${imagePath$u}/tcfd_risk.png`,
    },
    {
        code: 'metrics-and-targets',
        shortName: 'TCFD V1 Metrics and Targets',
        name: 'TCFD V1 Metrics and Targets',
        subtitle: 'Task Force on Climate-related Financial Disclosures',
        officialCode: '4',
        src: `${imagePath$u}/tcfd_metric.png`,
    },
];

const imagePath$t = config.imagePath;
const ungcGroup = [
    {
        code: "ungc-one",
        shortName: "Principle 1",
        name: "UNGC - Principle 1",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '1',
        src: `${imagePath$t}/ungc-one.png`,
    },
    {
        code: "ungc-two",
        shortName: "Principle 2",
        name: "UNGC - Principle 2",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '2',
        src: `${imagePath$t}/ungc-two.png`,
    },
    {
        code: "ungc-three",
        shortName: "Principle 3",
        name: "UNGC - Principle 3",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '3',
        src: `${imagePath$t}/ungc-three.png`,
    },
    {
        code: "ungc-four",
        shortName: "Principle 4",
        name: "UNGC - Principle 4",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '4',
        src: `${imagePath$t}/ungc-four.png`,
    },
    {
        code: "ungc-five",
        shortName: "Principle 5",
        name: "UNGC - Principle 5",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '5',
        src: `${imagePath$t}/ungc-five.png`,
    },
    {
        code: "ungc-six",
        shortName: "Principle 6",
        name: "UNGC - Principle 6",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '6',
        src: `${imagePath$t}/ungc-six.png`,
    },
    {
        code: "ungc-seven",
        shortName: "Principle 7",
        name: "UNGC - Principle 7",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '7',
        src: `${imagePath$t}/ungc-seven.png`,
    },
    {
        code: "ungc-eight",
        shortName: "Principle 8",
        name: "UNGC - Principle 8",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '8',
        src: `${imagePath$t}/ungc-eight.png`,
    },
    {
        code: "ungc-nine",
        shortName: "Principle 9",
        name: "UNGC - Principle 9",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '9',
        src: `${imagePath$t}/ungc-nine.png`,
    },
    {
        code: "ungc-ten",
        shortName: "Principle 10",
        name: "UNGC - Principle 10",
        subtitle: "The Ten Principles of the UN Global Compact",
        officialCode: '10',
        src: `${imagePath$t}/ungc-ten.png`,
    }
];

const imagePath$s = config.imagePath;
const wefGroup = [
    {
        code: 'wef-principles-of-governance',
        shortName: 'Principles of Governance',
        name: 'WEF - Principles of Governance',
        subtitle: 'World Economic Forum - Toward Common Metrics',
        officialCode: '1',
        src: `${imagePath$s}/wef-principles-of-governance.png`,
    },
    {
        code: 'wef-planet',
        shortName: 'Planet',
        name: 'WEF - Planet',
        subtitle: 'World Economic Forum - Toward Common Metrics',
        officialCode: '2',
        src: `${imagePath$s}/wef-planet.png`,
    },
    {
        code: 'wef-people',
        shortName: 'People',
        name: 'WEF - People',
        subtitle: 'World Economic Forum - Toward Common Metrics',
        officialCode: '3',
        src: `${imagePath$s}/wef-people.png`,
    },
    {
        code: 'wef-prosperity',
        shortName: 'Prosperity',
        name: 'WEF - Prosperity',
        subtitle: 'World Economic Forum - Toward Common Metrics',
        officialCode: '4',
        src: `${imagePath$s}/wef-prosperity.png`,
    },
];

const imagePath$r = config.imagePath;
const ctlGroup = [
    {
        code: 'ctl-social',
        shortName: 'CTL Social',
        name: 'SDG Impact - Social',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        officialCode: 'Social',
        src: `${imagePath$r}/SDG_colour_wheel.svg`,
        colour: '#ED1D24'
    },
    {
        code: 'ctl-economic',
        src: `${imagePath$r}/SDG_colour_wheel.svg`,
        shortName: 'CTL Economic',
        name: 'SDG Impact - Economic',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        officialCode: 'Economic',
        colour: '#2971E5'
    },
    {
        code: 'ctl-environment',
        src: `${imagePath$r}/SDG_colour_wheel.svg`,
        shortName: 'CTL Environmental',
        name: 'SDG Impact - Environmental',
        subtitle: 'All 17 SDGs can be broadly aggregated to three overarching pillars Social (S), Economic (E), Environment (E).',
        officialCode: 'Environment',
        colour: '#35C866'
    }
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
var Tags;
(function (Tags) {
    Tags["UsRegulatory"] = "us_regulatory";
    Tags["AuRegulatory"] = "au_regulatory";
    Tags["SgRegulatory"] = "sg_regulatory";
    Tags["UsRating"] = "us_rating";
})(Tags || (Tags = {}));
const regulatoryTags = [
    Tags.UsRegulatory,
    Tags.AuRegulatory,
    Tags.SgRegulatory,
];
const ratingsTags = [
    Tags.UsRating,
];
/**
 * Each tag represents a premium scope pack
 **/
var RequiredTags;
(function (RequiredTags) {
    RequiredTags["BOF"] = "scope_bof";
    RequiredTags["CDP"] = "scope_cdp";
    RequiredTags["DJSI"] = "scope_djsi";
    RequiredTags["Refinitiv"] = "scope_refinitiv";
    RequiredTags["IOGP"] = "scope_iogp";
    RequiredTags["ISSB"] = "scope_issb";
    RequiredTags["Ipieca"] = "scope_ipieca";
    RequiredTags["SASB"] = "scope_sasb";
    RequiredTags["RSPO"] = "scope_rspo";
    RequiredTags["VigeoEiris"] = "scope_vigeoeiris";
    RequiredTags["CSRD"] = "scope_csrd";
    RequiredTags["WFN"] = "scope_wfn_2024";
})(RequiredTags || (RequiredTags = {}));

const imagePath$q = config.imagePath;
const eesgGroup = [
    {
        code: 'eesg_2024_economic',
        name: 'Economic Metrics',
        src: `${imagePath$q}/esg_30.png`,
    },
    {
        code: 'eesg_2024_environmental',
        name: 'Environmental Metrics',
        src: `${imagePath$q}/esg_30.png`,
    },
    {
        code: 'eesg_2024_social',
        name: 'Social Metrics',
        src: `${imagePath$q}/esg_30.png`,
    },
    {
        code: 'eesg_2024_governance',
        name: 'Governance Metrics',
        src: `${imagePath$q}/esg_30.png`,
    },
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$p = config.imagePath;
const frameworks = {
    cdsb: {
        code: 'cdsb',
        name: 'CDSB (Climate Disclosure Standards Board)',
        shortName: 'CDSB',
        src: `${imagePath$p}/cdsb.png`,
        description: 'The CDSB Framework for reporting environmental and climate change information is designed to help organisations prepare and present environmental information in mainstream reports for the benefit of investors. It allows investors to assess the relationship between specific environmental matters and the organization\'s strategy, performance and prospects.',
        link: 'https://www.cdsb.net/',
        subgroups: cdsbGroup
    },
    esg30: {
        code: 'esg30',
        name: 'ESG Essentials',
        shortName: 'ESG Essentials',
        src: `${imagePath$p}/esg_30.png`,
        description: '',
        subgroups: [
            {
                code: 'esg30_environmental',
                name: 'Environment',
                officialCode: 'esg30_environmental',
                src: `${imagePath$p}/esg_30.png`,
            },
            {
                code: 'esg30_social',
                name: 'Social',
                officialCode: 'esg30_social',
                src: `${imagePath$p}/esg_30.png`,
            },
            {
                code: 'esg30_governance',
                name: 'Governance',
                officialCode: 'esg30_governance',
                src: `${imagePath$p}/esg_30.png`,
            }
        ],
    },
    eesg_2024: {
        code: 'eesg_2024',
        name: 'EESG Metrics',
        shortName: 'EESG',
        src: `${imagePath$p}/esg_30.png`,
        description: '',
        subgroups: eesgGroup,
    },
    sec: {
        code: 'sec',
        src: `${imagePath$p}/sec.png`,
        name: 'SEC (US Securities and Exchange Commission)',
        shortName: 'SEC',
        tooltip: 'This question is aligned with the SEC',
        tags: [Tags.UsRegulatory],
        subtitle: 'SEC',
        description: 'Includes issues such as child and forced labor, fair wages and provision of benefits, attracting, retaining and maintaining the workforce, and relations with organized labor. ',
        link: 'https://www.sec.gov/news/press-release/2020-192',
        subgroups: secGroup
    },
    see: {
        code: 'see',
        src: `${imagePath$p}/social.png`,
        name: 'SEE (Social Economic Environment)',
        shortName: 'SEE',
        tooltip: 'This question is aligned with the SEE',
        subtitle: 'SEE',
        description: '',
        subgroups: seeGroup
    },
    tcfd: {
        code: 'tcfd',
        src: `${imagePath$p}/tcfd.png`,
        name: 'TCFD V1 (Task Force on Climate-Related Financial Disclosures)',
        shortName: 'TCFD V1',
        description: 'The Task Force on Climate-Related Financial Disclosures (TCFD) was set up in 2015 by the Financial Stability Board (FSB) to develop voluntary, consistent climate-related financial risk disclosures for use by companies, banks, and investors in providing information to stakeholders.',
        link: 'https://www.fsb-tcfd.org/',
        subgroups: tcfdGroup,
        versionGroupCode: 'tcfd',
        version: 2019,
        archived: true,
    },
    ungc: {
        code: 'ungc',
        name: 'UNGC 10 Principles',
        shortName: 'UNGC',
        src: `${imagePath$p}/un_gc.svg`,
        description: 'The Ten Principles of the United Nations Global Compact are derived from: the Universal Declaration of Human Rights, the International Labour Organization\'s Declaration on Fundamental Principles and Rights at Work, the Rio Declaration on Environment and Development, and the United Nations Convention Against Corruption.',
        link: 'https://www.unglobalcompact.org/what-is-gc/mission/principles',
        subgroups: ungcGroup
    },
    wef: {
        code: 'wef',
        src: `${imagePath$p}/wef.png`,
        name: 'World Economic Forum',
        shortName: 'WEF',
        subtitle: 'World Economic Forum',
        description: 'WEF',
        subgroups: wefGroup
    },
    ctl: {
        code: 'ctl',
        src: `${imagePath$p}/SDG_colour_wheel.svg`,
        name: 'SDG Impact',
        shortName: 'SDG Impact',
        description: 'Universal metrics we suggest all companies, irrespective of size and sector, should be monitoring and measuring themselves against. A great place to start your sustainability journey.',
        subgroups: ctlGroup,
    },
    msa: {
        code: 'msa',
        src: `${imagePath$p}/msa.png`,
        name: 'Modern Slavery Act',
        shortName: 'Modern Slavery Act',
        tags: [Tags.AuRegulatory],
        description: 'The national referral mechanism is used to identify and refer potential victims of modern slavery and make sure they receive appropriate support.',
        subgroups: [
            {
                code: 'msa-msa',
                src: `${imagePath$p}/msa.png`,
                name: 'Modern Slavery Act',
                shortName: 'Modern Slavery Act',
                subtitle: 'The national referral mechanism is used to identify and refer potential victims of modern slavery and make sure they receive appropriate support.',
            },
        ],
    },
    dei: {
        code: 'dei',
        src: `${imagePath$p}/dei.png`,
        name: 'Diversity, Equality and Inclusion Indicators',
        shortName: 'DE&I Indicators',
        description: 'Indicators covering Diversity, Equality and Inclusion. Categories of Concern include: 1. Women (gender), 2. Sexual orientation (LGBTQ+), 3. Racial minorities, 4. Religious and ethnic minorities, 5. Disabled/handicapped people, 6. Those over 55 years of age',
        subgroups: [
            {
                code: 'dei-diversity',
                src: `${imagePath$p}/dei.png`,
                name: 'Diversity Indicators',
                shortName: 'Diversity',
            },
            {
                code: 'dei-equality',
                src: `${imagePath$p}/dei.png`,
                name: 'Equality Indicators',
                shortName: 'Equality',
            },
            {
                code: 'dei-inclusion',
                src: `${imagePath$p}/dei.png`,
                name: 'Inclusion Inclusion',
                shortName: 'Inclusion',
            },
        ],
    },
};

/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */
var FeatureCode;
(function (FeatureCode) {
    FeatureCode["AdminDashboard"] = "adminDashboard";
    FeatureCode["Assurance"] = "assurance";
    FeatureCode["BulkDelegation"] = "bulkDelegation";
    FeatureCode["BulkImporting"] = "bulkImporting";
    FeatureCode["CombinedReport"] = "combinedReport";
    FeatureCode["CombinedSurvey"] = "combinedSurvey";
    FeatureCode["CustomMetrics"] = "customMetrics";
    FeatureCode["ReportingLevels"] = "reportingLevels";
    FeatureCode["SurveyTemplates"] = "surveyTemplates";
    FeatureCode["Users"] = "users";
    FeatureCode["Verification"] = "verification";
    FeatureCode["CustomDashboards"] = "customDashboards";
    FeatureCode["NoteInstructions"] = "noteInstructions";
    /** @deprecated */
    FeatureCode["AITools"] = "aiTools";
    FeatureCode["MetricAssistantAI"] = "metricAssistantAI";
    FeatureCode["DraftFurtherExplanationAI"] = "draftFurtherExplanationAI";
    FeatureCode["SDGInsightAI"] = "SDGInsightAI";
    /** @legacy DB value is 'PPTXReportAI' — keep the string to avoid migration */
    FeatureCode["AIEnhancedReports"] = "PPTXReportAI";
    FeatureCode["ScopePacks"] = "scopePacks";
    FeatureCode["RichTextEditor"] = "richTextEditor";
    FeatureCode["TargetActual"] = "targetActual";
    FeatureCode["AppIntegrations"] = "appIntegrations";
    FeatureCode["AppIntegrationGreenProject"] = "appIntegrationGreenProject";
    FeatureCode["AppIntegrationGreenly"] = "appIntegrationGreenly";
    FeatureCode["AppIntegrationUnravelCarbon"] = "appIntegrationUnravelCarbon";
    FeatureCode["AIAccessDocumentLibrary"] = "aiAccessDocumentLibrary";
    FeatureCode["AIAutoAnswer"] = "aiAutoAnswer";
    FeatureCode["AITextSummarization"] = "aiTextSummarization";
    FeatureCode["LimitMaterialityTrackerToStaffOnly"] = "limitMaterialityTrackerToStaffOnly";
    FeatureCode["Workgroups"] = "workgroups";
    FeatureCode["InsightsIntelligence"] = "insightsIntelligence";
    FeatureCode["DataIntegrations"] = "dataIntegrations";
    FeatureCode["AggregationOverrides"] = "aggregationOverrides";
    FeatureCode["ConnectedHistory"] = "connectedHistory";
    FeatureCode["NormalisedReport"] = "normalisedReport";
    FeatureCode["Gri2025Beta"] = "gri2025Beta";
})(FeatureCode || (FeatureCode = {}));
// Feature tags are attached to initiatives and link to a Feature code, plus config for behaviours
var FeatureTag;
(function (FeatureTag) {
    FeatureTag["AdminDashboard"] = "feature_adminDashboard";
    FeatureTag["Assurance"] = "feature_assurance";
    FeatureTag["BulkDelegation"] = "feature_bulkDelegation";
    FeatureTag["BulkImporting"] = "feature_bulkImporting";
    FeatureTag["CombinedReport"] = "feature_combinedReport";
    FeatureTag["CombinedSurvey"] = "feature_combinedSurvey";
    /** Lowest level possible **/
    FeatureTag["CustomMetricsXS"] = "feature_customMetricsXS";
    FeatureTag["CustomMetricsS"] = "feature_customMetricsS";
    FeatureTag["CustomMetricsM"] = "feature_customMetricsM";
    FeatureTag["CustomMetricsL"] = "feature_customMetricsL";
    FeatureTag["CustomMetricsXL"] = "feature_customMetricsXL";
    FeatureTag["CustomMetrics3"] = "feature_customMetrics3";
    FeatureTag["CustomMetrics5"] = "feature_customMetrics5";
    FeatureTag["CustomMetrics50"] = "feature_customMetrics50";
    FeatureTag["CustomMetrics200"] = "feature_customMetrics200";
    FeatureTag["CustomMetrics300"] = "feature_customMetrics300";
    FeatureTag["CustomMetrics400"] = "feature_customMetrics400";
    FeatureTag["CustomMetrics500"] = "feature_customMetrics500";
    FeatureTag["CustomMetrics600"] = "feature_customMetrics600";
    FeatureTag["CustomMetrics700"] = "feature_customMetrics700";
    FeatureTag["CustomMetrics800"] = "feature_customMetrics800";
    FeatureTag["CustomMetrics900"] = "feature_customMetrics900";
    // CustomMetricsUnlimited = 'feature_customMetricsUnlimited',
    FeatureTag["ReportingLevelsS"] = "feature_reportingLevelsS";
    FeatureTag["ReportingLevelsM"] = "feature_reportingLevelsM";
    FeatureTag["ReportingLevelsL"] = "feature_reportingLevelsL";
    FeatureTag["ReportingLevelsXL"] = "feature_reportingLevelsXL";
    FeatureTag["ReportingLevels3"] = "feature_reportingLevels3";
    FeatureTag["ReportingLevels5"] = "feature_reportingLevels5";
    FeatureTag["ReportingLevels25"] = "feature_reportingLevels25";
    FeatureTag["ReportingLevels50"] = "feature_reportingLevels50";
    FeatureTag["ReportingLevels200"] = "feature_reportingLevels200";
    FeatureTag["ReportingLevels300"] = "feature_reportingLevels300";
    FeatureTag["ReportingLevels400"] = "feature_reportingLevels400";
    FeatureTag["ReportingLevels500"] = "feature_reportingLevels500";
    FeatureTag["ReportingLevels600"] = "feature_reportingLevels600";
    FeatureTag["ReportingLevels700"] = "feature_reportingLevels700";
    FeatureTag["ReportingLevels800"] = "feature_reportingLevels800";
    FeatureTag["ReportingLevels900"] = "feature_reportingLevels900";
    // ReportingLevelsUnlimited = 'feature_reportingLevelsUnlimited',
    FeatureTag["SurveyTemplates"] = "feature_surveyTemplates";
    FeatureTag["UsersXS"] = "feature_usersXS";
    FeatureTag["UsersS"] = "feature_usersS";
    FeatureTag["UsersM"] = "feature_usersM";
    FeatureTag["UsersL"] = "feature_usersL";
    FeatureTag["UsersXL"] = "feature_usersXL";
    FeatureTag["Users3"] = "feature_users3";
    FeatureTag["Users10"] = "feature_users10";
    FeatureTag["Users50"] = "feature_users50";
    FeatureTag["Users200"] = "feature_users200";
    FeatureTag["Users300"] = "feature_users300";
    FeatureTag["Users400"] = "feature_users400";
    FeatureTag["Users500"] = "feature_users500";
    FeatureTag["Users600"] = "feature_users600";
    FeatureTag["Users700"] = "feature_users700";
    FeatureTag["Users800"] = "feature_users800";
    FeatureTag["Users900"] = "feature_users900";
    // UsersUnlimited = 'feature_usersUnlimited',
    FeatureTag["Verification"] = "feature_verification";
    FeatureTag["CustomDashboards"] = "feature_customDashboards";
    FeatureTag["NoteInstructions"] = "feature_noteInstructions";
    /** @deprecated */
    FeatureTag["AITools"] = "feature_aiTools";
    FeatureTag["MetricAssistantAI"] = "feature_metricAssistantAI";
    FeatureTag["DraftFurtherExplanationAI"] = "feature_draftFurtherExplanationAI";
    FeatureTag["SDGInsightAI"] = "feature_SDGInsightAI";
    /** @legacy DB value is 'feature_PPTXReportAI' — keep the string to avoid migration */
    FeatureTag["AIEnhancedReports"] = "feature_PPTXReportAI";
    /** Restricted version tailored to starter pack **/
    FeatureTag["ScopePacksStarter"] = "feature_scopePacksStarter";
    // Default for all variations
    FeatureTag["ScopePacksBasic"] = "feature_scopePacksBasic";
    FeatureTag["RichTextEditor"] = "feature_richTextEditor";
    FeatureTag["TargetActual"] = "feature_targetActual";
    FeatureTag["AppIntegrations"] = "feature_appIntegrations";
    FeatureTag["AppIntegrationGreenProject"] = "feature_appIntegrationGreenProject";
    FeatureTag["AppIntegrationGreenly"] = "feature_appIntegrationGreenly";
    FeatureTag["AppIntegrationUnravelCarbon"] = "feature_appIntegrationUnravelCarbon";
    FeatureTag["AIAccessDocumentLibrary"] = "feature_aiAccessDocumentLibrary";
    FeatureTag["AIAutoAnswer"] = "feature_aiAutoAnswer";
    FeatureTag["AITextSummarization"] = "feature_aiTextSummarization";
    FeatureTag["InsightsIntelligence"] = "feature_insightsIntelligence";
    FeatureTag["DataIntegrations"] = "feature_dataIntegrations";
    FeatureTag["LimitMaterialityTrackerToStaffOnly"] = "feature_limitMaterialityTrackerToStaffOnly";
    FeatureTag["AggregationOverrides"] = "feature_aggregationOverrides";
    FeatureTag["ConnectedHistory"] = "feature_connectedHistory";
    FeatureTag["Workgroups0"] = "feature_workgroups0";
    FeatureTag["Workgroups1"] = "feature_workgroups1";
    FeatureTag["Workgroups3"] = "feature_workgroups3";
    FeatureTag["Workgroups5"] = "feature_workgroups5";
    FeatureTag["Workgroups10"] = "feature_workgroups10";
    FeatureTag["Workgroups25"] = "feature_workgroups25";
    FeatureTag["Workgroups50"] = "feature_workgroups50";
    FeatureTag["Workgroups100"] = "feature_workgroups100";
    FeatureTag["Workgroups200"] = "feature_workgroups200";
    FeatureTag["Workgroups300"] = "feature_workgroups300";
    FeatureTag["Workgroups400"] = "feature_workgroups400";
    FeatureTag["Workgroups500"] = "feature_workgroups500";
    FeatureTag["Workgroups600"] = "feature_workgroups600";
    FeatureTag["Workgroups700"] = "feature_workgroups700";
    FeatureTag["Workgroups800"] = "feature_workgroups800";
    FeatureTag["Workgroups900"] = "feature_workgroups900";
    FeatureTag["Workgroups999"] = "feature_workgroups999";
    FeatureTag["NormalisedReport"] = "feature_normalisedReport";
    FeatureTag["Gri2025Beta"] = "feature_gri2025Beta";
})(FeatureTag || (FeatureTag = {}));
const Features = {
    [FeatureTag.AdminDashboard]: {
        name: 'Admin Dashboard',
        code: FeatureCode.AdminDashboard,
        active: true,
    },
    [FeatureTag.Assurance]: {
        name: 'Assurance',
        code: FeatureCode.Assurance,
        active: true,
    },
    [FeatureTag.BulkDelegation]: {
        name: 'Bulk Delegation',
        code: FeatureCode.BulkDelegation,
        active: true,
    },
    [FeatureTag.BulkImporting]: {
        name: 'Bulk Importing',
        code: FeatureCode.BulkImporting,
        active: true,
    },
    [FeatureTag.CombinedReport]: {
        name: 'Combined Reports',
        code: FeatureCode.CombinedReport,
        active: true,
    },
    [FeatureTag.CombinedSurvey]: {
        name: 'Combined Surveys',
        code: FeatureCode.CombinedSurvey,
        active: true,
    },
    [FeatureTag.CustomMetricsXS]: {
        name: 'Custom Metrics - Extra Small (Limit 1)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 1,
        },
    },
    [FeatureTag.CustomMetrics3]: {
        name: 'Custom Metrics - (Limit 3)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 3,
        },
    },
    [FeatureTag.CustomMetrics5]: {
        name: 'Custom Metrics - (Limit 5)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 5,
        },
    },
    [FeatureTag.CustomMetricsS]: {
        name: 'Custom Metrics - Small (Limit 10)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 10,
        },
    },
    [FeatureTag.CustomMetricsM]: {
        name: 'Custom Metrics - Medium (Limit 25)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 25,
        },
    },
    [FeatureTag.CustomMetrics50]: {
        name: 'Custom Metrics - (Limit 50)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 50,
        },
    },
    [FeatureTag.CustomMetricsL]: {
        name: 'Custom Metrics - Large (Limit 100)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 100,
        },
    },
    [FeatureTag.CustomMetrics200]: {
        name: 'Custom Metrics - (Limit 200)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 200,
        },
    },
    [FeatureTag.CustomMetrics300]: {
        name: 'Custom Metrics - (Limit 300)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 300,
        },
    },
    [FeatureTag.CustomMetrics400]: {
        name: 'Custom Metrics - (Limit 400)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 400,
        },
    },
    [FeatureTag.CustomMetrics500]: {
        name: 'Custom Metrics - (Limit 500)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 500,
        },
    },
    [FeatureTag.CustomMetrics600]: {
        name: 'Custom Metrics - (Limit 600)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 600,
        },
    },
    [FeatureTag.CustomMetrics700]: {
        name: 'Custom Metrics - (Limit 700)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 700,
        },
    },
    [FeatureTag.CustomMetrics800]: {
        name: 'Custom Metrics - (Limit 800)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 800,
        },
    },
    [FeatureTag.CustomMetrics900]: {
        name: 'Custom Metrics - (Limit 900)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 900,
        },
    },
    [FeatureTag.CustomMetricsXL]: {
        name: 'Custom Metrics - X Large (Limit 999)',
        code: FeatureCode.CustomMetrics,
        active: true,
        config: {
            limit: 999,
        },
    },
    [FeatureTag.ReportingLevelsS]: {
        name: 'Reporting Levels - Small (Limit 1)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 1,
        },
    },
    [FeatureTag.ReportingLevels3]: {
        name: 'Reporting Levels - (Limit 3)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 3,
        },
    },
    [FeatureTag.ReportingLevels5]: {
        name: 'Reporting Levels - (Limit 5)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 5,
        },
    },
    [FeatureTag.ReportingLevelsM]: {
        name: 'Reporting Levels - Medium (Limit 10)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 10,
        },
    },
    [FeatureTag.ReportingLevels25]: {
        name: 'Reporting Levels - (Limit 25)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 25,
        },
    },
    [FeatureTag.ReportingLevels50]: {
        name: 'Reporting Levels - (Limit 50)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 50,
        },
    },
    [FeatureTag.ReportingLevelsL]: {
        name: 'Reporting Levels - Large (Limit 100)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 100,
        },
    },
    [FeatureTag.ReportingLevels200]: {
        name: 'Reporting Levels - (Limit 200)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 200,
        },
    },
    [FeatureTag.ReportingLevels300]: {
        name: 'Reporting Levels - (Limit 300)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 300,
        },
    },
    [FeatureTag.ReportingLevels400]: {
        name: 'Reporting Levels - (Limit 400)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 400,
        },
    },
    [FeatureTag.ReportingLevels500]: {
        name: 'Reporting Levels - (Limit 500)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 500,
        },
    },
    [FeatureTag.ReportingLevels600]: {
        name: 'Reporting Levels - (Limit 600)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 600,
        },
    },
    [FeatureTag.ReportingLevels700]: {
        name: 'Reporting Levels - (Limit 700)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 700,
        },
    },
    [FeatureTag.ReportingLevels800]: {
        name: 'Reporting Levels - (Limit 800)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 800,
        },
    },
    [FeatureTag.ReportingLevels900]: {
        name: 'Reporting Levels - (Limit 900)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 900,
        },
    },
    [FeatureTag.ReportingLevelsXL]: {
        name: 'Reporting Levels - X Large (Limit 999)',
        code: FeatureCode.ReportingLevels,
        active: true,
        config: {
            limit: 999,
        },
    },
    [FeatureTag.SurveyTemplates]: {
        name: 'Survey Templates',
        code: FeatureCode.SurveyTemplates,
        active: true,
    },
    [FeatureTag.UsersXS]: {
        name: 'Users - Extra Small (Limit 1)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 1,
        },
    },
    [FeatureTag.Users3]: {
        name: 'Users - (Limit 3)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 3,
        },
    },
    [FeatureTag.UsersS]: {
        name: 'Users - Small (Limit 5)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 5,
        },
    },
    [FeatureTag.Users10]: {
        name: 'Users - (Limit 10)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 10,
        },
    },
    [FeatureTag.UsersM]: {
        name: 'Users - Medium (Limit 25)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 25,
        },
    },
    [FeatureTag.Users50]: {
        name: 'Users - (Limit 50)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 50,
        },
    },
    [FeatureTag.UsersL]: {
        name: 'Users - Large (Limit 100)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 100,
        },
    },
    [FeatureTag.Users200]: {
        name: 'Users - (Limit 200)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 200,
        },
    },
    [FeatureTag.Users300]: {
        name: 'Users - (Limit 300)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 300,
        },
    },
    [FeatureTag.Users400]: {
        name: 'Users - (Limit 400)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 400,
        },
    },
    [FeatureTag.Users500]: {
        name: 'Users - (Limit 500)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 500,
        },
    },
    [FeatureTag.Users600]: {
        name: 'Users - (Limit 600)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 600,
        },
    },
    [FeatureTag.Users700]: {
        name: 'Users - (Limit 700)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 700,
        },
    },
    [FeatureTag.Users800]: {
        name: 'Users - (Limit 800)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 800,
        },
    },
    [FeatureTag.Users900]: {
        name: 'Users - (Limit 900)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 900,
        },
    },
    [FeatureTag.UsersXL]: {
        name: 'Users - X Large (Limit 999)',
        code: FeatureCode.Users,
        active: true,
        config: {
            limit: 999,
        },
    },
    [FeatureTag.Verification]: {
        name: 'Verification',
        code: FeatureCode.Verification,
        active: true,
    },
    [FeatureTag.CustomDashboards]: {
        name: 'Custom Dashboards',
        code: FeatureCode.CustomDashboards,
        active: true,
    },
    [FeatureTag.NoteInstructions]: {
        name: 'Note Instructions',
        code: FeatureCode.NoteInstructions,
        active: true,
    },
    [FeatureTag.AITools]: {
        name: 'AI Tools',
        code: FeatureCode.AITools,
        active: true,
    },
    [FeatureTag.MetricAssistantAI]: {
        name: 'AI Metric Assistant',
        code: FeatureCode.MetricAssistantAI,
        active: true,
    },
    [FeatureTag.DraftFurtherExplanationAI]: {
        name: 'AI Draft Further Explanation',
        code: FeatureCode.DraftFurtherExplanationAI,
        active: true,
    },
    [FeatureTag.SDGInsightAI]: {
        name: 'AI SDG Insights',
        code: FeatureCode.SDGInsightAI,
        active: true,
    },
    [FeatureTag.AIEnhancedReports]: {
        name: 'AI enhanced reports',
        code: FeatureCode.AIEnhancedReports,
        active: true,
    },
    [FeatureTag.ScopePacksStarter]: {
        name: 'Scope Modules Starter',
        code: FeatureCode.ScopePacks,
        active: true,
        config: {
            scopePacks: {
                access: 'custom',
                scope: {
                    standards: ['gri2021'],
                    frameworks: ['esg30'],
                },
                restricted: true,
            },
        },
    },
    [FeatureTag.ScopePacksBasic]: {
        name: 'Scope Modules Basic',
        code: FeatureCode.ScopePacks,
        active: true,
        config: {
            scopePacks: {
                access: 'basic',
            },
        },
    },
    [FeatureTag.RichTextEditor]: {
        name: 'Rich Text Editor',
        code: FeatureCode.RichTextEditor,
        active: true,
    },
    [FeatureTag.TargetActual]: {
        name: 'Target Actual (Disabled)',
        code: FeatureCode.TargetActual,
        active: true,
        disabled: true,
    },
    [FeatureTag.AIAccessDocumentLibrary]: {
        name: 'Data input: AI access to Document Library',
        code: FeatureCode.AIAccessDocumentLibrary,
        active: true,
    },
    [FeatureTag.AIAutoAnswer]: {
        name: 'Data input: Auto Answer button',
        code: FeatureCode.AIAutoAnswer,
        active: true,
    },
    [FeatureTag.InsightsIntelligence]: {
        name: 'Insights Intelligence',
        code: FeatureCode.InsightsIntelligence,
        active: true,
    },
    [FeatureTag.DataIntegrations]: {
        name: 'Data Integrations',
        code: FeatureCode.DataIntegrations,
        active: true,
    },
    [FeatureTag.AppIntegrations]: {
        name: 'App Integrations (legacy)',
        code: FeatureCode.AppIntegrations,
        active: true,
    },
    [FeatureTag.AppIntegrationGreenProject]: {
        name: 'App Integration — Green Project',
        code: FeatureCode.AppIntegrationGreenProject,
        active: true,
    },
    [FeatureTag.AppIntegrationGreenly]: {
        name: 'App Integration — Greenly',
        code: FeatureCode.AppIntegrationGreenly,
        active: true,
    },
    [FeatureTag.AppIntegrationUnravelCarbon]: {
        name: 'App Integration — Unravel Carbon',
        code: FeatureCode.AppIntegrationUnravelCarbon,
        active: true,
    },
    [FeatureTag.AITextSummarization]: {
        name: 'Aggregation: AI-powered text summarization',
        code: FeatureCode.AITextSummarization,
        active: true,
    },
    [FeatureTag.LimitMaterialityTrackerToStaffOnly]: {
        name: 'Limit Materiality Tracker to Staff Only',
        code: FeatureCode.LimitMaterialityTrackerToStaffOnly,
        active: true,
    },
    [FeatureTag.AggregationOverrides]: {
        name: 'Aggregation Overrides',
        code: FeatureCode.AggregationOverrides,
        active: true,
    },
    [FeatureTag.ConnectedHistory]: {
        name: 'Connected history (beta)',
        code: FeatureCode.ConnectedHistory,
        active: true,
    },
    [FeatureTag.Workgroups0]: {
        name: 'Workgroups - (Limit 0)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 0,
        },
    },
    [FeatureTag.Workgroups1]: {
        name: 'Workgroups - (Limit 1)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 1,
        },
    },
    [FeatureTag.Workgroups3]: {
        name: 'Workgroups - (Limit 3)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 3,
        },
    },
    [FeatureTag.Workgroups5]: {
        name: 'Workgroups - (Limit 5)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 5,
        },
    },
    [FeatureTag.Workgroups10]: {
        name: 'Workgroups - (Limit 10)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 10,
        },
    },
    [FeatureTag.Workgroups25]: {
        name: 'Workgroups - (Limit 25)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 25,
        },
    },
    [FeatureTag.Workgroups50]: {
        name: 'Workgroups - (Limit 50)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 50,
        },
    },
    [FeatureTag.Workgroups100]: {
        name: 'Workgroups - (Limit 100)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 100,
        },
    },
    [FeatureTag.Workgroups200]: {
        name: 'Workgroups - (Limit 200)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 200,
        },
    },
    [FeatureTag.Workgroups300]: {
        name: 'Workgroups - (Limit 300)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 300,
        },
    },
    [FeatureTag.Workgroups400]: {
        name: 'Workgroups - (Limit 400)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 400,
        },
    },
    [FeatureTag.Workgroups500]: {
        name: 'Workgroups - (Limit 500)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 500,
        },
    },
    [FeatureTag.Workgroups600]: {
        name: 'Workgroups - (Limit 600)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 600,
        },
    },
    [FeatureTag.Workgroups700]: {
        name: 'Workgroups - (Limit 700)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 700,
        },
    },
    [FeatureTag.Workgroups800]: {
        name: 'Workgroups - (Limit 800)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 800,
        },
    },
    [FeatureTag.Workgroups900]: {
        name: 'Workgroups - (Limit 900)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 900,
        },
    },
    [FeatureTag.Workgroups999]: {
        name: 'Workgroups - (Limit 999)',
        code: FeatureCode.Workgroups,
        active: true,
        config: {
            limit: 999,
        },
    },
    [FeatureTag.NormalisedReport]: {
        name: 'Normalised Custom Report (beta)',
        code: FeatureCode.NormalisedReport,
        active: true,
    },
    [FeatureTag.Gri2025Beta]: {
        name: 'GRI 2025 standard (beta)',
        code: FeatureCode.Gri2025Beta,
        active: true,
    },
};
const getFeatureDetails = (tag) => {
    return Features[tag];
};

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$o = config.imagePath;
const griGroup = [
    {
        code: 'gri-1',
        name: 'GRI 100: Universal Standards',
        officialCode: '1',
        colour: '335377',
        src: `${imagePath$o}/gri100.png`,
        subgroups: [
            {
                code: 'gri-1-102',
                name: 'GRI 102: General Disclosure',
                officialCode: '102',
                description: 'General Disclosures sets out reporting requirements on contextual information about an organization and its sustainability reporting practices. This Standard can be used by an organization of any size, type, sector or geographic location.',
            },
            {
                code: 'gri-1-103',
                name: 'GRI 103: Management Approach',
                officialCode: '103',
                description: 'Management Approach sets out reporting requirements about the approach an organization uses to manage a material topic. This Standard can be used by an organization of any size, type, sector or geographic location.',
            }
        ]
    },
    {
        code: 'gri-2',
        name: 'GRI 200: Economic',
        colour: '72327c',
        officialCode: '2',
        src: `${imagePath$o}/gri200.png`,
        subgroups: [
            {
                code: 'gri-2-201',
                name: 'GRI 201: Economic Performance',
                officialCode: '201',
                description: 'Economic Performance sets out reporting requirements on the topic of economic performance. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topi.',
            },
            {
                code: 'gri-2-202',
                name: 'GRI 202: Market Presence',
                officialCode: '202',
                description: 'Market Presence sets out reporting requirements on the topic of market presence. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-2-203',
                name: 'GRI 203: Indirect Economic Impacts',
                officialCode: '203',
                description: ' Indirect Economic Impacts sets out reporting requirements on the topic of indirect economic impacts. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-2-204',
                name: 'GRI 204: Procurement Practices',
                officialCode: '204',
                description: 'Procurement Practices sets out reporting requirements on the topic of procurement practices. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-2-205',
                name: 'GRI 205: Anti-corruption',
                officialCode: '205',
                description: 'Anti-corruption sets out reporting requirements on the topic of anti-corruption. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-2-206',
                name: 'GRI 206: Anti-competitive Behavior',
                officialCode: '206',
                description: 'Anti-competitive Behavior sets out reporting requirements on the topic of anti-competitive behavior. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-2-207',
                name: 'GRI 207: Tax',
                officialCode: '207',
                description: 'Tax sets out reporting requirements on the topic of tax. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            }
        ]
    },
    {
        code: 'gri-3',
        name: 'GRI 300: Environmental',
        colour: '17956d',
        officialCode: '3',
        src: `${imagePath$o}/gri300.png`,
        subgroups: [
            {
                code: 'gri-3-301',
                name: 'GRI 301: Materials',
                officialCode: '301',
                description: 'Materials sets out reporting requirements on the topic of materials. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-302',
                name: 'GRI 302: Energy',
                officialCode: '302',
                description: 'Energy sets out reporting requirements on the topic of energy. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-303',
                name: 'GRI 303: Water and Effluents',
                officialCode: '303',
                description: 'Water and Effluents sets out reporting requirements on the topic of water and effluents. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-304',
                name: 'GRI 304: Biodiversity',
                officialCode: '304',
                description: 'Biodiversity sets out reporting requirements on the topic of biodiversity. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-305',
                name: 'GRI 305: Emissions',
                officialCode: '305',
                description: 'Emissions sets out reporting requirements on the topic of emissions. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topi.',
            },
            {
                code: 'gri-3-306',
                name: 'GRI 306: Waste',
                officialCode: '306',
                description: 'Waste 2020 sets out reporting requirements on the topic of waste. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-307',
                name: 'GRI 307: Environmental Compliance',
                officialCode: '307',
                description: 'Environmental Compliance sets out reporting requirements on the topic of environmental compliance. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-3-308',
                name: 'GRI 308: Supplier Environmental Assessment',
                officialCode: '308',
                description: 'Supplier Environmental Assessment sets out reporting requirements on the topic of supplier environmental assessment. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            }
        ]
    },
    {
        code: 'gri-4',
        name: 'GRI 400: Social',
        colour: 'fa6a01',
        officialCode: '4',
        src: `${imagePath$o}/gri400.png`,
        subgroups: [
            {
                code: 'gri-4-401',
                name: 'GRI 401: Employment',
                officialCode: '401',
                description: 'Employment sets out reporting requirements on the topic of employment. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-402',
                name: 'GRI 402: Labor/Management Relations',
                officialCode: '402',
                description: ' Labor/Management Relations sets out reporting requirements on the topic of labor/management relations. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-403',
                name: 'GRI 403: Occupational Health and Safety',
                officialCode: '403',
                description: 'Occupational Health and Safety sets out reporting requirements on the topic of occupational health and safety. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-404',
                name: 'GRI 404: Training and Education',
                officialCode: '404',
                description: 'Training and Education sets out reporting requirements on the topic of training and education. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-405',
                name: 'GRI 405: Diversity and Equal Opportunity',
                officialCode: '405',
                description: 'Diversity and Equal Opportunity sets out reporting requirements on the topic of diversity and equal opportunity. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic',
            },
            {
                code: 'gri-4-406',
                name: 'GRI 406: Non-discrimination',
                officialCode: '406',
                description: 'Non-discrimination sets out reporting requirements on the topic of nondiscrimination. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-407',
                name: 'GRI 407: Freedom of Association and Collective Bargaining',
                officialCode: '407',
                description: 'Freedom of Association and Collective Bargaining sets out reporting requirements on the topic of freedom of association and collective bargaining. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-408',
                name: 'GRI 408: Child Labor',
                officialCode: '408',
                description: 'Child Labor sets out reporting requirements on the topic of child labor. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-409',
                name: 'GRI 409: Forced or Compulsory Labor',
                officialCode: '409',
                description: 'Forced or Compulsory Labor sets out reporting requirements on the topic of forced or compulsory labor. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-410',
                name: 'GRI 410: Security Practices',
                officialCode: '410',
                description: 'Security Practices sets out reporting requirements on the topic of security practices. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-411',
                name: 'GRI 411: Rights of Indigenous Peoples',
                officialCode: '411',
                description: 'Rights of Indigenous Peoples sets out reporting requirements on the topic of rights of indigenous peoples. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-412',
                name: 'GRI 412: Human Rights Assessment',
                officialCode: '412',
                description: 'Human Rights Assessment sets out reporting requirements on the topic of human rights assessment. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-413',
                name: 'GRI 413: Local Communities',
                officialCode: '413',
                description: 'Local Communities sets out reporting requirements on the topic of local communities. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-414',
                name: 'GRI 414: Supplier Social Assessment',
                officialCode: '414',
                description: 'Supplier Social Assessment sets out reporting requirements on the topic of supplier social assessment. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-415',
                name: 'GRI 415: Public Policy',
                officialCode: '415',
                description: 'Public Policy sets out reporting requirements on the topic of public policy. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-416',
                name: 'GRI 416: Customer Health and Safety',
                officialCode: '416',
                description: 'Customer Health and Safety sets out reporting requirements on the topic of customer health and safety. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-417',
                name: 'GRI 417: Marketing and Labeling',
                officialCode: '417',
                description: 'Marketing and Labeling sets out reporting requirements on the topic of marketing and labeling. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-418',
                name: 'GRI 418: Customer Privacy',
                officialCode: '418',
                description: 'Customer Privacy sets out reporting requirements on the topic of customer privacy. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic.',
            },
            {
                code: 'gri-4-419',
                name: 'GRI 419: Socioeconomic Compliance',
                officialCode: '419',
                description: 'Socioeconomic Compliance sets out reporting requirements on the topic of socioeconomic compliance. This Standard can be used by an organization of any size, type, sector or geographic location that wants to report on its impacts related to this topic',
            }
        ]
    }
];
const getGriGroup = (code) => {
    return griGroup.find(g => g.code === code[0]);
};

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
// Converted from json, keep quotes.
const allSasbGroups = [
    {
        "code": "sasb-cg",
        "name": "Consumer Goods",
        "officialCode": "CG",
        "subgroups": [
            {
                "code": "sasb-cg-aa",
                "name": "Apparel, Accessories & Footwear",
                "officialCode": "CG-AA"
            },
            {
                "code": "sasb-cg-am",
                "name": "Appliance Manufacturing",
                "officialCode": "CG-AM"
            },
            {
                "code": "sasb-cg-bf",
                "name": "Building Products & Furnishings",
                "officialCode": "CG-BF"
            },
            {
                "code": "sasb-cg-hp",
                "name": "Household & Personal Products",
                "officialCode": "CG-HP"
            },
            {
                "code": "sasb-cg-ts",
                "name": "Toys & Sporting Goods",
                "officialCode": "CG-TS"
            },
            {
                "code": "sasb-cg-mr",
                "name": "Multiline and Specialty Retailers & Distributors",
                "officialCode": "CG-MR"
            },
            {
                "code": "sasb-cg-ec",
                "name": "E-commerce",
                "officialCode": "CG-EC"
            }
        ]
    },
    {
        "code": "sasb-em",
        "name": "Extractives & Minerals Processing",
        "officialCode": "EM",
        "subgroups": [
            {
                "code": "sasb-em-co",
                "name": "Coal Operations",
                "officialCode": "EM-CO"
            },
            {
                "code": "sasb-em-cm",
                "name": "Construction Materials",
                "officialCode": "EM-CM"
            },
            {
                "code": "sasb-em-is",
                "name": "Iron & Steel Producers",
                "officialCode": "EM-IS"
            },
            {
                "code": "sasb-em-mm",
                "name": "Metals & Mining",
                "officialCode": "EM-MM"
            },
            {
                "code": "sasb-em-ep",
                "name": "Oil & Gas - Exploration & Production",
                "officialCode": "EM-EP"
            },
            {
                "code": "sasb-em-md",
                "name": "Oil & Gas - Midstream",
                "officialCode": "EM-MD"
            },
            {
                "code": "sasb-em-rm",
                "name": "Oil & Gas - Refining & Marketing",
                "officialCode": "EM-RM"
            },
            {
                "code": "sasb-em-sv",
                "name": "Oil & Gas - Services",
                "officialCode": "EM-SV"
            }
        ]
    },
    {
        "code": "sasb-fn",
        "name": "Financials",
        "officialCode": "FN",
        "subgroups": [
            {
                "code": "sasb-fn-ac",
                "name": "Asset Management & Custody Activities",
                "officialCode": "FN-AC"
            },
            {
                "code": "sasb-fn-ib",
                "name": "Investment Banking & Brokerage",
                "officialCode": "FN-IB"
            },
            {
                "code": "sasb-fn-ex",
                "name": "Security & Commodity Exchanges",
                "officialCode": "FN-EX"
            },
            {
                "code": "sasb-fn-cb",
                "name": "Commercial Banks",
                "officialCode": "FN-CB"
            },
            {
                "code": "sasb-fn-cf",
                "name": "Consumer Finance",
                "officialCode": "FN-CF"
            },
            {
                "code": "sasb-fn-mf",
                "name": "Mortgage Finance",
                "officialCode": "FN-MF"
            },
            {
                "code": "sasb-fn-in",
                "name": "Insurance",
                "officialCode": "FN-IN"
            }
        ]
    },
    {
        "code": "sasb-fb",
        "name": "Food & Beverage",
        "officialCode": "FB",
        "subgroups": [
            {
                "code": "sasb-fb-ag",
                "name": "Agricultural Products",
                "officialCode": "FB-AG"
            },
            {
                "code": "sasb-fb-mp",
                "name": "Meat, Poultry & Dairy",
                "officialCode": "FB-MP"
            },
            {
                "code": "sasb-fb-pf",
                "name": "Processed Foods",
                "officialCode": "FB-PF"
            },
            {
                "code": "sasb-fb-ab",
                "name": "Alcoholic Beverages",
                "officialCode": "FB-AB"
            },
            {
                "code": "sasb-fb-nb",
                "name": "Non-Alcoholic Beverages",
                "officialCode": "FB-NB"
            },
            {
                "code": "sasb-fb-fr",
                "name": "Food Retailers & Distributors",
                "officialCode": "FB-FR"
            },
            {
                "code": "sasb-fb-rn",
                "name": "Restaurants",
                "officialCode": "FB-RN"
            },
            {
                "code": "sasb-fb-tb",
                "name": "Tobacco",
                "officialCode": "FB-TB"
            }
        ]
    },
    {
        "code": "sasb-hc",
        "name": "Healthcare",
        "officialCode": "HC",
        "colour": "82236f",
        "subgroups": [
            {
                "code": "sasb-hc-bp",
                "name": "Biotechnology & Pharmaceuticals",
                "officialCode": "HC-BP"
            },
            {
                "code": "sasb-hc-dr",
                "name": "Drug Retailers",
                "officialCode": "HC-DR"
            },
            {
                "code": "sasb-hc-dy",
                "name": "Health Care Delivery",
                "officialCode": "HC-DY"
            },
            {
                "code": "sasb-hc-di",
                "name": "Health Care Distributors",
                "officialCode": "HC-DI"
            },
            {
                "code": "sasb-hc-mc",
                "name": "Managed Care",
                "officialCode": "HC-MC"
            },
            {
                "code": "sasb-hc-ms",
                "name": "Medical Equipment & Supplies",
                "officialCode": "HC-MS"
            }
        ]
    },
    {
        "code": "sasb-if",
        "name": "Infrastructure",
        "officialCode": "IF",
        "subgroups": [
            {
                "code": "sasb-if-eu",
                "name": "Electric Utilities & Power Generators",
                "officialCode": "IF-EU"
            },
            {
                "code": "sasb-if-gu",
                "name": "Gas Utilities & Distributors",
                "officialCode": "IF-GU"
            },
            {
                "code": "sasb-if-wu",
                "name": "Water Utilities & Services",
                "officialCode": "IF-WU"
            },
            {
                "code": "sasb-if-en",
                "name": "Engineering & Construction Services",
                "officialCode": "IF-EN"
            },
            {
                "code": "sasb-if-hb",
                "name": "Home Builders",
                "officialCode": "IF-HB"
            },
            {
                "code": "sasb-if-re",
                "name": "Real Estate",
                "officialCode": "IF-RE"
            },
            {
                "code": "sasb-if-rs",
                "name": "Real Estate Services",
                "officialCode": "IF-RS"
            },
            {
                "code": "sasb-if-wm",
                "name": "Waste Management",
                "officialCode": "IF-WM"
            }
        ]
    },
    {
        "code": "sasb-rr",
        "name": "Renewable Resources & Alternative Energy",
        "officialCode": "RR",
        "subgroups": [
            {
                "code": "sasb-rr-bi",
                "name": "Biofuels",
                "officialCode": "RR-BI"
            },
            {
                "code": "sasb-rr-fc",
                "name": "Fuel Cells & Industrial Batteries",
                "officialCode": "RR-FC"
            },
            {
                "code": "sasb-rr-st",
                "name": "Solar Technology & Project Developers",
                "officialCode": "RR-ST"
            },
            {
                "code": "sasb-rr-wt",
                "name": "Wind Technology & Project Developers",
                "officialCode": "RR-WT"
            },
            {
                "code": "sasb-rr-fm",
                "name": "Forestry Management",
                "officialCode": "RR-FM"
            },
            {
                "code": "sasb-rr-pp",
                "name": "Pulp & Paper Products",
                "officialCode": "RR-PP"
            }
        ]
    },
    {
        "code": "sasb-rt",
        "name": "Resource Transformation",
        "officialCode": "RT",
        "subgroups": [
            {
                "code": "sasb-rt-ae",
                "name": "Aerospace & Defense",
                "officialCode": "RT-AE"
            },
            {
                "code": "sasb-rt-cp",
                "name": "Containers & Packaging",
                "officialCode": "RT-CP"
            },
            {
                "code": "sasb-rt-ee",
                "name": "Electrical & Electronic Equipment",
                "officialCode": "RT-EE"
            },
            {
                "code": "sasb-rt-ig",
                "name": "Industrial Machinery & Goods",
                "officialCode": "RT-IG"
            },
            {
                "code": "sasb-rt-ch",
                "name": "Chemicals",
                "officialCode": "RT-CH"
            }
        ]
    },
    {
        "code": "sasb-sv",
        "name": "Services",
        "officialCode": "SV",
        "subgroups": [
            {
                "code": "sasb-sv-ad",
                "name": "Advertising & Marketing",
                "officialCode": "SV-AD"
            },
            {
                "code": "sasb-sv-me",
                "name": "Media & Entertainment",
                "officialCode": "SV-ME"
            },
            {
                "code": "sasb-sv-ca",
                "name": "Casinos & Gaming",
                "officialCode": "SV-CA"
            },
            {
                "code": "sasb-sv-hl",
                "name": "Hotels & Lodging",
                "officialCode": "SV-HL"
            },
            {
                "code": "sasb-sv-lf",
                "name": "Leisure Facilities",
                "officialCode": "SV-LF"
            },
            {
                "code": "sasb-sv-ed",
                "name": "Education",
                "officialCode": "SV-ED"
            },
            {
                "code": "sasb-sv-ps",
                "name": "Professional & Commercial Services",
                "officialCode": "SV-PS"
            }
        ]
    },
    {
        "code": "sasb-tc",
        "name": "Technology & Communications",
        "officialCode": "TC",
        "subgroups": [
            {
                "code": "sasb-tc-es",
                "name": "Electronic Manufacturing Services & Original Design Manufacturing",
                "officialCode": "TC-ES"
            },
            {
                "code": "sasb-tc-hw",
                "name": "Hardware",
                "officialCode": "TC-HW"
            },
            {
                "code": "sasb-tc-si",
                "name": "Software & IT Services",
                "officialCode": "TC-SI"
            },
            {
                "code": "sasb-tc-im",
                "name": "Internet Media & Services",
                "officialCode": "TC-IM"
            },
            {
                "code": "sasb-tc-sc",
                "name": "Semiconductors",
                "officialCode": "TC-SC"
            },
            {
                "code": "sasb-tc-tl",
                "name": "Telecommunication Services",
                "officialCode": "TC-TL"
            }
        ]
    },
    {
        "code": "sasb-tr",
        "name": "Transportation",
        "officialCode": "TR",
        "subgroups": [
            {
                "code": "sasb-tr-al",
                "name": "Airlines",
                "officialCode": "TR-AL"
            },
            {
                "code": "sasb-tr-af",
                "name": "Air Freight & Logistics",
                "officialCode": "TR-AF"
            },
            {
                "code": "sasb-tr-au",
                "name": "Automobiles",
                "officialCode": "TR-AU"
            },
            {
                "code": "sasb-tr-ap",
                "name": "Auto Parts",
                "officialCode": "TR-AP"
            },
            {
                "code": "sasb-tr-cr",
                "name": "Car Rental & Leasing",
                "officialCode": "TR-CR"
            },
            {
                "code": "sasb-tr-cl",
                "name": "Cruise Lines",
                "officialCode": "TR-CL"
            },
            {
                "code": "sasb-tr-mt",
                "name": "Marine Transportation",
                "officialCode": "TR-MT"
            },
            {
                "code": "sasb-tr-ra",
                "name": "Rail Transportation",
                "officialCode": "TR-RA"
            },
            {
                "code": "sasb-tr-ro",
                "name": "Road Transportation",
                "officialCode": "TR-RO"
            }
        ]
    }
];
const sasbGroup = allSasbGroups;

const imagePath$n = config.imagePath;
const rspoGroup = [
    {
        code: 'rspo-1',
        name: 'Principle 1: Behave Ethically and Transparently',
        officialCode: '1',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-1-1.1',
                name: '1.1',
                officialCode: '1.1',
                description: 'The unit of certification provides adequate information to relevant stakeholders on environmental, social and legal issues relevant to RSPO Criteria, in appropriate languanges and forms to allow for efffective participation in decision making.',
            },
            {
                code: 'rspo-1-1.2',
                name: '1.2',
                officialCode: '1.2',
                description: 'The unit of certification commits to ethical conduct in all business operations and transactions.',
            }
        ]
    },
    {
        code: 'rspo-2',
        name: 'Principle 2: Operate legally and respect rights - Implement legal requirements as the basic principles of operation in any jurisdiction.',
        officialCode: '2',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-2-2.1',
                name: '2.1',
                officialCode: '2.1',
                description: 'There is compliance with all applicable local, national and ratified international laws and regulations.',
            },
            {
                code: 'rspo-2-2.2',
                name: '2.2',
                officialCode: '2.2',
                description: 'All contractors providing operational services and supplying labour, and Fresh Fruit Bunch (FFB) suppliers, comply with legal requirements.',
            },
            {
                code: 'rspo-2-2.3',
                name: '2.3',
                officialCode: '2.3',
                description: 'All FFB supplies from outside the unit of certification are from legal sources.',
            }
        ]
    },
    {
        code: 'rspo-3',
        name: 'Principle 3: Optimise productivity, efficiency, positive impacts and resilience',
        officialCode: '3',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-3-3.1',
                name: '3.1',
                officialCode: '3.1',
                description: 'There is an implemented management plan for the unit of certification that aims to achieve longterm economic and financial viability. ',
            },
            {
                code: 'rspo-3-3.2',
                name: '3.2',
                officialCode: '3.2',
                description: 'The unit of certification regularly monitors and reviews their economic, social and environmental performance and develops and implements action plans that allow demonstrable continuous improvement in key operations. ',
            },
            {
                code: 'rspo-3-3.3',
                name: '3.3',
                officialCode: '3.3',
                description: 'Operating procedures are appropriately documented, consistently implemented and monitored.',
            },
            {
                code: 'rspo-3-3.4',
                name: '3.4',
                officialCode: '3.4',
                description: 'A comprehensive Social and Environmental Impact Assessment (SEIA) is undertaken prior to new plantings or operation, and a social and environmental management and monitoring plan is implemented and regularly updated in ongoing operations.',
            },
            {
                code: 'rspo-3-3.5',
                name: '3.5',
                officialCode: '3.5',
                description: 'A system for managing human resources is in place.',
            },
            {
                code: 'rspo-3-3.6',
                name: '3.6',
                officialCode: '3.6',
                description: 'An occupational health and safety (H&S) plan is documented, effectively communicated and implemented.',
            },
            {
                code: 'rspo-3-3.7',
                name: '3.7',
                officialCode: '3.7',
                description: 'All staff, workers, Scheme smallholders, outgrowers and contract workers are appropriately trained.',
            },
            {
                code: 'rspo-3-3.8',
                name: '3.8',
                officialCode: '3.8',
                description: 'Supply Chain Requirements  for mills',
            }
        ]
    },
    {
        code: 'rspo-4',
        name: 'Principle 4: Respect Community and Human Rights and Deliver Benefits',
        officialCode: '4',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-4-4.1',
                name: '4.1',
                officialCode: '4.1',
                description: 'The unit of certification respects human rights, which includes respecting the rights of Human Rights Defenders.',
            },
            {
                code: 'rspo-4-4.2',
                name: '4.2',
                officialCode: '4.2',
                description: 'There is a mutually agreed and documented system for dealing with complaints and grievances, which is implemented and accepted by all affected parties.',
            },
            {
                code: 'rspo-4-4.3',
                name: '4.3',
                officialCode: '4.3',
                description: 'The unit of certification contributes to local sustainable development as agreed by local communities.',
            },
            {
                code: 'rspo-4-4.4',
                name: '4.4',
                officialCode: '4.4',
                description: 'Use of the land for oil palm does not diminish the legal, customary or user rights of other users without their free, prior and informed consent.',
            },
            {
                code: 'rspo-4-4.5',
                name: '4.5',
                officialCode: '4.5',
                description: 'No new plantings are established on local peoples’ land where it can be demonstrated that there are legal, customary or user rights, without their FPIC. This is dealt with through a documented system that enables these and other stakeholders to express their views through their own representative institutions.',
            },
            {
                code: 'rspo-4-4.6',
                name: '4.6',
                officialCode: '4.6',
                description: 'Any negotiations concerning compensation for loss of legal, customary or user rights are dealt with through a documented system that enables indigenous peoples, local communities and other stakeholders to express their views through their own representative institutions.',
            },
            {
                code: 'rspo-4-4.7',
                name: '4.7',
                officialCode: '4.7',
                description: 'Where it can be demonstrated that local peoples have legal, customary or user rights, they are compensated for any agreed land acquisitions and relinquishment of rights, subject to their FPIC and negotiated agreements.',
            },
            {
                code: 'rspo-4-4.8',
                name: '4.8',
                officialCode: '4.8',
                description: 'The right to use the land is demonstrated and is not legitimately contested by local people who can demonstrate that they have legal, customary, or user rights.',
            }
        ]
    },
    {
        code: 'rspo-5',
        name: 'Principle 5: Support Smallholder Inclusion',
        officialCode: '5',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-5-5.1',
                name: '5.1',
                officialCode: '5.1',
                description: 'The unit of certification deals fairly and transparently with all smallholders (Independent and Scheme) and other local businesses. ',
            },
            {
                code: 'rspo-5-5.2',
                name: '5.2',
                officialCode: '5.2',
                description: 'The unit of certification supports improved livelihoods of smallholders and their inclusion in sustainable palm oil value chains.',
            },
        ]
    },
    {
        code: 'rspo-6',
        name: 'Principle 6: Respect Workers Rights and Conditions',
        officialCode: '6',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-6-6.1',
                name: '6.1',
                officialCode: '6.1',
                description: 'Any form of discrimination is prohibited',
            },
            {
                code: 'rspo-6-6.2',
                name: '6.2',
                officialCode: '6.2',
                description: 'Pay and conditions for staff and workers and for contract workers always meet at least legal or industry minimum standards and are sufficient to provide decent living wages (DLW)',
            },
            {
                code: 'rspo-6-6.3',
                name: '6.3',
                officialCode: '6.3',
                description: 'The unit of certification respects the rights of all personnel to form and join trade unions of their choice and to bargain collectively. Where the right to freedom of association and collective bargaining are restricted under law, the employer facilitates parallel means of independent and free  association and bargaining for all such personnel',
            },
            {
                code: 'rspo-6-6.4',
                name: '6.4',
                officialCode: '6.4',
                description: 'Children are not employed or exploited',
            },
            {
                code: 'rspo-6-6.5',
                name: '6.5',
                officialCode: '6.5',
                description: 'There is no harassment or abuse in the workplace, and reproductive rights are protected.',
            },
            {
                code: 'rspo-6-6.6',
                name: '6.6',
                officialCode: '6.6',
                description: 'No forms of forced or trafficked labour are used.',
            },
            {
                code: 'rspo-6-6.7',
                name: '6.7',
                officialCode: '6.7',
                description: 'The unit of certification ensures that the working environment under its control is safe and without undue risk to health.',
            }
        ]
    },
    {
        code: 'rspo-7',
        name: 'Principle 7: Protect, Conserve and Enhance Ecosystems and the Environment',
        officialCode: '7',
        src: `${imagePath$n}/rspo_logo`,
        subgroups: [
            {
                code: 'rspo-7-7.1',
                name: '7.1',
                officialCode: '7.1',
                description: 'IPM plans are implemented and monitored to ensure effective pestcontrol.',
            },
            {
                code: 'rspo-7-7.2',
                name: '7.2',
                officialCode: '7.2',
                description: 'Pesticides are used in ways that do not endanger health of workers, families, communities or the environment.',
            },
            {
                code: 'rspo-7-7.3',
                name: '7.3',
                officialCode: '7.3',
                description: 'Waste is reduced, recycled, reused and disposed of in an environmentally and socially responsible manner',
            },
            {
                code: 'rspo-7-7.4',
                name: '7.4',
                officialCode: '7.4',
                description: 'Practice maintain soil fertility at, or where possible improve soil fertility to, a level that ensures optimsl and sustianed yield.',
            },
            {
                code: 'rspo-7-7.5',
                name: '7.5',
                officialCode: '7.5',
                description: 'Practices minimise and control erosion and degradation of soils.',
            },
            {
                code: 'rspo-7-6.6',
                name: '7.6',
                officialCode: '7.6',
                description: 'Soil surveys and topographic information are used for site planning in the establishmenet of new plantings, and the results are incorporated into plans and operations.',
            },
            {
                code: 'rspo-7-7.7',
                name: '7.7',
                officialCode: '7.7',
                description: 'No new planting on peat, regardless of depth after 15 November 2018 and all peatlands are managed responsibly.',
            },
            {
                code: 'rspo-7-7.8',
                name: '7.8',
                officialCode: '7.8',
                description: 'Practices maintain the quality and availability of surface and groundwater.',
            },
            {
                code: 'rspo-7-7.9',
                name: '7.9',
                officialCode: '7.9',
                description: 'Efficiency of fossil fuel use and the use of renewal energy is optimised',
            },
            {
                code: 'rspo-7-7.10',
                name: '7.10',
                officialCode: '7.10',
                description: 'Plans to reduce pollution and emissions, including greenhouse gases (GHG), are developed, implemented and monitored and new developments are designed to minimise GHG emissions',
            },
            {
                code: 'rspo-7-7.11',
                name: '7.11',
                officialCode: '7.11',
                description: 'Fire is not used for preparing land and is prevented in the managed area.',
            },
            {
                code: 'rspo-7-7.12',
                name: '7.12',
                officialCode: '7.12',
                description: 'Land clearing does not cause deforestation or damage any area required to protect or enhance HighConservation Values (HCVs) or High Carbon Stock (HCS)forest. HCVs and HCS forests in the managed area are identified and protected or enhanced.',
            }
        ]
    }
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$m = config.imagePath;
const cdpGroup = [
    {
        code: 'cdp_climate',
        name: 'CDP Climate',
        officialCode: 'climate',
        colour: '88226e',
        description: 'CDP request information on climate risks and low carbon opportunities from the world’s largest companies on behalf of over 590 institutional investor signatories and 200+ major purchasers with the aim of improving corporate awareness through measurement and disclosure for the effective management of carbon and climate change risk.',
        src: `${imagePath$m}/cdp.png`,
        subgroups: [
            {
                "code": "cdp_climate-intro",
                "name": "C0 Introduction",
                "officialCode": "intro",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-governance",
                "name": "C1 Governance",
                "officialCode": "governance",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-risksandopportunities",
                "name": "C2 Risks and Opportunities",
                "officialCode": "risksandopportunities",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-bisstrat",
                "name": "C3 Business Strategy",
                "officialCode": "bisstrat",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-targets",
                "name": "C4 Targets and Performance",
                "officialCode": "targets",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-methodology",
                "name": "C5 Emissions Methodology",
                "officialCode": "methodology",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-emissions",
                "name": "C6 Emissions Data",
                "officialCode": "emissions",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-breakdown",
                "name": "C7 Emissions Breakdown",
                "officialCode": "breakdown",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-energy",
                "name": "C8 Energy",
                "officialCode": "energy",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-metrics",
                "name": "C9 Additional Metrics",
                "officialCode": "metrics",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-verification",
                "name": "C10 Verification",
                "officialCode": "verification",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-pricing",
                "name": "C11 Carbon Pricing",
                "officialCode": "pricing",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-engagement",
                "name": "C12 Engagement",
                "officialCode": "engagement",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-signoff",
                "name": "C15 Signoff",
                "officialCode": "signoff",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-supplychain",
                "name": "SC Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f",
            },
            {
                "code": "cdp_climate-ac",
                "name": "Agricultural Commodities",
                "officialCode": "ac",
                "colour": "82236f",
                "description": "Activities in the agricultural commodities sector include producing, processing and distributing raw materials (crops and/or livestock) that will be used as ingredients in the manufacturing and packaging of consumer goods by the food, beverage and tobacco sector. This includes the small-scale production of non-timber forest products (e.g. rubber, nuts, seeds, etc.). The agricultural commodities sector is fundamentally dependent on natural resources, and thus directly affected by climate change. Climate-related risks associated with the sector include physical risks such as changing weather patterns, and regulatory risks relating to farm management practices (e.g. the use of fertilizers and pesticides, land use, livestock management etc.). Emissions are associated with the entire agricultural commodities value chain, therefore a whole value chain approach is advised; including consideration of emissions resulting from the consumption of products.",
            },
            {
                "code": "cdp_climate-cg",
                "name": "Capital Goods",
                "officialCode": "cg",
                "colour": "82236f",
                "description": "The capital goods sector provides products and services to key high emitting end markets, such as power generation, construction, transportation, and industry. It is not an emissions intensive sector from direct emissions (Scope 1) or indirect emissions from energy use (Scope 2). However, indirect emissions in the value chain (Scope 3) are key for the sector, with the majority related to the use of sold products and services. Capital goods producers must therefore be able to understand their indirect emissions profile and manage their product-related climate change risks if they are to ensure future competitive success and be prepared for any product-related regulation. Investment in research and development of energy efficient low-carbon products with scope for system-wide change will be also key for the capital goods sector's transition to a low-carbon future.",
            },
            {
                "code": "cdp_climate-ce",
                "name": "Cement",
                "officialCode": "ce",
                "colour": "82236f",
                "description": "Activities in the cement sector encompass those associated with concrete production: from limestone quarrying to concrete end-of-life. Producing cement is an energy intensive process, with most of the GHG emissions for cement production originating from the combustion of fossil fuels for the required heating of key ingredients to about 1450°C in massive cement kilns. In addition, significant CO2 emissions are released as process emissions during production. Increasing energy efficiency, fuel switching, reducing clinker content, and moving to more efficient dry process kilns with pre-calciner and pre-heating technologies are examples of ways the cement industry can reduce its emissions.",
            },
            {
                "code": "cdp_climate-ch",
                "name": "Chemicals",
                "officialCode": "ch",
                "colour": "82236f",
                "description": "The chemicals sector is diverse, creating an immense variety of products such as commodity chemicals, specialty chemicals, life science products, and consumer care products. Most emissions originate from either fossil fuel combustion during the production process, or as process chemical emissions. Process redesign, increased heat production efficiency through cogeneration, and fuel-switching are examples of ways the chemicals sector can cut emissions. Depending on feedstocks used, this sector may have significant upstream emissions, thus feedstock switching from fossil to bio-based fuels may also reduce significant emissions.",
            },
            {
                "code": "cdp_climate-co",
                "name": "Coal",
                "officialCode": "co",
                "colour": "82236f",
                "description": "Activities in the coal sector include coal extraction, coal-based fuel production, and coal-based energy generation. Coal combustion contributes the largest share of the anthropogenic greenhouse gas increase in the atmosphere and dominates power generation globally (IEA, 2017: Tracking Clean Energy Progress).The coal sector faces increasing regulatory and market pressures in its downstream use, including competition from natural gas and renewables. As such, direct and use-phase emissions are strategic risks for coal companies.",
            },
            {
                "code": "cdp_climate-cn",
                "name": "Construction",
                "officialCode": "cn",
                "colour": "82236f",
                "description": "The construction sector is complex, with different types of companies operating at different points in the value chain; spanning across design, materials manufacturing, construction and life cycle maintenance. Although it is important to draw distinct lines of responsibility for CO2 emissions within the buildings value chain, all of the actors in this sector need to align their actions if we are to achieve the Paris Agreement goals, for which the reduction of building-related emissions will play a critical role. Buildings are currently responsible for 39% of global GHG emissions. The sizeable part of these emissions is attributable not only to the construction process itself, but also to materials manufacturing (embodied emissions) and to operational emissions during the use stage of buildings. With the present global building floor area set to more than double by 2060, there will be increased demand for construction materials for new buildings, extensions, renovations and infrastructure; creating significant and immediate carbon emissions before a project's completion.",
            },
            {
                "code": "cdp_climate-eu",
                "name": "Electric Utilities",
                "officialCode": "eu",
                "colour": "82236f",
                "description": "Climate change is a strategic issue for the electric utilities sector, as power generation is the single largest emitter of CO2, accounting for around 25% of global emissions (IPCC, 2014: Climate Change 2014: Synthesis Report. Contribution of Working Groups I, II and III to the Fifth Assessment Report of the Intergovernmental Panel on Climate Change). With the increasing commercialization of renewable energy sources and the advent of decentralized power production, the electric utilities sector has the potential to undergo a key transition to low-carbon energy sources (IIGCC, 2016: Investor Expectations of Electric Utility Companies: Looking down the line at carbon asset risk).",
            },
            {
                "code": "cdp_climate-fs",
                "name": "Financial Services",
                "officialCode": "fs",
                "colour": "82236f",
                "description": 'Activities in the financial services sector include bank lending, investing (asset management and/or asset ownership) and insurance underwriting. The recommendations of the Task Force on Climate-related Financial Disclosures (TCFD) highlight the important role of the financial sector as preparers of climate-related financial disclosures. Disclosure by this sector will enable investors, central banks, regulators/supervisors and other relevant stakeholders to better understand the concentrations of carbon-related assets in the financial sector and the financial system\'s exposures to climate-related risks. The supplemental guidance provided by the Task Force focuses on the importance of considering the impacts of climate-related issues in the context of their financial activities such as lending, financial intermediary, investment and/or insurance underwriting activities. Organizations in the FS sector should respond to the CDP climate change questionnaire in the context of these financing activities, in addition to operational activities where appropriate. Along with new sector-specific questions and modifications to existing questions, specific guidance has been included to clarify the type of information banks, insurance companies and asset managers should consider in their response. The questionnaire shifts focus from Scope 1 and Scope 2 emissions to a more in-depth disclosure of Scope 3 category 15 "Investments" emissions.',
            },
            {
                "code": "cdp_climate-fbt",
                "name": "Food, Beverage & Tobacco",
                "officialCode": "fbt",
                "colour": "82236f",
                "description": "Activities in the food, beverage, and tobacco sector include the processing (including packaging), manufacturing and trade of food, drinks and tobacco consumer goods. Organizations in this sector may also produce their own raw materials, or source them from the agricultural commodities sector. This sector inherits climate-related risks from the agricultural activities in its supply chain, including physical risks such as changing weather patterns, and regulatory risks relating to farm management practices. In addition, they face other climate-related risks associated with the processing, manufacture and packaging of food, drinks, and tobacco products, such as CO2 emissions from machinery, storage facilities and transportation. Focusing on the whole value chain to address these risks is highly important for organizations in this sector.",
            },
            {
                "code": "cdp_climate-mm",
                "name": "Metals and Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "This sector represents the first stage of the life cycle of a huge range of manufactured products, from nuclear reactors to hand cream. Emissions from this sector occur at mining sites during the combustion of fossil fuels and the processing of materials necessary to transform the Earth's elements into useable industry materials. Metals and mining companies can reduce emissions through increased recycling, increased purchases of renewable and low-carbon electricity, and through generation at production sites, which may be particularly significant in remote mines not connected to a power grid. Fuel switching and energy efficiency improvements are needed at metal processing facilities. ",
            },
            {
                "code": "cdp_climate-og",
                "name": "Oil and Gas",
                "officialCode": "og",
                "colour": "82236f",
                "description": "The main activities of the oil and gas sector are the exploration and development, production, refining, and the manufacturing and distribution of petrochemicals. Climate change is a strategic risk for the oil & gas sector; its operational and use phase emissions collectively account for half of global CO2 emissions (IIGCC, 2016: Investor Expectations of Oil and Gas Companies: Transition to a lower carbon future).",
            },
            {
                "code": "cdp_climate-pf",
                "name": "Paper and Forestry",
                "officialCode": "pf",
                "colour": "82236f",
                "description": "Activities in the paper and forestry sector include the production and/or sourcing of timber and timber-based products. Note that non-timber forest products (NTFPs; e.g. rubber, nuts, seeds, etc.) are excluded, as the production and/or sourcing of these products is generally done at a smaller scale and consumed in local markets. (Organizations that produce or source NTFPs are included in our agricultural commodities sector.) Risks associated with the paper and forestry sector extend across the whole value chain and arise from a variety of sources. For example, unsustainable forest management activities, such as illegal logging, burning or other practices can cause deforestation/forest degradation. Another potential issue is the sourcing of timber-based products for the manufacture of wooden goods, paper, and packaging. The use of wood as biofuel for facility energy use, downstream and upstream transportation and distribution, and the waste management of plantation/machinery residues are also all risk factors for the paper and forestry sector. Focusing on the whole value chain to address these risks is highly important for organizations in this sector. ",
            },
            {
                "code": "cdp_climate-re",
                "name": "Real Estate",
                "officialCode": "re",
                "colour": "82236f",
                "description": "The real estate sector is complex, with different types of companies operating at different points in the value chain; spanning across finance, design, construction and life cycle maintenance. Although it is important to draw distinct lines of responsibility for CO2 emissions within the buildings value chain, all of the actors in this sector need to align their actions if we are to achieve the Paris Agreement goals, for which the reduction of building-related emissions will play a critical role. Buildings are currently responsible for 39% of global GHG emissions. The sizeable part of these emissions is attributable not only to the use of built assets – operational emissions (Scopes 1 and 2), but also to their construction – embodied emissions (Scope 3). With the present global building floor area set to more than double by 2060, there will be increased demand for construction materials for new buildings, extensions, renovations and infrastructure; creating significant and immediate carbon emissions before a project's completion.",
            },
            {
                "code": "cdp_climate-st",
                "name": "Steel",
                "officialCode": "st",
                "colour": "82236f",
                "description": "The activities in this sector encompass those associated with the steel production chain: from quarrying to furnace operations. Steel production is a highly energy-intensive process as it transforms iron ore to steel. This transformation requires significant amounts of heat and coking coal, an emissions-intensive product. Production efficiency is closely tied to furnace type, so replacing less efficient furnaces with electric arc furnaces can greatly reduce emissions. However, electric arc furnaces rely on recycled steel for production, and therefore cannot be utilized without the more emissions-intensive production routes such as the blast furnace to transform the iron ore. Attention to feedstocks, implementing various techniques throughout the production process, installing technologies at plants, and switching to less emissions-intensive fuels will lower production emissions in the steel industry. In addition, recycling steel has, and will continue to, significantly reduce emissions.",
            },
            {
                "code": "cdp_climate-to",
                "name": "Transport OEMs",
                "officialCode": "to",
                "colour": "82236f",
                "description": "Transport activity is responsible for almost a quarter of global energy-related emissions, with total energy use for transport having doubled in the last 35 years. The transport value chain includes activities such as original equipment, vehicle parts and engine manufacturers, and service operators. CDP's original equipment manufacturers (OEMs) transport sector includes industrial producers of transportation vehicles across five transport modes: Aviation, Light Duty Vehicles (LDV), Heavy Duty Vehicles (HDV), Shipping, and Rail; and two transport subjects: freight and passengers. ",
            },
            {
                "code": "cdp_climate-ts",
                "name": "Transport Services",
                "officialCode": "ts",
                "colour": "82236f",
                "description": "Transport activity is responsible for almost a quarter of global energy-related emissions, with total energy use for transport having doubled in the last 35 years. The transport value chain includes activities such as original equipment, vehicle parts and engine manufacturers, and service operators. CDP's transport services sector includes operators of vehicles transporting goods and/or passengers across 5 modes: Aviation, Light Duty Vehicles (LDV), Heavy Duty Vehicles (HDV), Shipping, and Rail. Between passenger and freight transport, the key difference with relevance to the CDP questionnaire is the specific metrics that measure efficiency either by passenger or by metric ton of goods transported.",
            },
        ],
    },
    {
        code: 'cdp_forest',
        name: 'CDP Forests',
        officialCode: 'forests',
        colour: '23775b',
        description: 'CDP Forests provides a framework of action for companies to measure and manage forest-related risks and opportunities, transparently report on progress, and commit to proactive action for the restoration of forests and ecosystems.',
        src: `${imagePath$m}/cdp.png`,
        subgroups: [
            {
                "code": "cdp_forest-intro",
                "name": "F0 Introduction",
                "officialCode": "intro",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-state",
                "name": "F1 Current State",
                "officialCode": "state",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-procedures",
                "name": "F2 Procedures",
                "officialCode": "procedures",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-risks",
                "name": "F3 Risks and Opportunities",
                "officialCode": "risks",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-governance",
                "name": "F4 Governance",
                "officialCode": "governance",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-strategy",
                "name": "F5 Business Strategy",
                "officialCode": "strategy",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-implementation",
                "name": "F6 Implementation",
                "officialCode": "implementation",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-verification",
                "name": "F7 Verification",
                "officialCode": "verification",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-challenges",
                "name": "F8 Barriers and Challenges",
                "officialCode": "challenges",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-cstate",
                "name": "F9 Current State",
                "officialCode": "cstate",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-proced",
                "name": "F10 Procedures",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-opportunities",
                "name": "F11 Impacts, Risks and Opportunities",
                "officialCode": "opportunities",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-Govern",
                "name": "F12 Governance",
                "officialCode": "govern",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-business",
                "name": "F13 Business Strategy",
                "officialCode": "business",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-implem",
                "name": "F14 Implementation",
                "officialCode": "implem",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-engagement",
                "name": "F15 Engagement",
                "officialCode": "engagement",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-biodiversity",
                "name": "F16 Verification of biodiversity information",
                "officialCode": "biodiversity",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-signoff",
                "name": "F17 Signoff",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-supplychain",
                "name": "SW Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f"
            },
            {
                "code": "cdp_forest-co",
                "name": "Coal",
                "officialCode": "co",
                "colour": "82236f",
                "description": "CDP's coal forests questionnaire solely focuses on the impacts and risks associated with coal mining, not covering impacts and risks related to the use of coal. A broad focus on biodiversity[1] management was adopted in this sector to ensure alignment with the sector best practices. This covers not only deforestation and forests degradation but also other aspects like protected areas, endangered species and biodiversity-related commitments (e.g., no net loss)."
            },
            {
                "code": "cdp_forest-mm",
                "name": "Metals & Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "CDP's metals & mining forests questionnaire solely focuses on the impacts and risks associated with mining projects, not covering downstream activities related to the processing of chemical elements and compounds from minerals.A broad focus on biodiversity[1] management was adopted in this sector to ensure alignment with the sector best practices. This covers not only deforestation and forests degradation issues but also other aspects like protected areas, endangered species and biodiversity related commitments (e.g., no net loss)."
            },
            {
                "code": "cdp_forest-pf",
                "name": "Papers & Forestry",
                "officialCode": "pf",
                "colour": "82236f",
                "description": "Activities of the paper & forestry (PF) sector include the production and/or sourcing of timber and timber-based products. Note that non-timber forest products (NTFPs; e.g., rubber, nuts, seeds, etc.) are excluded, as the production and/or sourcing of these products are generally done at a smaller scale and consumed in local markets. Organizations that produce/source NTFPs should disclose to the general forests questionnaire."
            }
        ]
    },
    {
        code: 'cdp_water',
        name: 'CDP Water',
        officialCode: 'water',
        colour: '3087db',
        description: 'CDP’s work with water security motivates companies to disclose and reduce their environmental impacts by using the power of investors and customers. The data CDP collects helps influential decision makers to reduce risk, capitalise on opportunities and drive action towards a more sustainable world.',
        src: `${imagePath$m}/cdp.png`,
        subgroups: [
            {
                "code": "cdp_water-intro",
                "name": "W0 Introduction",
                "officialCode": "intro",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-state",
                "name": "W1 Current State",
                "officialCode": "state",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-impacts",
                "name": "W2 Business Impacts",
                "officialCode": "impacts",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-procedures",
                "name": "W3 Procedures",
                "officialCode": "procedures",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-risks",
                "name": "W4 Risks and Opportunities",
                "officialCode": "risks",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-accounting",
                "name": "W5 Facility-level Accounting",
                "officialCode": "accounting",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-governance",
                "name": "W6 Governance",
                "officialCode": "governance",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-strategy",
                "name": "W7 Business Strategy",
                "officialCode": "strategy",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-targets",
                "name": "W8 Targets",
                "officialCode": "targets",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-verification",
                "name": "W9 Verification",
                "officialCode": "verification",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-signoff",
                "name": "W10 Singoff",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-supplychain",
                "name": "SW Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f"
            },
            {
                "code": "cdp_water-ch",
                "name": "Chemicals",
                "officialCode": "ch",
                "colour": "82236f",
                "description": "Chemical production is frequently water-intensive and feedstocks, wastes, or products in this sector may pose particular water pollution risks. Water is used primarily for cooling purposes, but also as a raw material in cleaning and transport, as a solvent, and as part of final products. Hazardous chemicals pose a significant threat to water ecosystems.The activities which define this sector for the CDP water security chemical questionnaire are the production, processing and trading of chemical products."
            },
            {
                "code": "cdp_water-eu",
                "name": "Electric Utilities",
                "officialCode": "eu",
                "colour": "82236f",
                "description": "Activities in the electric utilities sector include electricity generation, transmission, distribution and retailing. However, most significant for water risks and impacts is power generation, and this is the focus of the CDP water security questionnaire for this sector. Only organizations with generation activities will be presented with these sector-specific questions.This sector is heavily dependent on water for cooling; and for electricity generation itself in the case of hydropower. For this reason, plants are often located near bodies of water and organizations rely on access to these resources for the success of their business. The most pressing issues for the sector relate to the impacts of business activities on the hydrological cycle and thermal pollution. Specific forms of water pollution for some fuel types also expose organizations to risks, such as radiation or hydrocarbon contamination. Robust water risk assessment procedures are critical given the long-term nature of investments in the sector."
            },
            {
                "code": "cdp_water-fb",
                "name": "Food, Beverage & Tobacco",
                "officialCode": "fb",
                "colour": "82236f",
                "description": "This sector can include a broad range of activities from the production of agricultural products to food retail, and, amongst others, the processing of raw commodities into ingredients, the manufacturing of packaged consumer or industrial food, beverage, or tobacco products (including packaging processes), and the trade and distribution of food products.Agricultural production and food processing are the most significant activities in terms of water impacts, risks, and opportunities. Water availability, water quality and water pollution due to chemical use and management of animal wastes are issues that can affect an organization's performance. In addition, the agricultural and manufacturing supply chains for this sector are considered high impact for water.The CDP water security FB questionnaire is currently targeted at organizations with processing and manufacturing activities, but it also requests information related to any agricultural production activities engaged in directly or within their supply chain. The questions provide information to data users about an organization's awareness and management of its water dependency related to its direct production and processing activities as well as the commodities it sources."
            },
            {
                "code": "cdp_water-mm",
                "name": "Metals & Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "Water is used by metals and mining organizations during the in-situ extraction process from the ground, mineral processing, transport of minerals and tailings, storage of tailings, and for other processes such as dust suppression, cooling, and employee requirements on site. Tailings dams are a key environmental risk for this sector requiring strong management procedures.The CDP water security metals & mining questionnaire focuses on the impacts and risks associated with the principal business activities of the sector, which include the mining and processing of chemical elements and compounds from minerals."
            },
            {
                "code": "cdp_water-og",
                "name": "Oil & Gas",
                "officialCode": "og",
                "colour": "82236f",
                "description": "Water is critical to the oil & gas industry. The extraction of hydrocarbons produces large volumes of water. Smart, safe management of this produced water is both a business opportunity and a regulatory necessity (in that water contaminated with hydrocarbons must be properly treated).In newer exploration and production such as hydraulic fracturing and oil sands, water is often an essential input for the recovery of the resource. Downstream operations such as refining and petrochemicals require water for cooling.The CDP water security OG questionnaire covers the main activities of the sector: exploration and development, production, refining and the manufacturing and distribution of petro-chemicals; and some data is requested by business division (upstream, downstream and chemicals). Notably, transportation and marketing are not covered as these are not considered water-intensive activities. "
            }
        ]
    },
];

const imagePath$l = config.imagePath;
const vigeoEiris = [
    {
        code: 'vigeo_eiris_gi',
        name: 'General Information Domain',
        officialCode: 'gi',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_gi_i',
                name: 'Information',
                officialCode: 'i',
            },
        ]
    },
    {
        code: 'vigeo_eiris_bbd',
        name: 'Business Behaviour (C&S) Domain',
        officialCode: 'bbd',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_bbd_ps',
                name: 'Product Safety',
                officialCode: 'ps',
                description: 'In this sustainability driver, we analyse the systems put in place to ensure the safety and quality of products as well as the prevention and repair of any emergency/crisis situation affecting product safety.',
            },
            {
                code: 'vigeo_eiris_bbd_info',
                name: 'Information to Customers',
                officialCode: 'info',
                description: 'In this sustainability driver we analyse how companies ensure the provision of reliable, responsible, intelligible and honest information related to their products or service.',
            },
            {
                code: 'vigeo_eiris_bbd_env',
                name: 'Environmental Standards in the Supply Chain',
                officialCode: 'env',
                description: 'In this sustainability driver we analyse the extent to which companies integrate environmental factors into their relationships with suppliers.',
            },
            {
                code: 'vigeo_eiris_bbd_lab',
                name: 'Labour Standards in the Supply Chain',
                officialCode: 'lab',
                description: 'In this sustainability driver we analyse the extent to which companies integrate social standards into their relationships with suppliers.',
            },
            {
                code: 'vigeo_eiris_bbd_c',
                name: 'Corruption',
                officialCode: 'c',
                description: 'In this sustainability driver we analyse how companies work to prevent all forms of corruption in their business operations (bribery, money laundering, conflicts of interest, political donations, extortion, embezzlement, fraud, facilitation payments etc).',
            },
            {
                code: 'vigeo_eiris_bbd_anti',
                name: 'Anti-Competitive Practices',
                officialCode: 'anti',
                description: 'In this sustainability driver we analyse how companies ensure the respect of international market principles related to competition (price fixing, market sharing, dumping, industrial espionage etc).',
            },
            {
                code: 'vigeo_eiris_bbd_rl',
                name: 'Responsible Lobbying',
                officialCode: 'rl',
                description: 'In this sustainability driver we analyse how companies ensure both transparency and integrity when conducting lobbying practices (whether directly or indirectly).',
            }
        ]
    },
    {
        code: 'vigeo_eiris_rights',
        name: 'Human Rights Domain',
        officialCode: 'rights',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_rights_fr',
                name: 'Respect of Fundamental Rights',
                officialCode: 'fr',
                description: 'In this sustainability driver, we assess the extent to which companies are complying with obligation to respect human rights in the community (community taken as a whole, i.e. within and outside of the workplace). This obligation includes: respect of effective exercise of fundamental human rights and personal rights ; prevention of human rights violations or complicity of violations ; promoting or contributing to promote rights are also part of the obligation.',
            },
            {
                code: 'vigeo_eiris_rights_lr',
                name: 'Fundamental Labour Rights',
                officialCode: 'lr',
                description: 'In this sustainability driver, we analyse how companies respect, protect and promote the fundamental labour rights of their employees namely, freedom of association and the right to collective bargaining.',
            },
            {
                code: 'vigeo_eiris_rights_nondis',
                name: 'Non Discrimination and Diversity',
                officialCode: 'nondis',
                description: 'In this sustainability driver, we assess the way in which the company prevents gender discrimination on workplace and other discrimination regarding work conditions, vocational training, promotion, fees, and other benefits. Positive measures and specific measures intended to protect and support women (pregnancy, maternity) or vulnerable people, constitute measures to promote equal opportunity and treatment.',
            },
        ]
    },
    {
        code: 'vigeo_eiris_env',
        name: 'Environment Domain',
        officialCode: 'env',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_env_strat',
                name: 'Environmental Strategy',
                officialCode: 'strat',
                description: 'In this sustainability driver we analyse the overall content of the Environmental Strategy of the company as well as its supporting managerial structures.',
            },
            {
                code: 'vigeo_eiris_env_poll',
                name: 'Accidental Pollution',
                officialCode: 'poll',
                description: 'In this sustainability driver, we analyse how companies prevent and manage accidental pollution impacting the ground linked to their operations.',
            },
            {
                code: 'vigeo_eiris_env_atesting',
                name: 'Animal Testing',
                officialCode: 'atesting',
                description: 'In this sustainability driver, we analyse the measures put in place to both reduce the level of animal testing conducted as well as the measures put in place to safeguard the well-being of animals that are tested upon.',
            },
            {
                code: 'vigeo_eiris_env_water',
                name: 'Water',
                officialCode: 'water',
                description: 'In this sustainability driver, we analyse how company manage both their consumption of water as well as their emissions to water sources.',
            },
            {
                code: 'vigeo_eiris_env_energy',
                name: 'Energy',
                officialCode: 'energy',
                description: 'In this sustainability driver, we analyse how companies manage both their consumption of energy as well as their CO2 emissions linked to energy consumption in production processes (not transportation).',
            },
            {
                code: 'vigeo_eiris_env_transport',
                name: 'Transportation',
                officialCode: 'transport',
                description: 'In this sustainability driver, we analyse how companies manage the environmental impacts linked to the transportation of their products and/or personnel.',
            },
            {
                code: 'vigeo_eiris_env_ecodesign',
                name: 'Eco-Design of Products and Packaging',
                officialCode: 'ecodesign',
                description: 'In this sustainability driver, we analyse how companies manage the environmental impacts related to the use of products by end consumers. We also analyses how companies manage the impacts related to the disposal of products by consumers as well as the disposal of packaging.',
            },
        ]
    },
    {
        code: 'vigeo_eiris_community',
        name: 'Community Involvement Domain',
        officialCode: 'community',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_community_dev',
                name: 'Social and Economic Development',
                officialCode: 'dev',
                description: "In this sustainability driver, we examine how companies promote local social and economic development in areas where they have operations. We also analyses the extent of companies' commitments towards good tax governance in this sustainability driver.",
            }
        ]
    },
    {
        code: 'vigeo_eiris_governance',
        name: 'Corporate Governance Domain',
        officialCode: 'governance',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_governance_board',
                name: 'Board of Directors',
                officialCode: 'board',
                description: 'In this sustainability driver, we analyse the composition, skills, functions and the mandate of the Board of Directors. Their level of independence is assessed as well as the extent of their accountability to shareholders. Amongst other things, we assess the level of diversity on the Board in terms of skills, gender and expertise. We analyse whether training on CSR issues is provided to Board members and the level of responsibility allocated to the oversight of CSR issues at Board level is also examined.',
            },
            {
                code: 'vigeo_eiris_governance_audit',
                name: 'Audit & Internal Controls',
                officialCode: 'audit',
                description: 'In this sustainability driver we analyse the risk management and oversight systems that have been established at the top level of the company. Alongside the composition, independence and mandate of the Audit Committee, we examine whether this committee has expertise in CSR, the operational risks that are covered by internal control systems, the processes in place related to the management of CSR risks (trainings, materiality assessments etc) as well as the level of assurance provided by auditors on the CSR reporting of a company.',
            },
            {
                code: 'vigeo_eiris_governance_shareholders',
                name: 'Shareholders',
                officialCode: 'shareholders',
                description: 'In this sustainability driver, we examine how companies ensure the fair treatment of shareholders and how they allow them to actively participate in strategic decision making. The voting rights attached to shares as well as the ability of shareholders to actively participate and vote on a number of key governance aspects during Annual General Meetings are also examined.',
            },
            {
                code: 'vigeo_eiris_governance_execpay',
                name: 'Executive Pay',
                officialCode: 'execpay',
                description: 'In this sustainability driver, we assess whether companies report transparently on the absolute levels of and the rationales for executive remuneration (both long term and short term). We examine whether or not executive remuneration is tied to specific CSR targets as well as the level of shareholder support for remuneration based resolutions at Annual General Meetings.',
            },
        ]
    },
    {
        code: 'vigeo_eiris_hr',
        name: 'Human Resources Domain',
        officialCode: 'hr',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_hr_dialogue',
                name: 'Social Dialogue',
                officialCode: 'dialogue',
                description: 'In this sustainability driver, we analyse the extent of the companies commitment towards social dialogue with employees in the workplace. We examine what topics are covered by bargaining agreements as well as the employee representative bodies that have been put in place.',
            },
            {
                code: 'vigeo_eiris_hr_reorg',
                name: 'Reorganisations',
                officialCode: 'reorg',
                description: "In this sustainability driver, we analyse the extent of the company's commitment to undertake business reorganisations in a responsible manner.",
            },
            {
                code: 'vigeo_eiris_hr_career',
                name: 'Career Management',
                officialCode: 'career',
                description: 'In this sustainability driver, we analyse how companies establish career management structures that adapt employee skills to their job requirements, enable the progressive development of additional skills and qualifications and ensure transparent frameworks for career management.',
            },
            {
                code: 'vigeo_eiris_hr_hs',
                name: 'Health & Safety',
                officialCode: 'hs',
                description: 'In this sustainability driver, we analyse how companies ensure and improve the health and safety conditions for employees (including stress at work).',
            },
        ]
    },
    {
        code: 'vigeo_eiris_additional',
        name: 'Additional Analysis Domain',
        officialCode: 'additional',
        src: `${imagePath$l}/VigeoEiris.jpeg`,
        subgroups: [
            {
                code: 'vigeo_eiris_additional_employment',
                name: 'Employment',
                officialCode: 'employment',
            },
            {
                code: 'vigeo_eiris_additional_contracts',
                name: 'Working Contracts',
                officialCode: 'contracts',
            },
            {
                code: 'vigeo_eiris_additional_dialogue',
                name: 'Social Dialogue',
                officialCode: 'dialogue',
            },
            {
                code: 'vigeo_eiris_additional_behaviour',
                name: 'Additional Business Behaviour',
                officialCode: 'behaviour',
            },
            {
                code: 'vigeo_eiris_additional_ccimpacts',
                name: 'Physical Impacts of Climate Change',
                officialCode: 'ccimpacts',
                description: "In this sustainability driver, we analyse how a company assesses its vulnerability to the physical impacts of climate changes, how it takes adequate measures to mitigate the potential consequences physical impacts of climate change could have on its activities and how it reinforces its capacity to adapt and reduce its exposure to such changes. Of note : The physical impacts of climate change can be categorised as follows: -Impacts linked to potential destructions or damages to companies' assets (production sites, production equipment, buildings, etc.) -Impacts linked to resource availability (materials, water, agriculture, etc)",
            },
            {
                code: 'vigeo_eiris_additional_ccstrat',
                name: 'Climate Change Strategy',
                officialCode: 'ccstrat',
            },
        ]
    }
];

const bofGroup = [
    {
        code: 'bof_c1',
        name: 'Category 1: Transparency',
        officialCode: 'c1',
        subgroups: [
            {
                code: 'bof_c1_p1',
                name: 'By 2022: Achieve full supply chain traceability and disclose suppliers',
                officialCode: 'c1_p1',
            },
            {
                code: 'bof_c1_p2',
                name: 'By 2022: Analyse and disclose data on environmental and social impact',
                officialCode: 'c1_p2',
            },
        ],
    },
    {
        code: 'bof_c2',
        name: 'Category 2: Emissions',
        description: 'Reduce absolute greenhouse gas emissions across the supply chain 45% by 2030',
        officialCode: 'c2',
        subgroups: [
            {
                code: 'bof_c2_p1',
                name: 'By 2030: Reduce absolute greenhouse gas emissions by 45 percent',
                officialCode: 'c1_p1',
            },
        ],
    },
    {
        code: 'bof_c3',
        name: 'Category 3: Water & Chemicals',
        officialCode: 'c3',
        subgroups: [
            {
                code: 'bof_c3_p1',
                name: 'By 2030: Reduce water use to naturally replenishable levels',
                officialCode: 'c3_p1',
            },
            {
                code: 'bof_c3_p2',
                name: 'By 2030: Eliminate harmful pollution',
                officialCode: 'c3_p2',
            },
            {
                code: 'bof_c3_p3',
                name: 'The Baseline: Actively engage in industry efforts to minimise microfibre pollution',
                officialCode: 'c3_p3',
            },
            {
                code: 'bof_c3_p4',
                name: 'By 2030: Eliminate hazardous usage of chemicals',
                officialCode: 'c3_p4',
            },
        ],
    },
    {
        code: 'bof_c4',
        name: 'Category 4: Waste',
        officialCode: 'c4',
        subgroups: [
            {
                code: 'bof_c4_p1',
                name: 'By 2025: Eliminate waste to landfill and virgin or single-use plastic packaging',
                officialCode: 'c4_p1',
            },
            {
                code: 'bof_c4_p2',
                name: 'By 2030: Establish waste-free production',
                officialCode: 'c4_p2',
            },
            {
                code: 'bof_c4_p3',
                name: 'By 2025: Establish a circular business model',
                officialCode: 'c4_p3',
            },
        ],
    },
    {
        code: 'bof_c5',
        name: 'Category 5: Materials',
        officialCode: 'c5',
        subgroups: [
            {
                code: 'bof_c5_p1',
                name: 'By 2022: Procure 100 percent of materials from "preferred" sources',
                officialCode: 'c5_p1',
            },
            {
                code: 'bof_c5_p2',
                name: 'By 2030: Procure 100 percent of all natural fibres from regenerative and socially responsible sources',
                officialCode: 'c5_p2',
            },
            {
                code: 'bof_c5_p3',
                name: 'By 2030: Eliminate virgin polyester',
                officialCode: 'c5_p3',
            },
        ],
    },
    {
        code: 'bof_c6',
        name: "Category 6: Workers' Rights",
        officialCode: 'c6',
        subgroups: [
            {
                code: 'bof_c6_p1',
                name: 'By 2025: Ensure workers receive a living wage',
                officialCode: 'c6_p1',
            },
            {
                code: 'bof_c6_p2',
                name: 'By 2022: Fully align purchasing practices with commitments to ethical working conditions',
                officialCode: 'c6_p2',
            },
            {
                code: 'bof_c6_p3',
                name: 'The Baseline: Protecting human rights is embedded in corporate strategy',
                officialCode: 'c6_p3',
            },
        ],
    },
];

const imagePath$k = config.imagePath;
const samCsaGroup = [
    {
        code: 'sam_csa_info',
        name: '0 Company Information',
        officialCode: 'info',
        src: `${imagePath$k}/djsi.png`,
        subgroups: [
            {
                code: 'sam_csa_info_denominator',
                name: '0.1 Denominator - Revenues',
                officialCode: 'info_denominator',
            },
        ]
    },
    {
        code: 'sam_csa_economic',
        name: '1 Economic Dimension',
        officialCode: 'economic',
        src: `${imagePath$k}/djsi.png`,
        subgroups: [
            {
                code: 'sam_csa_corporate_governance',
                name: '1.1 Corporate Governance',
                officialCode: 'corporate_governance',
            },
            {
                code: 'sam_csa_materiality',
                name: '1.2 Materiality',
                officialCode: 'materiality',
            },
            {
                code: 'sam_csa_risk',
                name: '1.3 Risk & Crisis Management',
                officialCode: 'risk',
            },
            {
                code: 'sam_csa_conduct',
                name: '1.4 Codes of Business Conduct',
                officialCode: 'conduct',
            },
            {
                code: 'sam_csa_customer_relationship',
                name: '1.5 Customer Relationship Management',
                officialCode: 'customer_relationship',
            },
            {
                code: 'sam_csa_policy_influence',
                name: '1.6 Policy Influence',
                officialCode: 'policy_influence',
            },
            {
                code: 'sam_csa_supply_chain_management',
                name: '1.7 Supply Chain Management',
                officialCode: 'supply_chain_management',
            },
            {
                code: 'sam_csa_brand_management',
                name: '1.8 Brand Management',
                officialCode: 'brand_management',
            },
            {
                code: 'sam_csa_tax_strategy',
                name: '1.9 Tax Strategy',
                officialCode: 'tax_strategy',
            },
            {
                code: 'sam_csa_cybersecurity',
                name: '1.10 Information Security/Cybersecurity & System Availability',
                officialCode: 'cybersecurity',
            },
            {
                code: 'sam_csa_innovation_management',
                name: '1.11 Innovation Management',
                officialCode: 'innovation_management',
            },
            {
                code: 'sam_csa_privacy_protection',
                name: '1.12 Privacy Protection',
                officialCode: 'privacy_protection',
            },
        ]
    },
    {
        code: 'sam_csa_environmental',
        name: '2 Environmental Dimension',
        officialCode: 'environmental',
        src: `${imagePath$k}/djsi.png`,
        subgroups: [
            {
                code: 'sam_csa_environmental_reporting',
                name: '2.1 Environmental Reporting',
                officialCode: 'environmental_reporting',
            },
            {
                code: 'sam_csa_environmental_systems',
                name: '2.2 Environmental Policy & Management Systems',
                officialCode: 'environmental_systems',
            },
            {
                code: 'sam_csa_ecoefficiency',
                name: '2.3 Operational Eco-Efficiency',
                officialCode: 'ecoefficiency',
            },
            {
                code: 'sam_csa_product_stewardship',
                name: '2.4 Product Stewardship',
                officialCode: 'product_stewardship',
            },
            {
                code: 'sam_csa_climate_strategy',
                name: '2.5 Climate Strategy',
                officialCode: 'climate_strategy',
            },
            {
                code: 'sam_csa_packaging',
                name: '2.6 Packaging',
                officialCode: 'packaging',
            },
        ]
    },
    {
        code: 'sam_csa_social',
        name: '3 Social Dimension',
        officialCode: 'social',
        src: `${imagePath$k}/djsi.png`,
        subgroups: [
            {
                code: 'sam_csa_social_reporting',
                name: '3.1 Social Reporting',
                officialCode: 'social_reporting',
            },
            {
                code: 'sam_csa_labor_pracitce',
                name: '3.2 Labor Practice Indicators',
                officialCode: 'labor_pracitce',
            },
            {
                code: 'sam_csa_human_rights',
                name: '3.3 Human Rights',
                officialCode: 'human_rights',
            },
            {
                code: 'sam_csa_human_capital_dev',
                name: '3.4 Human Capital Development',
                officialCode: 'human_capital_dev',
            },
            {
                code: 'sam_csa_talent',
                name: '3.5 Talent Attraction & Retention',
                officialCode: 'talent',
            },
            {
                code: 'sam_csa_philanthropy',
                name: '3.6 Corporate Citizenship and Philanthropy',
                officialCode: 'philanthropy',
            },
            {
                code: 'sam_csa_health_safety',
                name: '3.7 Occupational Health and Safety',
                officialCode: 'health_safety',
            },
        ]
    },
    {
        code: 'sam_csa_future',
        name: '4 Future Questions (Optional)',
        officialCode: 'future',
        src: `${imagePath$k}/djsi.png`,
        subgroups: [
            {
                code: 'sam_csa_impact_valuation',
                name: '4.1 Impact Valuation',
                officialCode: 'impact_valuation',
            },
            {
                code: 'sam_csa_living_wage',
                name: '4.2 Living Wage',
                officialCode: 'living_wage',
            },
        ]
    }
];

const ipiecaGroup = [
    {
        code: "ipieca_governance",
        name: "Governance and Business Ethics",
        officialCode: "governance",
        colour: "82236f"
    },
    {
        code: "ipieca_climate-strat",
        name: "Climate Change and Energy",
        officialCode: "climate-strat",
        colour: "82236f"
    },
    {
        code: "ipieca_environment",
        name: "Environment",
        officialCode: "environment",
        colour: "82236f"
    },
    {
        code: "ipieca_shs",
        name: "Safety. Health & Security",
        officialCode: "shs",
        colour: "82236f"
    },
    {
        code: "ipieca_social",
        name: "Social",
        officialCode: "social",
        colour: "82236f"
    }
];

const iogpGroup = [
    {
        "code": "iogp_commitment",
        "name": "Commitment and accountability",
        "officialCode": "commitment",
        "colour": "82236f"
    },
    {
        "code": "iogp_policies",
        "name": "Policies, standards and objectives",
        "officialCode": "policies",
        "colour": "82236f"
    },
    {
        "code": "iogp_organisation",
        "name": "Organisation, resources and capability",
        "officialCode": "organisation",
        "colour": "82236f"
    },
    {
        "code": "iogp_stakeholders",
        "name": "Stakeholders and customers",
        "officialCode": "stakeholders",
        "colour": "82236f"
    },
    {
        "code": "iogp_risk",
        "name": "Risk assessment and control",
        "officialCode": "risk",
        "colour": "82236f"
    },
    {
        "code": "iogp_asset",
        "name": "Asset design and integrity",
        "officialCode": "asset",
        "colour": "82236f"
    },
    {
        "code": "iogp_plans",
        "name": "Plans and procedures",
        "officialCode": "plans",
        "colour": "82236f"
    },
    {
        "code": "iogp_execution",
        "name": "Execution of activities",
        "officialCode": "execution",
        "colour": "82236f"
    },
    {
        "code": "iogp_monitoring",
        "name": "Monitoring, reporting and learning",
        "officialCode": "monitoring",
        "colour": "82236f"
    },
    {
        "code": "iogp_assurance",
        "name": "Assurance, review and improvement",
        "officialCode": "assurance", "colour": "82236f"
    },
    {
        "code": "iogp_activity",
        "name": "By activitiy and category",
        "officialCode": "activity",
        "colour": "82236f"
    },
    {
        "code": "iogp_region",
        "name": "By region",
        "officialCode": "region",
        "colour": "82236f"
    },
    {
        "code": "iogp_country",
        "name": "By country",
        "officialCode": "country",
        "colour": "82236f"
    },
    {
        "code": "iogp_function",
        "name": "By function",
        "officialCode": "function",
        "colour": "82236f"
    }
];

const imagePath$j = config.imagePath;
const ifcGroups = [
    {
        code: "ifc-ps",
        name: "IFC Environmental and Social Performance Standards",
        officialCode: "ps",
        colour: "263E58",
        src: `${imagePath$j}/ifc-ps1-risk-management-wn.png`,
        subgroups: [
            {
                code: "ifc-ps1",
                name: "Performance Standard 1: Assessment and Management of Environmental and Social Risks and Impacts",
                officialCode: "ps1",
                colour: "263E58",
                src: `${imagePath$j}/ifc-ps1-risk-management-wn.png`,
                description: "Environmental and social responsibility is critically important in today’s global economy. An environmental and social management system (ESMS) helps companies integrate plans and standards into their core operations—so they can anticipate environmental and social risks posed by their business activities and avoid, minimize, and compensate for such impacts as necessary. A good management system provides for consultation with stakeholders and a means for complaints from workers and local communities to be addressed.",
            },
            {
                code: "ifc-ps2",
                name: "Performance Standard 2: Labor and Working Conditions",
                officialCode: "ps2",
                colour: "C89C28",
                src: `${imagePath$j}/ifc-ps2-labor.png`,
                description: "For any business, its workforce is its most valuable asset. A sound worker-management relationship is key to the success of any enterprise. PS2 asks that companies treat their workers fairly, provide safe and healthy working conditions, avoid the use of child or forced labor, and identify risks in their primary supply chain.",
            },
            {
                code: "ifc-ps3",
                name: "Performance Standard 3: Resource efficiency and Pollution Prevention",
                officialCode: "ps3",
                colour: "869098",
                src: `${imagePath$j}/ifc-ps3-resource-efficiency.png`,
                description: "Industrial activity and urbanization can increase levels of pollution that may threaten people’s health and the environment. PS3 guides companies to integrate practices and technologies that promote energy efficiency, use resources—including energy and water—sustainably, and reduce greenhouse gas emissions.",
            },
            {
                code: "ifc-ps4",
                name: "Performance Standard 4: Community Health, Safety, and Security",
                officialCode: "ps4",
                colour: "00234E",
                src: `${imagePath$j}/ifc-ps4-community.png`,
                description: "Business activities and infrastructure projects may expose local communities to increased risks and adverse impacts related to worksite accidents, hazardous materials, spread of diseases, or interactions with private security personnel. PS4 helps companies adopt responsible practices to reduce such risks including through emergency preparedness and response, security force management, and design safety measures.",
            },
            {
                code: "ifc-ps5",
                name: "Performance Standard 5: Land Acquisition and Involuntary Resettlement",
                officialCode: "ps5",
                colour: "036C44",
                src: `${imagePath$j}/ifc-ps5-land-resettlement.png`,
                description: "When companies seek to acquire land for their business activities, it can lead to relocation and loss of shelter or livelihoods for communities or individual households. Involuntary resettlement occurs when affected people do not have the right to refuse land acquisition and are displaced, which may result in long-term hardship and impoverishment as well as social stress. PS5 advises companies to avoid involuntary resettlement wherever possible and to minimize its impact on those displaced through mitigation measures such as fair compensation and improvements to and living conditions. Active community engagement throughout the process is essential.",
            },
            {
                code: "ifc-ps6",
                name: "Performance Standard 6: Biodiversity Conservation and Sustainable Management of Living Natural Resources",
                officialCode: "ps6",
                colour: "00B0E5",
                src: `${imagePath$j}/ifc-ps6-biodiversity.png`,
                description: "Biodiversity loss can result in critical reductions in the resources provided by the earth’s ecosystems, which contribute to economic prosperity and human development. This is especially relevant in developing countries where natural resource-based livelihoods are often prevalent. PS6 recognizes that protecting and conserving biodiversity, maintaining ecosystem services, and managing living natural resources adequately are fundamental to sustainable development.",
            },
            {
                code: "ifc-ps7",
                name: "Performance Standard 7: Indigenous Peoples",
                officialCode: "ps7",
                colour: "B78552",
                src: `${imagePath$j}/ifc-ps7-indigenous-people.png`,
                description: "Indigenous peoples (IPs) may be particularly vulnerable to the adverse impacts associated with project development, including risk of impoverishment and loss of identity, culture, and natural resource-based livelihoods. PS7 seeks to ensure that business activities minimize negative impacts, foster respect for human rights, dignity and culture of indigenous populations, and promote development benefits in culturally appropriate ways. Informed consultation and participation with IPs throughout the project process is a core requirement and may include Free, Prior and Informed Consent under certain circumstances.",
            },
            {
                code: "ifc-ps8",
                name: "Performance Standard 8: Cultural Heritage",
                officialCode: "ps8",
                colour: "EA7C1B",
                src: `${imagePath$j}/ifc-ps8-cultural-heritage.png`,
                description: "Cultural heritage encompasses properties and sites of archaeological, historical, cultural, artistic, and religious significance. It also refers to unique environmental features and cultural knowledge, as well as intangible forms of culture embodying traditional lifestyles that should be preserved for current and future generations. PS8 aims to guide companies in protecting cultural heritage from adverse impacts of project activities and supporting its preservation. It also promotes the equitable sharing of benefits from the use of cultural heritage.",
            },
        ],
    },
    {
        code: "ifc-gp",
        name: "IFC Corporate Governance Parameters",
        officialCode: "gp",
        subgroups: [
            {
                code: "ifc-gp-a",
                name: "Governance Parameter A: Commitment to Environmental, Social, and Governance (Leadership and Culture)",
                officialCode: "gp-a",
                description: "The company and its shareholders have demonstrated a commitment to implementing high-quality corporate governance, including the governance of key environmental and social policies and procedures.",
            },
            {
                code: "ifc-gp-b",
                name: "Governance Parameter B: Structure and Functioning of the Board of Directors",
                officialCode: "gp-b",
                description: "The board of directors is qualified and adequately structured to oversee the strategy, management, and performance of the company.",
            },
            {
                code: "ifc-gp-c",
                name: "Governance Parameter C: Control Environment",
                officialCode: "gp-c",
                description: "The company’s internal control system, internal audit function, risk management system (including an environmental and social management system), and compliance function are sufficient to ensure sound stewardship of the company’s assets, effectiveness of operations, accuracy in reporting, and compliance with policies, procedures, laws, and regulations.",
            },
            {
                code: "ifc-gp-d",
                name: "Governance Parameter D: Disclosure and Transparency",
                officialCode: "gp-d",
                description: "The company’s financial and non-financial disclosures are a relevant, faithful, and timely representation of material events to shareholders and other stakeholders.",
            },
            {
                code: "ifc-gp-e",
                name: "Governance Parameter E: Treatment of Minority Shareholders",
                officialCode: "gp-e",
                description: "The company’s minority shareholders’ rights are adequate and not abused, and other stakeholders are treated equitably.",
            },
            {
                code: "ifc-gp-f",
                name: "Governance Parameter F: Governance of Stakeholder Engagement",
                officialCode: "gp-f",
                description: "The company’s governance of stakeholder engagement is adequate, particularly oversight over stakeholder mapping, stakeholder engagement policy and grievance mechanisms.",
            }
        ]
    }
];

const erqGroup = [
    {
        code: "erq_metrics_2022_risk",
        name: "ERQ Metrics - Risk",
        officialCode: "erq-risk",
        colour: "82236f"
    },
    {
        code: "erq_metrics_2022_gov",
        name: "ERQ Metrics - Governance",
        officialCode: "erq-gov",
        colour: "82236f"
    },
    {
        code: "erq_metrics_2022_sf",
        name: "ERQ Metrics - Sustainable Financing",
        officialCode: "erq-sf",
        colour: "82236f"
    },
    {
        code: "erq_metrics_2022_met",
        name: "ERQ Metrics - Metrics",
        officialCode: "erq-met",
        colour: "82236f"
    },
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$i = config.imagePath;
const cdp2020Group = [
    {
        "code": "cdp_2022_climate",
        "name": "CDP Climate",
        "officialCode": "climate",
        "colour": "88226e",
        "description": "CDP request information on climate risks and low carbon opportunities from the world's largest companies on behalf of over 590 institutional investor signatories and 200+ major purchasers with the aim of improving corporate awareness through measurement and disclosure for the effective management of carbon and climate change risk.",
        "src": `${imagePath$i}/cdp.png`,
        "subgroups": [
            {
                "code": "cdp_2022_climate-intro",
                "name": "C0 Introduction",
                "officialCode": "intro",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-governance",
                "name": "C1 Governance",
                "officialCode": "governance",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-risksandopportunities",
                "name": "C2 Risks and Opportunities",
                "officialCode": "risksandopportunities",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-bisstrat",
                "name": "C3 Business Strategy",
                "officialCode": "bisstrat",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-targets",
                "name": "C4 Targets and Performance",
                "officialCode": "targets",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-methodology",
                "name": "C5 Emissions Methodology",
                "officialCode": "methodology",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-emissions",
                "name": "C6 Emissions Data",
                "officialCode": "emissions",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-breakdown",
                "name": "C7 Emissions Breakdown",
                "officialCode": "breakdown",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-energy",
                "name": "C8 Energy",
                "officialCode": "energy",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-metrics",
                "name": "C9 Additional Metrics",
                "officialCode": "metrics",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-verification",
                "name": "C10 Verification",
                "officialCode": "verification",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-pricing",
                "name": "C11 Carbon Pricing",
                "officialCode": "pricing",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-engagement",
                "name": "C12 Engagement",
                "officialCode": "engagement",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-signoff",
                "name": "C16 Signoff",
                "officialCode": "signoff",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-supplychain",
                "name": "SC Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f",
            },
            {
                "code": "cdp_2022_climate-ac",
                "name": "Agricultural Commodities",
                "officialCode": "ac",
                "colour": "82236f",
                "description": "Activities in the agricultural commodities sector include producing, processing and distributing raw materials (crops and/or livestock) that will be used as ingredients in the manufacturing and packaging of consumer goods by the food, beverage and tobacco sector. This includes the small-scale production of non-timber forest products (e.g. rubber, nuts, seeds, etc.). The agricultural commodities sector is fundamentally dependent on natural resources, and thus directly affected by climate change. Climate-related risks associated with the sector include physical risks such as changing weather patterns, and regulatory risks relating to farm management practices (e.g. the use of fertilizers and pesticides, land use, livestock management etc.). Emissions are associated with the entire agricultural commodities value chain, therefore a whole value chain approach is advised; including consideration of emissions resulting from the consumption of products.",
            },
            {
                "code": "cdp_2022_climate-cg",
                "name": "Capital Goods",
                "officialCode": "cg",
                "colour": "82236f",
                "description": "The capital goods sector provides products and services to key high emitting end markets, such as power generation, construction, transportation, and industry. It is not an emissions intensive sector from direct emissions (Scope 1) or indirect emissions from energy use (Scope 2). However, indirect emissions in the value chain (Scope 3) are key for the sector, with the majority related to the use of sold products and services. Capital goods producers must therefore be able to understand their indirect emissions profile and manage their product-related climate change risks if they are to ensure future competitive success and be prepared for any product-related regulation. Investment in research and development of energy efficient low-carbon products with scope for system-wide change will be also key for the capital goods sector's transition to a low-carbon future.",
            },
            {
                "code": "cdp_2022_climate-ce",
                "name": "Cement",
                "officialCode": "ce",
                "colour": "82236f",
                "description": "Activities in the cement sector encompass those associated with concrete production: from limestone quarrying to concrete end-of-life. Producing cement is an energy intensive process, with most of the GHG emissions for cement production originating from the combustion of fossil fuels for the required heating of key ingredients to about 1450°C in massive cement kilns. In addition, significant CO2 emissions are released as process emissions during production. Increasing energy efficiency, fuel switching, reducing clinker content, and moving to more efficient dry process kilns with pre-calciner and pre-heating technologies are examples of ways the cement industry can reduce its emissions.",
            },
            {
                "code": "cdp_2022_climate-ch",
                "name": "Chemicals",
                "officialCode": "ch",
                "colour": "82236f",
                "description": "The chemicals sector is diverse, creating an immense variety of products such as commodity chemicals, specialty chemicals, life science products, and consumer care products. Most emissions originate from either fossil fuel combustion during the production process, or as process chemical emissions. Process redesign, increased heat production efficiency through cogeneration, and fuel-switching are examples of ways the chemicals sector can cut emissions. Depending on feedstocks used, this sector may have significant upstream emissions, thus feedstock switching from fossil to bio-based fuels may also reduce significant emissions.",
            },
            {
                "code": "cdp_2022_climate-co",
                "name": "Coal",
                "officialCode": "co",
                "colour": "82236f",
                "description": "Activities in the coal sector include coal extraction, coal-based fuel production, and coal-based energy generation. Coal combustion contributes the largest share of the anthropogenic greenhouse gas increase in the atmosphere and dominates power generation globally (IEA, 2017: Tracking Clean Energy Progress).The coal sector faces increasing regulatory and market pressures in its downstream use, including competition from natural gas and renewables. As such, direct and use-phase emissions are strategic risks for coal companies.",
            },
            {
                "code": "cdp_2022_climate-cn",
                "name": "Construction",
                "officialCode": "cn",
                "colour": "82236f",
                "description": "The construction sector is complex, with different types of companies operating at different points in the value chain; spanning across design, materials manufacturing, construction and life cycle maintenance. Although it is important to draw distinct lines of responsibility for CO2 emissions within the buildings value chain, all of the actors in this sector need to align their actions if we are to achieve the Paris Agreement goals, for which the reduction of building-related emissions will play a critical role. Buildings are currently responsible for 39% of global GHG emissions. The sizeable part of these emissions is attributable not only to the construction process itself, but also to materials manufacturing (embodied emissions) and to operational emissions during the use stage of buildings. With the present global building floor area set to more than double by 2060, there will be increased demand for construction materials for new buildings, extensions, renovations and infrastructure; creating significant and immediate carbon emissions before a project's completion.",
            },
            {
                "code": "cdp_2022_climate-eu",
                "name": "Electric Utilities",
                "officialCode": "eu",
                "colour": "82236f",
                "description": "Climate change is a strategic issue for the electric utilities sector, as power generation is the single largest emitter of CO2, accounting for around 25% of global emissions (IPCC, 2014: Climate Change 2014: Synthesis Report. Contribution of Working Groups I, II and III to the Fifth Assessment Report of the Intergovernmental Panel on Climate Change). With the increasing commercialization of renewable energy sources and the advent of decentralized power production, the electric utilities sector has the potential to undergo a key transition to low-carbon energy sources (IIGCC, 2016: Investor Expectations of Electric Utility Companies: Looking down the line at carbon asset risk).",
            },
            {
                "code": "cdp_2022_climate-fs",
                "name": "Financial Services",
                "officialCode": "fs",
                "colour": "82236f",
                "description": "Activities in the financial services sector include bank lending, investing (asset management and/or asset ownership) and insurance underwriting. The recommendations of the Task Force on Climate-related Financial Disclosures (TCFD) highlight the important role of the financial sector as preparers of climate-related financial disclosures. Disclosure by this sector will enable investors, central banks, regulators/supervisors and other relevant stakeholders to better understand the concentrations of carbon-related assets in the financial sector and the financial system's exposures to climate-related risks. The supplemental guidance provided by the Task Force focuses on the importance of considering the impacts of climate-related issues in the context of their financial activities such as lending, financial intermediary, investment and/or insurance underwriting activities. Organizations in the FS sector should respond to the CDP climate change questionnaire in the context of these financing activities, in addition to operational activities where appropriate. Along with new sector-specific questions and modifications to existing questions, specific guidance has been included to clarify the type of information banks, insurance companies and asset managers should consider in their response. The questionnaire shifts focus from Scope 1 and Scope 2 emissions to a more in-depth disclosure of Scope 3 category 15 'Investments' emissions.",
            },
            {
                "code": "cdp_2022_climate-fbt",
                "name": "Food, Beverage & Tobacco",
                "officialCode": "fbt",
                "colour": "82236f",
                "description": "Activities in the food, beverage, and tobacco sector include the processing (including packaging), manufacturing and trade of food, drinks and tobacco consumer goods. Organizations in this sector may also produce their own raw materials, or source them from the agricultural commodities sector. This sector inherits climate-related risks from the agricultural activities in its supply chain, including physical risks such as changing weather patterns, and regulatory risks relating to farm management practices. In addition, they face other climate-related risks associated with the processing, manufacture and packaging of food, drinks, and tobacco products, such as CO2 emissions from machinery, storage facilities and transportation. Focusing on the whole value chain to address these risks is highly important for organizations in this sector.",
            },
            {
                "code": "cdp_2022_climate-mm",
                "name": "Metals and Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "This sector represents the first stage of the life cycle of a huge range of manufactured products, from nuclear reactors to hand cream. Emissions from this sector occur at mining sites during the combustion of fossil fuels and the processing of materials necessary to transform the Earth's elements into useable industry materials. Metals and mining companies can reduce emissions through increased recycling, increased purchases of renewable and low-carbon electricity, and through generation at production sites, which may be particularly significant in remote mines not connected to a power grid. Fuel switching and energy efficiency improvements are needed at metal processing facilities. ",
            },
            {
                "code": "cdp_2022_climate-og",
                "name": "Oil and Gas",
                "officialCode": "og",
                "colour": "82236f",
                "description": "The main activities of the oil and gas sector are the exploration and development, production, refining, and the manufacturing and distribution of petrochemicals. Climate change is a strategic risk for the oil & gas sector; its operational and use phase emissions collectively account for half of global CO2 emissions (IIGCC, 2016: Investor Expectations of Oil and Gas Companies: Transition to a lower carbon future).",
            },
            {
                "code": "cdp_2022_climate-pf",
                "name": "Paper and Forestry",
                "officialCode": "pf",
                "colour": "82236f",
                "description": "Activities in the paper and forestry sector include the production and/or sourcing of timber and timber-based products. Note that non-timber forest products (NTFPs; e.g. rubber, nuts, seeds, etc.) are excluded, as the production and/or sourcing of these products is generally done at a smaller scale and consumed in local markets. (Organizations that produce or source NTFPs are included in our agricultural commodities sector.) Risks associated with the paper and forestry sector extend across the whole value chain and arise from a variety of sources. For example, unsustainable forest management activities, such as illegal logging, burning or other practices can cause deforestation/forest degradation. Another potential issue is the sourcing of timber-based products for the manufacture of wooden goods, paper, and packaging. The use of wood as biofuel for facility energy use, downstream and upstream transportation and distribution, and the waste management of plantation/machinery residues are also all risk factors for the paper and forestry sector. Focusing on the whole value chain to address these risks is highly important for organizations in this sector. ",
            },
            {
                "code": "cdp_2022_climate-re",
                "name": "Real Estate",
                "officialCode": "re",
                "colour": "82236f",
                "description": "The real estate sector is complex, with different types of companies operating at different points in the value chain; spanning across finance, design, construction and life cycle maintenance. Although it is important to draw distinct lines of responsibility for CO2 emissions within the buildings value chain, all of the actors in this sector need to align their actions if we are to achieve the Paris Agreement goals, for which the reduction of building-related emissions will play a critical role. Buildings are currently responsible for 39% of global GHG emissions. The sizeable part of these emissions is attributable not only to the use of built assets – operational emissions (Scopes 1 and 2), but also to their construction – embodied emissions (Scope 3). With the present global building floor area set to more than double by 2060, there will be increased demand for construction materials for new buildings, extensions, renovations and infrastructure; creating significant and immediate carbon emissions before a project's completion.",
            },
            {
                "code": "cdp_2022_climate-st",
                "name": "Steel",
                "officialCode": "st",
                "colour": "82236f",
                "description": "The activities in this sector encompass those associated with the steel production chain: from quarrying to furnace operations. Steel production is a highly energy-intensive process as it transforms iron ore to steel. This transformation requires significant amounts of heat and coking coal, an emissions-intensive product. Production efficiency is closely tied to furnace type, so replacing less efficient furnaces with electric arc furnaces can greatly reduce emissions. However, electric arc furnaces rely on recycled steel for production, and therefore cannot be utilized without the more emissions-intensive production routes such as the blast furnace to transform the iron ore. Attention to feedstocks, implementing various techniques throughout the production process, installing technologies at plants, and switching to less emissions-intensive fuels will lower production emissions in the steel industry. In addition, recycling steel has, and will continue to, significantly reduce emissions.",
            },
            {
                "code": "cdp_2022_climate-to",
                "name": "Transport OEMs",
                "officialCode": "to",
                "colour": "82236f",
                "description": "Transport activity is responsible for almost a quarter of global energy-related emissions, with total energy use for transport having doubled in the last 35 years. The transport value chain includes activities such as original equipment, vehicle parts and engine manufacturers, and service operators. CDP's original equipment manufacturers (OEMs) transport sector includes industrial producers of transportation vehicles across five transport modes: Aviation, Light Duty Vehicles (LDV), Heavy Duty Vehicles (HDV), Shipping, and Rail; and two transport subjects: freight and passengers. ",
            },
            {
                "code": "cdp_2022_climate-ts",
                "name": "Transport Services",
                "officialCode": "ts",
                "colour": "82236f",
                "description": "Transport activity is responsible for almost a quarter of global energy-related emissions, with total energy use for transport having doubled in the last 35 years. The transport value chain includes activities such as original equipment, vehicle parts and engine manufacturers, and service operators. CDP's transport services sector includes operators of vehicles transporting goods and/or passengers across 5 modes: Aviation, Light Duty Vehicles (LDV), Heavy Duty Vehicles (HDV), Shipping, and Rail. Between passenger and freight transport, the key difference with relevance to the CDP questionnaire is the specific metrics that measure efficiency either by passenger or by metric ton of goods transported.",
            },
            {
                "code": "cdp_2022_climate-land-management",
                "name": "C13 Other land management impacts",
                "officialCode": "landmanagement",
                "colour": "82236f",
                "description": "Disclosure on impacts - other than climate-related - of land management practices implemented in owned land and/or by suppliers.",
            },
            {
                "code": "cdp_2022_climate-portfolio-impact",
                "name": "C14 Portfolio Impact",
                "officialCode": "portfolioimpact",
                "colour": "82236f",
                "description": "Provides the opportunity to disclose the impacts your financial portfolio(s) has on the climate, and to break down your portfolio emissions and/or other carbon footprinting and exposure metrics by asset class, industry, country/region and/or scope.",
            },
            {
                "code": "cdp_2022_climate-biodiversity",
                "name": "C15 Biodiversity",
                "officialCode": "biodiv",
                "colour": "82236f",
                "description": "Disclosure on actions to preserve or improve biodiversity will help organizations to evaluate the relevancy and efficacy of their commitments and consider the biodiversity-related risks and impacts of their business practices.",
            },
            {
                "code": "cdp_2022_climate-fw-security",
                "name": "FW-FS Forests and Water Security (FS only)",
                "officialCode": "fwsecurity",
                "colour": "82236f",
                "description": "Financial institutions’ impact on nature, and their exposure to nature-related risks, comes almost entirely from the activities they finance and/or insure in the wider economy. They are therefore requested to report information related to forests and water security only if they lend to, invest in or insure sectors of the economy with a critical impact or dependency on nature. Organizations should respond to this module in the context of these financing/insurance underwriting activities.",
            },
        ],
    },
    {
        "code": "cdp_2022_forest",
        "name": "CDP Forests",
        "officialCode": "forests",
        "colour": "23775b",
        "description": "CDP Forests provides a framework of action for companies to measure and manage forest-related risks and opportunities, transparently report on progress, and commit to proactive action for the restoration of forests and ecosystems.",
        "src": `${imagePath$i}/cdp.png`,
        "subgroups": [
            {
                "code": "cdp_2022_forest-intro",
                "name": "F0 Introduction",
                "officialCode": "intro",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-state",
                "name": "F1 Current State",
                "officialCode": "state",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-procedures",
                "name": "F2 Procedures",
                "officialCode": "procedures",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-risks",
                "name": "F3 Risks and Opportunities",
                "officialCode": "risks",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-governance",
                "name": "F4 Governance",
                "officialCode": "governance",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-strategy",
                "name": "F5 Business Strategy",
                "officialCode": "strategy",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-implementation",
                "name": "F6 Implementation",
                "officialCode": "implementation",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-verification",
                "name": "F7 Verification",
                "officialCode": "verification",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-challenges",
                "name": "F8 Barriers and Challenges",
                "officialCode": "challenges",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-cstate",
                "name": "F9 Current State",
                "officialCode": "cstate",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-proced",
                "name": "F10 Procedures",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-opportunities",
                "name": "F11 Impacts, Risks and Opportunities",
                "officialCode": "opportunities",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-govern",
                "name": "F12 Governance",
                "officialCode": "govern",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-business",
                "name": "F13 Business Strategy",
                "officialCode": "business",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-implem",
                "name": "F14 Implementation",
                "officialCode": "implem",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-engagement",
                "name": "F15 Engagement",
                "officialCode": "engagement",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-biodiversity",
                "name": "F16 Verification of biodiversity information",
                "officialCode": "biodiversity",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-signoff",
                "name": "F17 Signoff",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-supplychain",
                "name": "SW Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_forest-co",
                "name": "Coal",
                "officialCode": "co",
                "colour": "82236f",
                "description": "CDP's coal forests questionnaire solely focuses on the impacts and risks associated with coal mining, not covering impacts and risks related to the use of coal. A broad focus on biodiversity[1] management was adopted in this sector to ensure alignment with the sector best practices. This covers not only deforestation and forests degradation but also other aspects like protected areas, endangered species and biodiversity-related commitments (e.g., no net loss)."
            },
            {
                "code": "cdp_2022_forest-mm",
                "name": "Metals & Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "CDP's metals & mining forests questionnaire solely focuses on the impacts and risks associated with mining projects, not covering downstream activities related to the processing of chemical elements and compounds from minerals.A broad focus on biodiversity[1] management was adopted in this sector to ensure alignment with the sector best practices. This covers not only deforestation and forests degradation issues but also other aspects like protected areas, endangered species and biodiversity related commitments (e.g., no net loss)."
            },
            {
                "code": "cdp_2022_forest-pf",
                "name": "Papers & Forestry",
                "officialCode": "pf",
                "colour": "82236f",
                "description": "Activities of the paper & forestry (PF) sector include the production and/or sourcing of timber and timber-based products. Note that non-timber forest products (NTFPs; e.g., rubber, nuts, seeds, etc.) are excluded, as the production and/or sourcing of these products are generally done at a smaller scale and consumed in local markets. Organizations that produce/source NTFPs should disclose to the general forests questionnaire."
            }
        ]
    },
    {
        "code": "cdp_2022_water",
        "name": "CDP Water",
        "officialCode": "water",
        "colour": "3087db",
        "description": "CDP's work with water security motivates companies to disclose and reduce their environmental impacts by using the power of investors and customers. The data CDP collects helps influential decision makers to reduce risk, capitalise on opportunities and drive action towards a more sustainable world.",
        "src": `${imagePath$i}/cdp.png`,
        "subgroups": [
            {
                "code": "cdp_2022_water-intro",
                "name": "W0 Introduction",
                "officialCode": "intro",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-state",
                "name": "W1 Current State",
                "officialCode": "state",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-impacts",
                "name": "W2 Business Impacts",
                "officialCode": "impacts",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-procedures",
                "name": "W3 Procedures",
                "officialCode": "procedures",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-risks",
                "name": "W4 Risks and Opportunities",
                "officialCode": "risks",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-accounting",
                "name": "W5 Facility-level Accounting",
                "officialCode": "accounting",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-governance",
                "name": "W6 Governance",
                "officialCode": "governance",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-strategy",
                "name": "W7 Business Strategy",
                "officialCode": "strategy",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-targets",
                "name": "W8 Targets",
                "officialCode": "targets",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-verification",
                "name": "W9 Verification",
                "officialCode": "verification",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-signoff",
                "name": "W10 Singoff",
                "officialCode": "signoff",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-supplychain",
                "name": "SW Supply Chain",
                "officialCode": "supplychain",
                "colour": "82236f"
            },
            {
                "code": "cdp_2022_water-ch",
                "name": "Chemicals",
                "officialCode": "ch",
                "colour": "82236f",
                "description": "Chemical production is frequently water-intensive and feedstocks, wastes, or products in this sector may pose particular water pollution risks. Water is used primarily for cooling purposes, but also as a raw material in cleaning and transport, as a solvent, and as part of final products. Hazardous chemicals pose a significant threat to water ecosystems.The activities which define this sector for the CDP water security chemical questionnaire are the production, processing and trading of chemical products."
            },
            {
                "code": "cdp_2022_water-eu",
                "name": "Electric Utilities",
                "officialCode": "eu",
                "colour": "82236f",
                "description": "Activities in the electric utilities sector include electricity generation, transmission, distribution and retailing. However, most significant for water risks and impacts is power generation, and this is the focus of the CDP water security questionnaire for this sector. Only organizations with generation activities will be presented with these sector-specific questions.This sector is heavily dependent on water for cooling; and for electricity generation itself in the case of hydropower. For this reason, plants are often located near bodies of water and organizations rely on access to these resources for the success of their business. The most pressing issues for the sector relate to the impacts of business activities on the hydrological cycle and thermal pollution. Specific forms of water pollution for some fuel types also expose organizations to risks, such as radiation or hydrocarbon contamination. Robust water risk assessment procedures are critical given the long-term nature of investments in the sector."
            },
            {
                "code": "cdp_2022_water-fb",
                "name": "Food, Beverage & Tobacco",
                "officialCode": "fb",
                "colour": "82236f",
                "description": "This sector can include a broad range of activities from the production of agricultural products to food retail, and, amongst others, the processing of raw commodities into ingredients, the manufacturing of packaged consumer or industrial food, beverage, or tobacco products (including packaging processes), and the trade and distribution of food products.Agricultural production and food processing are the most significant activities in terms of water impacts, risks, and opportunities. Water availability, water quality and water pollution due to chemical use and management of animal wastes are issues that can affect an organization's performance. In addition, the agricultural and manufacturing supply chains for this sector are considered high impact for water.The CDP water security FB questionnaire is currently targeted at organizations with processing and manufacturing activities, but it also requests information related to any agricultural production activities engaged in directly or within their supply chain. The questions provide information to data users about an organization's awareness and management of its water dependency related to its direct production and processing activities as well as the commodities it sources."
            },
            {
                "code": "cdp_2022_water-mm",
                "name": "Metals & Mining",
                "officialCode": "mm",
                "colour": "82236f",
                "description": "Water is used by metals and mining organizations during the in-situ extraction process from the ground, mineral processing, transport of minerals and tailings, storage of tailings, and for other processes such as dust suppression, cooling, and employee requirements on site. Tailings dams are a key environmental risk for this sector requiring strong management procedures.The CDP water security metals & mining questionnaire focuses on the impacts and risks associated with the principal business activities of the sector, which include the mining and processing of chemical elements and compounds from minerals."
            },
            {
                "code": "cdp_2022_water-og",
                "name": "Oil & Gas",
                "officialCode": "og",
                "colour": "82236f",
                "description": "Water is critical to the oil & gas industry. The extraction of hydrocarbons produces large volumes of water. Smart, safe management of this produced water is both a business opportunity and a regulatory necessity (in that water contaminated with hydrocarbons must be properly treated).In newer exploration and production such as hydraulic fracturing and oil sands, water is often an essential input for the recovery of the resource. Downstream operations such as refining and petrochemicals require water for cooling.The CDP water security OG questionnaire covers the main activities of the sector: exploration and development, production, refining and the manufacturing and distribution of petro-chemicals; and some data is requested by business division (upstream, downstream and chemicals). Notably, transportation and marketing are not covered as these are not considered water-intensive activities. "
            }
        ]
    },
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath$h = config.imagePath;
const gri2021Group = [
    {
        code: 'gri_2021-1',
        name: 'GRI 1 - Foundation 2021',
        officialCode: 'gri2021-1',
        colour: '#677538',
        description: 'GRI 1: Foundation 2021 introduces the purpose and system of the GRI Sustainability Reporting Standards (GRI Standards) and explains key concepts for sustainability reporting. It also specifies the requirements and reporting principles that organizations must comply with to report in accordance with the GRI Standards.',
        src: `${imagePath$h}/gri2021-1.png`,
    },
    {
        code: 'gri_2021-2',
        name: 'GRI 2 - General Disclosures 2021',
        officialCode: 'gri2021-2',
        colour: '#677538',
        description: 'GRI 2: General Disclosures 2021 contains disclosures for organizations to provide information about their reporting practices; activities and workers; governance; strategy, policies, and practices; and stakeholder engagement. This information gives insight into the profile and scale of organizations and provides a context for understanding their impacts.',
        src: `${imagePath$h}/gri2021-2.png`,
    },
    {
        code: 'gri_2021-3',
        name: 'GRI 3 - Material Topics 2021',
        officialCode: 'gri2021-3',
        colour: '#677538',
        description: 'GRI 2: GRI 3: Material Topics 2021 provides step-by-step guidance for organizations on how to determine material topics. It also explains how the Sector Standards are used in this process. Material topics are topics that represent an organizations most significant impacts on the economy, environment, and people, including impacts on their human rights.',
        src: `${imagePath$h}/gri2021-3.png`,
    },
    {
        code: 'gri_2021-101',
        name: 'GRI 101: Biodiversity',
        src: `${imagePath$h}/gri2021-101.png`,
        subgroups: [
            {
                code: 'gri_2021-101-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$h}/gri2021-101.png`,
            },
            {
                code: 'gri_2021-101-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$h}/gri2021-101.png`,
            },
        ],
    },
    {
        code: 'gri_2021-102',
        name: 'GRI 102: Climate Change',
        src: `${imagePath$h}/gri2021-102.png`,
        subgroups: [
            {
                code: 'gri_2021-102-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$h}/gri2021-102.png`,
            },
            {
                code: 'gri_2021-102-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$h}/gri2021-102.png`,
            },
        ],
    },
    {
        code: 'gri_2021-103',
        name: 'GRI 103: Energy',
        src: `${imagePath$h}/gri2021-103.png`,
        subgroups: [
            {
                code: 'gri_2021-103-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$h}/gri2021-103.png`,
            },
            {
                code: 'gri_2021-103-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$h}/gri2021-103.png`,
            },
        ],
    },
    {
        code: 'gri_2021-200',
        name: 'GRI 200: Economic',
        officialCode: 'gri2021-200',
        colour: '#8B6479',
        src: `${imagePath$h}/gri2021-200.png`,
        subgroups: [
            {
                code: 'gri_2021-2-201',
                name: 'GRI 201: Economic Performance',
                officialCode: 'gri2021-201',
                colour: '#8B6479',
                description: 'GRI 201: Economic Performance 2016 contains disclosures for organizations to report information about their economic performance-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-201.png`,
            },
            {
                code: 'gri_2021-2-202',
                name: 'GRI 202: Market Presence',
                officialCode: 'gri2021-202',
                colour: '#8B6479',
                description: 'GRI 202: Market Presence 2016 contains disclosures for organizations to report information about their market presence-related impacts and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-202.png`,
            },
            {
                code: 'gri_2021-2-203',
                name: 'GRI 203: Indirect economic impacts',
                officialCode: 'gri2021-203',
                colour: '#8B6479',
                description: 'GRI 203: Indirect Economic Impacts 2016 contains disclosures for organizations to report information about their indirect economic impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-203.png`,
            },
            {
                code: 'gri_2021-2-204',
                name: 'GRI 204: Procurement Practices',
                officialCode: 'gri2021-204',
                colour: '#8B6479',
                description: 'GRI 204: Procurement Practices 2016 contains disclosures for organizations to report information about their procurement practice-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-204.png`,
            },
            {
                code: 'gri_2021-2-205',
                name: 'GRI 205; Anti-corruption',
                officialCode: 'gri2021-205',
                colour: '#8B6479',
                description: 'GRI 205: Anti-corruption 2016 contains disclosures for organizations to report information about their corruption-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-205.png`,
            },
            {
                code: 'gri_2021-2-206',
                name: 'GRI 206; Anti-competitive Behaviour',
                officialCode: 'gri2021-206',
                colour: '#8B6479',
                description: 'GRI 206: Anti-competitive Behavior 2016 contains disclosures for organizations to report information about their anti-competitive behavior-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-206.png`,
            },
            {
                code: 'gri_2021-2-207',
                name: 'GRI 207; Tax',
                officialCode: 'gri2021-207',
                colour: '#8B6479',
                description: 'GRI 207: Tax 2019 contains disclosures for organizations to report information about their tax-related impacts, and how they manage these impacts. The disclosures enable an organization to provide information on how it manages tax, and information about its revenue, tax, and business activities on a country-by-country basis.',
                src: `${imagePath$h}/gri2021-207.png`,
            }
        ]
    },
    {
        code: 'gri_2021-300',
        name: 'GRI 300: Environmental',
        officialCode: 'gri2021-300',
        colour: '#8B6479',
        src: `${imagePath$h}/gri2021-300.png`,
        subgroups: [
            {
                code: 'gri_2021-3-301',
                name: 'GRI 301: Materials',
                officialCode: 'gri2021-301',
                colour: '#8B6479',
                description: 'GRI 301: Materials 2016 contains disclosures for organizations to report information about their materials-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-301.png`,
            },
            {
                code: 'gri_2021-3-302',
                name: 'GRI 302: Energy',
                officialCode: 'gri2021-302',
                colour: '#8B6479',
                description: 'GRI 302: Energy 2016 contains disclosures for organizations to report information about their energy-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-302.png`,
            },
            {
                code: 'gri_2021-3-303',
                name: 'GRI 303: Water and Effluents',
                officialCode: 'gri2021-303',
                colour: '#8B6479',
                description: 'GRI 303: Water and Effluents 2018 contains disclosures for organizations to report information about their water-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-303.png`,
            },
            {
                code: 'gri_2021-3-304',
                name: 'GRI 304: Biodiversity',
                officialCode: 'gri2021-304',
                colour: '#8B6479',
                description: 'GRI 304: Biodiversity 2016 contains disclosures for organizations to report information about their biodiversity-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-304.png`,
            },
            {
                code: 'gri_2021-3-305',
                name: 'GRI 305: Emissions',
                officialCode: 'gri2021-305',
                colour: '#8B6479',
                description: 'GRI 305: Emissions 2016 contains disclosures for organizations to report information about their emissions-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-305.png`,
            },
            {
                code: 'gri_2021-3-306',
                name: 'GRI 306: Waste',
                officialCode: 'gri2021-306',
                colour: '#8B6479',
                description: 'GRI 306: Waste 2020 contains disclosures for organizations to report information about their waste-related impacts, and how they manage these impacts. The disclosures enable an organization to provide information on how it prevents waste generation and how it manages waste that cannot be prevented, in its own activities and upstream and downstream in its value chain.',
                src: `${imagePath$h}/gri2021-306.png`,
            },
            {
                code: 'gri_2021-3-308',
                name: 'GRI 308: Supplier Environmental Assessment',
                officialCode: 'gri2021-308',
                colour: '#8B6479',
                description: 'GRI 308: Supplier Environmental Assessment 2016 contains disclosures for organizations to report information about their environmental impacts in their supply chain, and how they manage these impacts. The disclosures enable an organization to provide information on its approach to preventing and mitigating negative environmental impacts in its supply chain. ',
                src: `${imagePath$h}/gri2021-308.png`,
            }
        ]
    },
    {
        code: 'gri_2021-400',
        name: 'GRI 400: Social',
        officialCode: 'gri2021-400',
        colour: '#8B6479',
        src: `${imagePath$h}/gri2021-400.png`,
        subgroups: [
            {
                code: 'gri_2021-4-401',
                name: 'GRI 401: Employment',
                officialCode: 'gri2021-401',
                colour: '#8B6479',
                description: 'GRI 401: Employment 2016 contains disclosures for organizations to report information about their employment-related impacts, and how they manage these impacts. ',
                src: `${imagePath$h}/gri2021-401.png`,
            },
            {
                code: 'gri_2021-4-402',
                name: 'GRI 402: Labor/Management Relations',
                officialCode: 'gri2021-402',
                colour: '#8B6479',
                description: 'GRI 402: Labor/Management Relations 2016 contains disclosures for organizations to report information about their impacts related to labor/management relations, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-402.png`,
            },
            {
                code: 'gri_2021-4-403',
                name: 'GRI 403: Occupational Health and Safety',
                officialCode: 'gri2021-403',
                colour: '#8B6479',
                description: 'GRI 403: Occupational Health and Safety 2018 contains disclosures for organizations to report information about their occupational health and safety-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-403.png`,
            },
            {
                code: 'gri_2021-4-404',
                name: 'GRI 404: Training and Education',
                officialCode: 'gri2021-404',
                colour: '#8B6479',
                description: 'GRI 404: Training and Education 2016 contains disclosures for organizations to report information about their training and education-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-404.png`,
            },
            {
                code: 'gri_2021-4-405',
                name: 'GRI 405: Diversity and Equal Opportunities',
                officialCode: 'gri2021-405',
                colour: '#8B6479',
                description: 'GRI 405: Diversity and Equal Opportunity 2016 contains disclosures for organizations to report information about their impacts related to diversity and equal opportunity at work, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-405.png`,
            },
            {
                code: 'gri_2021-4-406',
                name: 'GRI 406: Non-discrimination',
                officialCode: 'gri2021-406',
                colour: '#8B6479',
                description: 'GRI 406: Non-discrimination 2016 contains disclosures for organizations to report information about their impacts related to discrimination, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-406.png`,
            },
            {
                code: 'gri_2021-4-407',
                name: 'GRI 407: Freedom of Association',
                officialCode: 'gri2021-407',
                colour: '#8B6479',
                description: 'GRI 407: GRI 407: Freedom of Association and Collective Bargaining 2016 contains disclosures for organizations to report information about their impacts related to freedom of association and collective bargaining, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-407.png`,
            },
            {
                code: 'gri_2021-4-408',
                name: 'GRI 408: Child Labor',
                officialCode: 'gri2021-408',
                colour: '#8B6479',
                description: 'GRI 408: Child Labor 2016 contains disclosures for organizations to report information about their impacts related to child labor, and how they manage these impacts. ',
                src: `${imagePath$h}/gri2021-408.png`,
            },
            {
                code: 'gri_2021-4-409',
                name: 'GRI 409: Forced or Compulsory Labor',
                officialCode: 'gri2021-409',
                colour: '#8B6479',
                description: 'GRI 409: Forced or Compulsory Labor 2016 contains disclosures for organizations to report information about their impacts related to forced or compulsory labor, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-409.png`,
            },
            {
                code: 'gri_2021-4-410',
                name: 'GRI 410; Security Practices',
                officialCode: 'gri2021-410',
                colour: '#8B6479',
                description: 'GRI 410: Security Practices 2016 contains disclosures for organizations to report information about their security practice-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-410.png`,
            },
            {
                code: 'gri_2021-4-411',
                name: 'GRI 411; Rights of Indigenous People',
                officialCode: 'gri2021-411',
                colour: '#8B6479',
                description: 'GRI 411: Rights of Indigenous Peoples 2016 contains disclosures for organizations to report information about their impacts related to the rights of indigenous peoples, and how they manage these impacts. ',
                src: `${imagePath$h}/gri2021-411.png`,
            },
            {
                code: 'gri_2021-4-413',
                name: 'GRI 413; Local Communities',
                officialCode: 'gri2021-413',
                colour: '#8B6479',
                description: 'GRI 413: Local Communities 2016 contains disclosures for organizations to report information about their impacts related to local communities, and how they manage these impacts. ',
                src: `${imagePath$h}/gri2021-413.png`,
            },
            {
                code: 'gri_2021-4-414',
                name: 'GRI 414: Supplier Social Assessment',
                officialCode: 'gri2021-414',
                colour: '#8B6479',
                description: 'GRI 414: Supplier Social Assessment 2016 contains disclosures for organizations to report information about their social impacts in their supply chain, and how they manage these impacts. The disclosures enable an organization to provide information on its approach to preventing and mitigating negative social impacts in its supply chain.',
                src: `${imagePath$h}/gri2021-414.png`,
            },
            {
                code: 'gri_2021-4-415',
                name: 'GRI 415: Public Policy',
                officialCode: 'gri2021-415',
                colour: '#8B6479',
                description: 'GRI 415: Public Policy 2016 contains disclosures for organizations to report information about their public policy-related impacts, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-415.png`,
            },
            {
                code: 'gri_2021-4-416',
                name: 'GRI 416: Customer Health and Safety',
                officialCode: 'gri2021-416',
                colour: '#8B6479',
                description: 'GRI 416: Customer Health and Safety 2016 contains disclosures for organizations to report information about their impacts related to customer health and safety, and how they manage these impacts. ',
                src: `${imagePath$h}/gri2021-416.png`,
            },
            {
                code: 'gri_2021-4-417',
                name: 'GRI 417: Marketing and Labelling',
                officialCode: 'gri2021-417',
                colour: '#8B6479',
                description: 'GRI 417: Marketing and Labeling 2016 contains disclosures for organizations to report information about their impacts related to marketing and labeling, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-417.png`,
            },
            {
                code: 'gri_2021-4-418',
                name: 'GRI 418; Customer Privacy',
                officialCode: 'gri2021-418',
                colour: '#8B6479',
                description: 'GRI 418: Customer Privacy 2016 contains disclosures for organizations to report information about their impacts related to customer privacy, and how they manage these impacts.',
                src: `${imagePath$h}/gri2021-418.png`,
            }
        ]
    },
    {
        code: 'gri_2021-11',
        name: 'GRI 11: Oil and Gas Sector',
        officialCode: 'gri11-Oil&Gas',
        colour: '#8B6479',
        description: 'GRI 11: Oil and Gas Sector 2021 provides information for organizations in the oil and gas sector about their likely material topics. These topics are likely to be material for organizations in the oil and gas sector on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights. ',
        src: `${imagePath$h}/gri2021-s11.png`,
        subgroups: [
            {
                code: 'gri_2021-11-1',
                name: 'Topic 11.1 GHG emissions',
                officialCode: 'gri11-Oil&Gas-1',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change, such as carbon dioxide (CO ) and methane (CH ). This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-2',
                name: 'Topic 11.2 Climate adaptation, resilience, and transition',
                officialCode: 'gri11-Oil&Gas-2',
                colour: '#8B6479',
                description: 'Climate adaptation, resilience, and transition refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change. This topic covers an organization’s strategy in relation to the transition to a low-carbon economy and the impacts of that transition on workers and local communities.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-3',
                name: 'Topic 11.3 Air emissions',
                officialCode: 'gri11-Oil&Gas-3',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SO ), nitrogen oxides (NO ), particulate matter (PM), volatile organic compounds (VOC), carbon monoxide (CO), and heavy metals, such as lead, mercury, and cadmium.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-4',
                name: 'Topic 11.4 Biodiversity',
                officialCode: 'gri11-Oil&Gas-4',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity and natural ecosystems.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-5',
                name: 'Topic 11.5 Waste',
                officialCode: 'gri11-Oil&Gas-5',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste, including as a result of construction and rehabilitation activities.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-6',
                name: 'Topic 11.6 Water and effluents',
                officialCode: 'gri11-Oil&Gas-6',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-7',
                name: 'Topic 11.7 Closure and rehabilitation',
                officialCode: 'gri11-Oil&Gas-7',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-8',
                name: 'Topic 11.8 Asset integrity and critical incident management',
                officialCode: 'gri11-Oil&Gas-8',
                colour: '#8B6479',
                description: 'Asset integrity and critical incident management deal with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-9',
                name: 'Topic 11.9 Occupational health and safety',
                officialCode: 'gri11-Oil&Gas-9',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-10',
                name: 'Topic 11.10 Employment practices',
                officialCode: 'gri11-Oil&Gas-10',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain. ',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-11',
                name: 'Topic 11.11 Non-discrimination and equal opportunity',
                officialCode: 'gri11-Oil&Gas-11',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-12',
                name: 'Topic 11.12 Forced labor and modern slavery',
                officialCode: 'gri11-Oil&Gas-12',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-13',
                name: 'Topic 11.13 Freedom of association and collective bargaining',
                officialCode: 'gri11-Oil&Gas-13',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-14',
                name: 'Topic 11.14 Economic impacts',
                officialCode: 'gri11-Oil&Gas-14',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems. For example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-15',
                name: 'Topic 11.15 Local Communities',
                officialCode: 'gri11-Oil&Gas-15',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-16',
                name: 'Topic 11.16 Land and resource rights',
                officialCode: 'gri11-Oil&Gas-16',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-17',
                name: 'Topic 11.17 Rights of indigenous peoples',
                officialCode: 'gri11-Oil&Gas-17',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-18',
                name: 'Topic 11.18 Conflict and security',
                officialCode: 'gri11-Oil&Gas-18',
                colour: '#8B6479',
                description: 'An organization’s activities may trigger conflict or, in cases of existing conflict, intensify it. The use of security personnel to manage conflict can play an essential role in allowing an organization to operate safely and productively but also has the potential to impact on people’s human rights. This topic covers the organization\'s security practices and its approach to operating in areas of conflict.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-19',
                name: 'Topic 11.19 Anti-competitive behavior',
                officialCode: 'gri11-Oil&Gas-19',
                colour: '#8B6479',
                description: 'Anti-competitive behavior refers to actions by an organization that can result in collusion with potential competitors, abuse of dominant market position or exclusion of potential competitors, thereby limiting the effects of market competition. This can include fixing prices or coordinating bids, creating market or output restrictions, imposing geographic quotas, and allocating customers, suppliers, geographic areas, or product lines. This topic covers impacts as a result of anti-competitive behavior.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-20',
                name: 'Topic 11.20 Anti-corruption',
                officialCode: 'gri11-Oil&Gas-20',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-21',
                name: 'Topic 11.21 Payments to governments',
                officialCode: 'gri11-Oil&Gas-21',
                colour: '#8B6479',
                description: 'Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization\'s practices related to payments to governments and the organization’s approach to transparency of such payments.',
                src: `${imagePath$h}/gri2021-s11.png`,
            },
            {
                code: 'gri_2021-11-22',
                name: 'Topic 11.22 Public policy',
                officialCode: 'gri11-Oil&Gas-22',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy, and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$h}/gri2021-s11.png`,
            }
        ]
    },
    {
        code: 'gri_2021-12',
        name: 'GRI 12: Coal Sector',
        officialCode: 'gri12-Coal',
        colour: '#8B6479',
        description: 'GRI 12: Coal Sector 2022 provides information for organizations in the coal sector about their likely material topics. These topics are likely to be material for organizations in the coal sector on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights. ',
        src: `${imagePath$h}/gri2021-s12.png`,
        subgroups: [
            {
                code: 'gri_2021-12-1',
                name: 'Topic 12.1 GHG emissions',
                officialCode: 'gri12-coal-1',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change, such as carbon dioxide (CO2) and methane (CH4). This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-2',
                name: 'Topic 12.2 Climate adaptation, resilience, and transition',
                officialCode: 'gri12-coal-2',
                colour: '#8B6479',
                description: 'Climate adaptation, resilience, and transition refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change. This topic covers an organization’s strategy in relation to the transition to a low-carbon economy and the impacts of that transition on workers and local communities.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-3',
                name: 'Topic 12.3 Closure and rehabilitation',
                officialCode: 'gri12-coal-3',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-4',
                name: 'Topic 12.4 Air emissions',
                officialCode: 'gri12-coal-4',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SOx), nitrogen oxides (NOx), particulate matter (PM), volatile organic compounds (VOC), carbon monoxide (CO), and heavy metals, such as lead, mercury, and cadmium.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-5',
                name: 'Topic 12.5 Biodiversity',
                officialCode: 'gri12-coal-5',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity, and natural ecosystems.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-6',
                name: 'Topic 12.6 Waste',
                officialCode: 'gri12-coal-6',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste, including as a result of construction and rehabilitation activities.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-7',
                name: 'Topic 12.7 Water and effluents',
                officialCode: 'gri12-coal-7',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-8',
                name: 'Topic 12.8 Economic impacts',
                officialCode: 'gri12-coal-8',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems, for example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-9',
                name: 'Topic 12.9 Local communities',
                officialCode: 'gri12-coal-9',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization\'s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-10',
                name: 'Topic 12.10 Land and resource rights',
                officialCode: 'gri12-coal-10',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-11',
                name: 'Topic 12.11 Rights of indigenous peoples',
                officialCode: 'gri12-coal-11',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-12',
                name: 'Topic 12.12 Conflict and security',
                officialCode: 'gri12-coal-12',
                colour: '#8B6479',
                description: 'An organization’s activities may trigger conflict or, in cases of existing conflict, intensify it. The use of security personnel to manage conflict can play an essential role in allowing an organization to operate safely and productively but also has the potential to impact on people’s human rights. This topic covers the organization\'s security practices and its approach to operating in areas of conflict.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-13',
                name: 'Topic 12.13 Asset integrity and critical incident management',
                officialCode: 'gri12-coal-13',
                colour: '#8B6479',
                description: 'Asset integrity and critical incident management deal with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-14',
                name: 'Topic 12.14 Occupational health and safety',
                officialCode: 'gri12-coal-14',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-15',
                name: 'Topic 12.15 Employment practices',
                officialCode: 'gri12-coal-15',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-16',
                name: 'Topic 12.16 Child labor',
                officialCode: 'gri12-coal-16',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-17',
                name: 'Topic 12.17 Forced labor and modern slavery',
                officialCode: 'gri12-coal-17',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-18',
                name: 'Topic 12.18 Freedom of association and collective bargaining',
                officialCode: 'gri12-coal-18',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-19',
                name: 'Topic 12.19 Non-discrimination and equal opportunity',
                officialCode: 'gri12-coal-19',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-20',
                name: 'Topic 12.20 Anti-corruption',
                officialCode: 'gri12-coal-20',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-21',
                name: 'Topic 12.21 Payments to governments',
                officialCode: 'gri12-coal-21',
                colour: '#8B6479',
                description: 'Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization\'s practices related to payments to governments and the organization’s approach to transparency of such payments.',
                src: `${imagePath$h}/gri2021-s12.png`,
            },
            {
                code: 'gri_2021-12-22',
                name: 'Topic 12.22 Public policy',
                officialCode: 'gri12-coal-22',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$h}/gri2021-s12.png`,
            }
        ]
    },
    {
        code: 'gri_2021-13',
        name: 'GRI 13: Agriculture, Aquaculture and Fishing Sector',
        officialCode: 'gri13-Agriculture',
        colour: '#8B6479',
        description: 'GRI 13: Agriculture, Aquaculture and Fishing Sectors 2022 provides information for organizations in the agriculture, aquaculture, and fishing sectors about their likely material topics. These topics are likely to be material for organizations in the sectors on the basis of the sectors’ most significant impacts on the economy, environment, and people, including on their human rights.',
        src: `${imagePath$h}/gri2021-s13.png`,
        subgroups: [
            {
                code: 'gri_2021-13-1',
                name: 'Topic 13.1 Emissions',
                officialCode: 'gri13-agriculture-1',
                colour: '#8B6479',
                description: 'This topic addresses emissions into the air, including greenhouse gas (GHG), ozone-depleting substances (ODS), nitrogen oxides (NOX), sulfur oxides (SOX), and other significant air emissions regarded as pollutants. Emissions can have negative impacts on air quality, ecosystems, and on human and animal health. GHG emissions are also a major contributor to climate change.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-2',
                name: 'Topic 13.2 Climate adaptation and resilience',
                officialCode: 'gri13-agriculture-2',
                colour: '#8B6479',
                description: 'Organizations contribute to climate change and are simultaneously affected by it. Climate adaptation and resilience refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-3',
                name: 'Topic 13.3 Biodiversity',
                officialCode: 'gri13-agriculture-3',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity, and natural ecosystems.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-4',
                name: 'Topic 13.4 Natural ecosystem conversion',
                officialCode: 'gri13-agriculture-4',
                colour: '#8B6479',
                description: 'Natural ecosystem conversion refers to changing a natural ecosystem to another use or a profound change in a natural ecosystem’s species composition, structure, or function. This topic covers impacts related to natural ecosystem conversion, including discrete incidents of land clearance, severe degradation, or the introduction of practices that lead to substantial and sustained change in natural ecosystems.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-5',
                name: 'Topic 13.5 Soil health',
                officialCode: 'gri13-agriculture-5',
                colour: '#8B6479',
                description: 'Soil health is the capacity of soil to function as a living ecosystem and to sustain plant and animal productivity, promote plant and animal health, and maintain or enhance water and air quality. This topic covers impacts on soil health, including soil erosion, soil loss, and reduction in soil fertility.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-6',
                name: 'Topic 13.6 Pesticides use',
                officialCode: 'gri13-agriculture-6',
                colour: '#8B6479',
                description: 'Pesticides are chemical or biological substances intended to regulate plant growth or control, repel, or destroy any pest. This topic covers an organization’s approach and impacts related to pesticides use, including the impact of their toxicity on non-target organisms.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-7',
                name: 'Topic 13.7 Water and effluents',
                officialCode: 'gri13-agriculture-7',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-8',
                name: 'Topic 13.8 Waste',
                officialCode: 'gri13-agriculture-8',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste and the management of waste.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-9',
                name: 'Topic 13.9 Food security',
                officialCode: 'gri13-agriculture-9',
                colour: '#8B6479',
                description: 'Food security means that people have physical and economic access to sufficient, safe, and nutritious food that is acceptable within a given culture and meets people’s dietary needs and food preferences for an active and healthy life. Adequate food is a human right and is crucial to the enjoyment of all rights. This topic covers impacts on the dimensions of food security.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-10',
                name: 'Topic 13.10 Food safety',
                officialCode: 'gri13-agriculture-10',
                colour: '#8B6479',
                description: 'Food safety concerns the handling of food and feed products in a way that prevents food contamination and food-borne illness. This topic addresses an organization’s efforts to prevent contamination and ensure food safety.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-11',
                name: 'Topic 13.11 Animal health and welfare',
                officialCode: 'gri13-agriculture-11',
                colour: '#8B6479',
                description: 'Animal health and welfare refers to an animal\'s physical and mental state in relation to the conditions in which it lives and dies. The ‘Five Freedoms’ of animal welfare are freedom from hunger and thirst; freedom from discomfort; freedom from pain, injury, and disease; freedom to express normal behavior; and freedom from fear and distress. This topic covers impacts on animal health and the five freedoms of animal welfare.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-12',
                name: 'Topic 13.12 Local communities',
                officialCode: 'gri13-agriculture-12',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-13',
                name: 'Topic 13.13 Land and resource rights',
                officialCode: 'gri13-agriculture-13',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts on human rights and tenure rights that result from an organization’s use of land and natural resources.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-14',
                name: 'Topic 13.14 Rights of indigenous peoples',
                officialCode: 'gri13-agriculture-14',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-15',
                name: 'Topic 13.15 Non-discrimination and equal opportunity',
                officialCode: 'gri13-agriculture-15',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and an organization’s practices related to equal opportunity.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-16',
                name: 'Topic 13.16 Forced or compulsory labor',
                officialCode: 'gri13-agriculture-16',
                colour: '#8B6479',
                description: 'Forced or compulsory labor is work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-17',
                name: 'Topic 13.17 Child labor',
                officialCode: 'gri13-agriculture-17',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-18',
                name: 'Topic 13.18 Freedom of association and collective bargaining',
                officialCode: 'gri13-agriculture-18',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-19',
                name: 'Topic 13.19 Occupational health and safety',
                officialCode: 'gri13-agriculture-19',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-20',
                name: 'Topic 13.20 Employment practices',
                officialCode: 'gri13-agriculture-20',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-21',
                name: 'Topic 13.21 Living income and living wage',
                officialCode: 'gri13-agriculture-21',
                colour: '#8B6479',
                description: 'Living income and living wage refer to such level of income or wage which is sufficient to afford a decent standard of living for all household members, including nutritious food, clean water, housing, education, healthcare, and other essential needs, such as provision for unexpected events. This topic covers the organization’s approach to worker compensation in the context of whether it provides for living income or living wage.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-22',
                name: 'Topic 13.22 Economic inclusion',
                officialCode: 'gri13-agriculture-22',
                colour: '#8B6479',
                description: 'Economic inclusion concerns an organization’s impacts on access to economic opportunities for local communities and the productive potential of actual and possible suppliers. This topic covers an organization’s approach to economic inclusion of farmers and fishers, and their communities.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-23',
                name: 'Topic 13.23 Supply chain traceability',
                officialCode: 'gri13-agriculture-23',
                colour: '#8B6479',
                description: 'Traceability is the ability to trace the source, origin, or production conditions of raw materials and final products. Traceability provides a way to identify and prevent potential negative impacts linked to an organization’s products. This topic covers an organization’s approach to supply chain traceability.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-24',
                name: 'Topic 13.24 Public policy',
                officialCode: 'gri13-agriculture-24',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage public policy development that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from an organization\'s influence.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-25',
                name: 'Topic 13.25 Anti-competitive behavior',
                officialCode: 'gri13-agriculture-25',
                colour: '#8B6479',
                description: 'Anti-competitive behavior refers to actions by an organization that can result in collusion with potential competitors, abuse of dominant market position or exclusion of potential competitors, thereby limiting the effects of market competition. This can include fixing prices or coordinating bids, creating market or output restrictions, imposing geographic quotas, and allocating customers, suppliers, geographic areas, or product lines. This topic covers impacts as a result of anti-competitive behavior.',
                src: `${imagePath$h}/gri2021-s13.png`,
            },
            {
                code: 'gri_2021-13-26',
                name: 'Topic 13.26 Anti-corruption',
                officialCode: 'gri13-agriculture-26',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers the potential for corruption to occur and the related impacts.',
                src: `${imagePath$h}/gri2021-s13.png`,
            }
        ]
    },
    {
        code: 'gri_2021-14',
        name: 'GRI 14: Mining Sector',
        officialCode: 'gri14-Mining',
        colour: '#8B6479',
        description: 'GRI 14: Mining Sector 2024 provides information for organizations involved in mining activities about their likely material topics. These topics are likely to be material for mining organizations on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights.',
        src: `${imagePath$h}/gri2021-s14.png`,
        subgroups: [
            {
                code: 'gri_2021-14-1',
                name: 'Topic 14.1 GHG emissions',
                officialCode: 'gri14-mining-1',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change. This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-2',
                name: 'Topic 14.2 Climate adaptation and resilience',
                officialCode: 'gri14-mining-2',
                colour: '#8B6479',
                description: 'Organizations contribute to climate change and are simultaneously affected by it. Climate adaptation and resilience refer to how an organization adjusts to current and anticipated climate change-related risks,',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-3',
                name: 'Topic 14.3 Air emissions ',
                officialCode: 'gri14-mining-3',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SOx), nitrogen oxides (NOx), particulate matter (PM), volatile organic compounds (VOCs), carbon monoxide (CO), and heavy metals, such as mercury (Hg).',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-4',
                name: 'Topic 14.4 Biodiversity',
                officialCode: 'gri14-mining-4',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species, and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on genetic diversity, animal and plant species, and natural ecosystems.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-5',
                name: 'Topic 14.5 Waste',
                officialCode: 'gri14-mining-5',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste and the management of waste.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-6',
                name: 'Topic 14.6 Tailings',
                officialCode: 'gri14-mining-6',
                colour: '#8B6479',
                description: 'Tailings are a by-product of mining that need management throughout the life of a mine and beyond closure. Poor design or management of tailings facilities can, at worst, lead to catastrophic failures with lasting impacts on workers, local communities, and damage to the environment, natural resources, and infrastructure.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-7',
                name: 'Topic 14.7 Water and effluents',
                officialCode: 'gri14-mining-7',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-8',
                name: 'Topic 14.8 Closure and rehabilitation',
                officialCode: 'gri14-mining-8',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-9',
                name: 'Topic 14.9 Economic impacts',
                officialCode: 'gri14-mining-9',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems, for example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-10',
                name: 'Topic 14.10 Local communities',
                officialCode: 'gri14-mining-10',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities and priorities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-11',
                name: 'Topic 14.11 Rights of Indigenous Peoples',
                officialCode: 'gri14-mining-11',
                colour: '#8B6479',
                description: 'Indigenous Peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous Peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of Indigenous Peoples.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-12',
                name: 'Topic 14.12 Land and resource rights',
                officialCode: 'gri14-mining-12',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-13',
                name: 'Topic 14.13 Artisanal and small-scale mining',
                officialCode: 'gri14-mining-13',
                colour: '#8B6479',
                description: 'Artisanal and small-scale mining (ASM) refers to mining by individuals, families, or cooperatives with minimal or no mechanization and often operating informally. ASM occurs throughout the world, but is particularly widespread in developing countries where it is an important source of income and livelihood. This topic covers impacts of mining organizations on ASM operators, and impacts mining organizations may be involved with through their business relationships, interactions, or co-location with ASM.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-14',
                name: 'Topic 14.14 Security practices',
                officialCode: 'gri14-mining-14',
                colour: '#8B6479',
                description: 'The use of security personnel can play an essential role in allowing an organization to operate safely and productively, but also has the potential to lead to human rights violations. This topic covers impacts as a result of the use or presence of security personnel.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-15',
                name: 'Topic 14.15 Critical incident management',
                officialCode: 'gri14-mining-15',
                colour: '#8B6479',
                description: 'Critical incident management deals with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-16',
                name: 'Topic 14.16 Occupational health and safety',
                officialCode: 'gri14-mining-16',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-17',
                name: 'Topic 14.17 Employment practices',
                officialCode: 'ggri14-mining-17',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment, and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-18',
                name: 'Topic 14.18 Child labor',
                officialCode: 'gri14-mining-18',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-19',
                name: 'Topic 14.19 Forced labor and modern slavery',
                officialCode: 'gri14-mining-19',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-20',
                name: 'Topic 14.20 Freedom of association and collective bargaining',
                officialCode: 'gri14-mining-20',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-21',
                name: 'Topic 14.21 Non-discrimination and equal opportunity',
                officialCode: 'gri14-mining-21',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-22',
                name: 'Topic 14.22 Anti-corruption',
                officialCode: 'gri14-mining-22',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-23',
                name: 'Topic 14.23 Payments to governments',
                officialCode: 'gri14-mining-23',
                colour: '#8B6479',
                description: "Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization's practices related to payments to governments and the organization’s approach to transparency of such payments.",
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-24',
                name: 'Topic 14.24 Public policy',
                officialCode: 'gri14-mining-24',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
            {
                code: 'gri_2021-14-25',
                name: 'Topic 14.25 Conflict-affected and high-risk areas',
                officialCode: 'gri14-mining-25',
                colour: '#8B6479',
                description: 'When operating in or sourcing from conflict-affected and high-risk areas, organizations are more likely to be involved in human rights and legal violations and be implicated in corruption and financial flows contributing to conflict. This topic covers an organization’s approach and impacts related to operating in or sourcing from conflict-affected and high-risk areas.',
                src: `${imagePath$h}/gri2021-s14.png`,
            },
        ],
    },
];

/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */
const imagePath$g = config.imagePath;
// The GRI 2021 tree minus withdrawn standards: GRI 102 and GRI 103 replace GRI 302 and GRI 305-1 to 305-5
// (305-6 and 305-7 stay), and GRI 101 replaced GRI 304 in 2026. GRI published no 2025 official codes.
const gri2025Group = [
    {
        code: 'gri_2025-1',
        name: 'GRI 1 - Foundation 2021',
        colour: '#677538',
        description: 'GRI 1: Foundation 2021 introduces the purpose and system of the GRI Sustainability Reporting Standards (GRI Standards) and explains key concepts for sustainability reporting. It also specifies the requirements and reporting principles that organizations must comply with to report in accordance with the GRI Standards.',
        src: `${imagePath$g}/gri2021-1.png`,
    },
    {
        code: 'gri_2025-2',
        name: 'GRI 2 - General Disclosures 2021',
        colour: '#677538',
        description: 'GRI 2: General Disclosures 2021 contains disclosures for organizations to provide information about their reporting practices; activities and workers; governance; strategy, policies, and practices; and stakeholder engagement. This information gives insight into the profile and scale of organizations and provides a context for understanding their impacts.',
        src: `${imagePath$g}/gri2021-2.png`,
    },
    {
        code: 'gri_2025-3',
        name: 'GRI 3 - Material Topics 2021',
        colour: '#677538',
        description: 'GRI 2: GRI 3: Material Topics 2021 provides step-by-step guidance for organizations on how to determine material topics. It also explains how the Sector Standards are used in this process. Material topics are topics that represent an organizations most significant impacts on the economy, environment, and people, including impacts on their human rights.',
        src: `${imagePath$g}/gri2021-3.png`,
    },
    {
        code: 'gri_2025-101',
        name: 'GRI 101: Biodiversity',
        src: `${imagePath$g}/gri2021-101.png`,
        subgroups: [
            {
                code: 'gri_2025-101-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$g}/gri2021-101.png`,
            },
            {
                code: 'gri_2025-101-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$g}/gri2021-101.png`,
            },
        ],
    },
    {
        code: 'gri_2025-102',
        name: 'GRI 102: Climate Change 2025',
        src: `${imagePath$g}/gri2021-102.png`,
        subgroups: [
            {
                code: 'gri_2025-102-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$g}/gri2021-102.png`,
            },
            {
                code: 'gri_2025-102-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$g}/gri2021-102.png`,
            },
        ],
    },
    {
        code: 'gri_2025-103',
        name: 'GRI 103: Energy 2025',
        src: `${imagePath$g}/gri2021-103.png`,
        subgroups: [
            {
                code: 'gri_2025-103-manage',
                name: '1. Topic Management Disclosures',
                src: `${imagePath$g}/gri2021-103.png`,
            },
            {
                code: 'gri_2025-103-disclose',
                name: '2. Topic Disclosures',
                src: `${imagePath$g}/gri2021-103.png`,
            },
        ],
    },
    {
        code: 'gri_2025-200',
        name: 'GRI 200: Economic',
        colour: '#8B6479',
        src: `${imagePath$g}/gri2021-200.png`,
        subgroups: [
            {
                code: 'gri_2025-2-201',
                name: 'GRI 201: Economic Performance',
                colour: '#8B6479',
                description: 'GRI 201: Economic Performance 2016 contains disclosures for organizations to report information about their economic performance-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-201.png`,
            },
            {
                code: 'gri_2025-2-202',
                name: 'GRI 202: Market Presence',
                colour: '#8B6479',
                description: 'GRI 202: Market Presence 2016 contains disclosures for organizations to report information about their market presence-related impacts and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-202.png`,
            },
            {
                code: 'gri_2025-2-203',
                name: 'GRI 203: Indirect economic impacts',
                colour: '#8B6479',
                description: 'GRI 203: Indirect Economic Impacts 2016 contains disclosures for organizations to report information about their indirect economic impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-203.png`,
            },
            {
                code: 'gri_2025-2-204',
                name: 'GRI 204: Procurement Practices',
                colour: '#8B6479',
                description: 'GRI 204: Procurement Practices 2016 contains disclosures for organizations to report information about their procurement practice-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-204.png`,
            },
            {
                code: 'gri_2025-2-205',
                name: 'GRI 205; Anti-corruption',
                colour: '#8B6479',
                description: 'GRI 205: Anti-corruption 2016 contains disclosures for organizations to report information about their corruption-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-205.png`,
            },
            {
                code: 'gri_2025-2-206',
                name: 'GRI 206; Anti-competitive Behaviour',
                colour: '#8B6479',
                description: 'GRI 206: Anti-competitive Behavior 2016 contains disclosures for organizations to report information about their anti-competitive behavior-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-206.png`,
            },
            {
                code: 'gri_2025-2-207',
                name: 'GRI 207; Tax',
                colour: '#8B6479',
                description: 'GRI 207: Tax 2019 contains disclosures for organizations to report information about their tax-related impacts, and how they manage these impacts. The disclosures enable an organization to provide information on how it manages tax, and information about its revenue, tax, and business activities on a country-by-country basis.',
                src: `${imagePath$g}/gri2021-207.png`,
            },
        ],
    },
    {
        code: 'gri_2025-300',
        name: 'GRI 300: Environmental',
        colour: '#8B6479',
        src: `${imagePath$g}/gri2021-300.png`,
        subgroups: [
            {
                code: 'gri_2025-3-301',
                name: 'GRI 301: Materials',
                colour: '#8B6479',
                description: 'GRI 301: Materials 2016 contains disclosures for organizations to report information about their materials-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-301.png`,
            },
            {
                code: 'gri_2025-3-303',
                name: 'GRI 303: Water and Effluents',
                colour: '#8B6479',
                description: 'GRI 303: Water and Effluents 2018 contains disclosures for organizations to report information about their water-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-303.png`,
            },
            {
                code: 'gri_2025-3-305',
                name: 'GRI 305: Emissions',
                colour: '#8B6479',
                description: 'GRI 305-6 (ozone-depleting substances) and 305-7 (NOx, SOx and other significant air emissions), which GRI 102 does not replace.',
                src: `${imagePath$g}/gri2021-305.png`,
            },
            {
                code: 'gri_2025-3-306',
                name: 'GRI 306: Waste',
                colour: '#8B6479',
                description: 'GRI 306: Waste 2020 contains disclosures for organizations to report information about their waste-related impacts, and how they manage these impacts. The disclosures enable an organization to provide information on how it prevents waste generation and how it manages waste that cannot be prevented, in its own activities and upstream and downstream in its value chain.',
                src: `${imagePath$g}/gri2021-306.png`,
            },
            {
                code: 'gri_2025-3-308',
                name: 'GRI 308: Supplier Environmental Assessment',
                colour: '#8B6479',
                description: 'GRI 308: Supplier Environmental Assessment 2016 contains disclosures for organizations to report information about their environmental impacts in their supply chain, and how they manage these impacts. The disclosures enable an organization to provide information on its approach to preventing and mitigating negative environmental impacts in its supply chain. ',
                src: `${imagePath$g}/gri2021-308.png`,
            },
        ],
    },
    {
        code: 'gri_2025-400',
        name: 'GRI 400: Social',
        colour: '#8B6479',
        src: `${imagePath$g}/gri2021-400.png`,
        subgroups: [
            {
                code: 'gri_2025-4-401',
                name: 'GRI 401: Employment',
                colour: '#8B6479',
                description: 'GRI 401: Employment 2016 contains disclosures for organizations to report information about their employment-related impacts, and how they manage these impacts. ',
                src: `${imagePath$g}/gri2021-401.png`,
            },
            {
                code: 'gri_2025-4-402',
                name: 'GRI 402: Labor/Management Relations',
                colour: '#8B6479',
                description: 'GRI 402: Labor/Management Relations 2016 contains disclosures for organizations to report information about their impacts related to labor/management relations, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-402.png`,
            },
            {
                code: 'gri_2025-4-403',
                name: 'GRI 403: Occupational Health and Safety',
                colour: '#8B6479',
                description: 'GRI 403: Occupational Health and Safety 2018 contains disclosures for organizations to report information about their occupational health and safety-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-403.png`,
            },
            {
                code: 'gri_2025-4-404',
                name: 'GRI 404: Training and Education',
                colour: '#8B6479',
                description: 'GRI 404: Training and Education 2016 contains disclosures for organizations to report information about their training and education-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-404.png`,
            },
            {
                code: 'gri_2025-4-405',
                name: 'GRI 405: Diversity and Equal Opportunities',
                colour: '#8B6479',
                description: 'GRI 405: Diversity and Equal Opportunity 2016 contains disclosures for organizations to report information about their impacts related to diversity and equal opportunity at work, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-405.png`,
            },
            {
                code: 'gri_2025-4-406',
                name: 'GRI 406: Non-discrimination',
                colour: '#8B6479',
                description: 'GRI 406: Non-discrimination 2016 contains disclosures for organizations to report information about their impacts related to discrimination, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-406.png`,
            },
            {
                code: 'gri_2025-4-407',
                name: 'GRI 407: Freedom of Association',
                colour: '#8B6479',
                description: 'GRI 407: GRI 407: Freedom of Association and Collective Bargaining 2016 contains disclosures for organizations to report information about their impacts related to freedom of association and collective bargaining, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-407.png`,
            },
            {
                code: 'gri_2025-4-408',
                name: 'GRI 408: Child Labor',
                colour: '#8B6479',
                description: 'GRI 408: Child Labor 2016 contains disclosures for organizations to report information about their impacts related to child labor, and how they manage these impacts. ',
                src: `${imagePath$g}/gri2021-408.png`,
            },
            {
                code: 'gri_2025-4-409',
                name: 'GRI 409: Forced or Compulsory Labor',
                colour: '#8B6479',
                description: 'GRI 409: Forced or Compulsory Labor 2016 contains disclosures for organizations to report information about their impacts related to forced or compulsory labor, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-409.png`,
            },
            {
                code: 'gri_2025-4-410',
                name: 'GRI 410; Security Practices',
                colour: '#8B6479',
                description: 'GRI 410: Security Practices 2016 contains disclosures for organizations to report information about their security practice-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-410.png`,
            },
            {
                code: 'gri_2025-4-411',
                name: 'GRI 411; Rights of Indigenous People',
                colour: '#8B6479',
                description: 'GRI 411: Rights of Indigenous Peoples 2016 contains disclosures for organizations to report information about their impacts related to the rights of indigenous peoples, and how they manage these impacts. ',
                src: `${imagePath$g}/gri2021-411.png`,
            },
            {
                code: 'gri_2025-4-413',
                name: 'GRI 413; Local Communities',
                colour: '#8B6479',
                description: 'GRI 413: Local Communities 2016 contains disclosures for organizations to report information about their impacts related to local communities, and how they manage these impacts. ',
                src: `${imagePath$g}/gri2021-413.png`,
            },
            {
                code: 'gri_2025-4-414',
                name: 'GRI 414: Supplier Social Assessment',
                colour: '#8B6479',
                description: 'GRI 414: Supplier Social Assessment 2016 contains disclosures for organizations to report information about their social impacts in their supply chain, and how they manage these impacts. The disclosures enable an organization to provide information on its approach to preventing and mitigating negative social impacts in its supply chain.',
                src: `${imagePath$g}/gri2021-414.png`,
            },
            {
                code: 'gri_2025-4-415',
                name: 'GRI 415: Public Policy',
                colour: '#8B6479',
                description: 'GRI 415: Public Policy 2016 contains disclosures for organizations to report information about their public policy-related impacts, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-415.png`,
            },
            {
                code: 'gri_2025-4-416',
                name: 'GRI 416: Customer Health and Safety',
                colour: '#8B6479',
                description: 'GRI 416: Customer Health and Safety 2016 contains disclosures for organizations to report information about their impacts related to customer health and safety, and how they manage these impacts. ',
                src: `${imagePath$g}/gri2021-416.png`,
            },
            {
                code: 'gri_2025-4-417',
                name: 'GRI 417: Marketing and Labelling',
                colour: '#8B6479',
                description: 'GRI 417: Marketing and Labeling 2016 contains disclosures for organizations to report information about their impacts related to marketing and labeling, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-417.png`,
            },
            {
                code: 'gri_2025-4-418',
                name: 'GRI 418; Customer Privacy',
                colour: '#8B6479',
                description: 'GRI 418: Customer Privacy 2016 contains disclosures for organizations to report information about their impacts related to customer privacy, and how they manage these impacts.',
                src: `${imagePath$g}/gri2021-418.png`,
            },
        ],
    },
    {
        code: 'gri_2025-11',
        name: 'GRI 11: Oil and Gas Sector',
        colour: '#8B6479',
        description: 'GRI 11: Oil and Gas Sector 2021 provides information for organizations in the oil and gas sector about their likely material topics. These topics are likely to be material for organizations in the oil and gas sector on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights. ',
        src: `${imagePath$g}/gri2021-s11.png`,
        subgroups: [
            {
                code: 'gri_2025-11-1',
                name: 'Topic 11.1 GHG emissions',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change, such as carbon dioxide (CO ) and methane (CH ). This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-2',
                name: 'Topic 11.2 Climate adaptation, resilience, and transition',
                colour: '#8B6479',
                description: 'Climate adaptation, resilience, and transition refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change. This topic covers an organization’s strategy in relation to the transition to a low-carbon economy and the impacts of that transition on workers and local communities.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-3',
                name: 'Topic 11.3 Air emissions',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SO ), nitrogen oxides (NO ), particulate matter (PM), volatile organic compounds (VOC), carbon monoxide (CO), and heavy metals, such as lead, mercury, and cadmium.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-4',
                name: 'Topic 11.4 Biodiversity',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity and natural ecosystems.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-5',
                name: 'Topic 11.5 Waste',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste, including as a result of construction and rehabilitation activities.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-6',
                name: 'Topic 11.6 Water and effluents',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-7',
                name: 'Topic 11.7 Closure and rehabilitation',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-8',
                name: 'Topic 11.8 Asset integrity and critical incident management',
                colour: '#8B6479',
                description: 'Asset integrity and critical incident management deal with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-9',
                name: 'Topic 11.9 Occupational health and safety',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-10',
                name: 'Topic 11.10 Employment practices',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain. ',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-11',
                name: 'Topic 11.11 Non-discrimination and equal opportunity',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-12',
                name: 'Topic 11.12 Forced labor and modern slavery',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-13',
                name: 'Topic 11.13 Freedom of association and collective bargaining',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-14',
                name: 'Topic 11.14 Economic impacts',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems. For example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-15',
                name: 'Topic 11.15 Local Communities',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-16',
                name: 'Topic 11.16 Land and resource rights',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-17',
                name: 'Topic 11.17 Rights of indigenous peoples',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-18',
                name: 'Topic 11.18 Conflict and security',
                colour: '#8B6479',
                description: 'An organization’s activities may trigger conflict or, in cases of existing conflict, intensify it. The use of security personnel to manage conflict can play an essential role in allowing an organization to operate safely and productively but also has the potential to impact on people’s human rights. This topic covers the organization\'s security practices and its approach to operating in areas of conflict.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-19',
                name: 'Topic 11.19 Anti-competitive behavior',
                colour: '#8B6479',
                description: 'Anti-competitive behavior refers to actions by an organization that can result in collusion with potential competitors, abuse of dominant market position or exclusion of potential competitors, thereby limiting the effects of market competition. This can include fixing prices or coordinating bids, creating market or output restrictions, imposing geographic quotas, and allocating customers, suppliers, geographic areas, or product lines. This topic covers impacts as a result of anti-competitive behavior.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-20',
                name: 'Topic 11.20 Anti-corruption',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-21',
                name: 'Topic 11.21 Payments to governments',
                colour: '#8B6479',
                description: 'Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization\'s practices related to payments to governments and the organization’s approach to transparency of such payments.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
            {
                code: 'gri_2025-11-22',
                name: 'Topic 11.22 Public policy',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy, and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$g}/gri2021-s11.png`,
            },
        ],
    },
    {
        code: 'gri_2025-12',
        name: 'GRI 12: Coal Sector',
        colour: '#8B6479',
        description: 'GRI 12: Coal Sector 2022 provides information for organizations in the coal sector about their likely material topics. These topics are likely to be material for organizations in the coal sector on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights. ',
        src: `${imagePath$g}/gri2021-s12.png`,
        subgroups: [
            {
                code: 'gri_2025-12-1',
                name: 'Topic 12.1 GHG emissions',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change, such as carbon dioxide (CO2) and methane (CH4). This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-2',
                name: 'Topic 12.2 Climate adaptation, resilience, and transition',
                colour: '#8B6479',
                description: 'Climate adaptation, resilience, and transition refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change. This topic covers an organization’s strategy in relation to the transition to a low-carbon economy and the impacts of that transition on workers and local communities.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-3',
                name: 'Topic 12.3 Closure and rehabilitation',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-4',
                name: 'Topic 12.4 Air emissions',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SOx), nitrogen oxides (NOx), particulate matter (PM), volatile organic compounds (VOC), carbon monoxide (CO), and heavy metals, such as lead, mercury, and cadmium.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-5',
                name: 'Topic 12.5 Biodiversity',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity, and natural ecosystems.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-6',
                name: 'Topic 12.6 Waste',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste, including as a result of construction and rehabilitation activities.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-7',
                name: 'Topic 12.7 Water and effluents',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-8',
                name: 'Topic 12.8 Economic impacts',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems, for example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-9',
                name: 'Topic 12.9 Local communities',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization\'s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-10',
                name: 'Topic 12.10 Land and resource rights',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-11',
                name: 'Topic 12.11 Rights of indigenous peoples',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-12',
                name: 'Topic 12.12 Conflict and security',
                colour: '#8B6479',
                description: 'An organization’s activities may trigger conflict or, in cases of existing conflict, intensify it. The use of security personnel to manage conflict can play an essential role in allowing an organization to operate safely and productively but also has the potential to impact on people’s human rights. This topic covers the organization\'s security practices and its approach to operating in areas of conflict.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-13',
                name: 'Topic 12.13 Asset integrity and critical incident management',
                colour: '#8B6479',
                description: 'Asset integrity and critical incident management deal with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-14',
                name: 'Topic 12.14 Occupational health and safety',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-15',
                name: 'Topic 12.15 Employment practices',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-16',
                name: 'Topic 12.16 Child labor',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-17',
                name: 'Topic 12.17 Forced labor and modern slavery',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-18',
                name: 'Topic 12.18 Freedom of association and collective bargaining',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-19',
                name: 'Topic 12.19 Non-discrimination and equal opportunity',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-20',
                name: 'Topic 12.20 Anti-corruption',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-21',
                name: 'Topic 12.21 Payments to governments',
                colour: '#8B6479',
                description: 'Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization\'s practices related to payments to governments and the organization’s approach to transparency of such payments.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
            {
                code: 'gri_2025-12-22',
                name: 'Topic 12.22 Public policy',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$g}/gri2021-s12.png`,
            },
        ],
    },
    {
        code: 'gri_2025-13',
        name: 'GRI 13: Agriculture, Aquaculture and Fishing Sector',
        colour: '#8B6479',
        description: 'GRI 13: Agriculture, Aquaculture and Fishing Sectors 2022 provides information for organizations in the agriculture, aquaculture, and fishing sectors about their likely material topics. These topics are likely to be material for organizations in the sectors on the basis of the sectors’ most significant impacts on the economy, environment, and people, including on their human rights.',
        src: `${imagePath$g}/gri2021-s13.png`,
        subgroups: [
            {
                code: 'gri_2025-13-1',
                name: 'Topic 13.1 Emissions',
                colour: '#8B6479',
                description: 'This topic addresses emissions into the air, including greenhouse gas (GHG), ozone-depleting substances (ODS), nitrogen oxides (NOX), sulfur oxides (SOX), and other significant air emissions regarded as pollutants. Emissions can have negative impacts on air quality, ecosystems, and on human and animal health. GHG emissions are also a major contributor to climate change.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-2',
                name: 'Topic 13.2 Climate adaptation and resilience',
                colour: '#8B6479',
                description: 'Organizations contribute to climate change and are simultaneously affected by it. Climate adaptation and resilience refer to how an organization adjusts to current and anticipated climate change-related risks, as well as how it contributes to the ability of societies and economies to withstand impacts from climate change.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-3',
                name: 'Topic 13.3 Biodiversity',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on plant and animal species, genetic diversity, and natural ecosystems.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-4',
                name: 'Topic 13.4 Natural ecosystem conversion',
                colour: '#8B6479',
                description: 'Natural ecosystem conversion refers to changing a natural ecosystem to another use or a profound change in a natural ecosystem’s species composition, structure, or function. This topic covers impacts related to natural ecosystem conversion, including discrete incidents of land clearance, severe degradation, or the introduction of practices that lead to substantial and sustained change in natural ecosystems.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-5',
                name: 'Topic 13.5 Soil health',
                colour: '#8B6479',
                description: 'Soil health is the capacity of soil to function as a living ecosystem and to sustain plant and animal productivity, promote plant and animal health, and maintain or enhance water and air quality. This topic covers impacts on soil health, including soil erosion, soil loss, and reduction in soil fertility.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-6',
                name: 'Topic 13.6 Pesticides use',
                colour: '#8B6479',
                description: 'Pesticides are chemical or biological substances intended to regulate plant growth or control, repel, or destroy any pest. This topic covers an organization’s approach and impacts related to pesticides use, including the impact of their toxicity on non-target organisms.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-7',
                name: 'Topic 13.7 Water and effluents',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-8',
                name: 'Topic 13.8 Waste',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste and the management of waste.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-9',
                name: 'Topic 13.9 Food security',
                colour: '#8B6479',
                description: 'Food security means that people have physical and economic access to sufficient, safe, and nutritious food that is acceptable within a given culture and meets people’s dietary needs and food preferences for an active and healthy life. Adequate food is a human right and is crucial to the enjoyment of all rights. This topic covers impacts on the dimensions of food security.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-10',
                name: 'Topic 13.10 Food safety',
                colour: '#8B6479',
                description: 'Food safety concerns the handling of food and feed products in a way that prevents food contamination and food-borne illness. This topic addresses an organization’s efforts to prevent contamination and ensure food safety.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-11',
                name: 'Topic 13.11 Animal health and welfare',
                colour: '#8B6479',
                description: 'Animal health and welfare refers to an animal\'s physical and mental state in relation to the conditions in which it lives and dies. The ‘Five Freedoms’ of animal welfare are freedom from hunger and thirst; freedom from discomfort; freedom from pain, injury, and disease; freedom to express normal behavior; and freedom from fear and distress. This topic covers impacts on animal health and the five freedoms of animal welfare.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-12',
                name: 'Topic 13.12 Local communities',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-13',
                name: 'Topic 13.13 Land and resource rights',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts on human rights and tenure rights that result from an organization’s use of land and natural resources.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-14',
                name: 'Topic 13.14 Rights of indigenous peoples',
                colour: '#8B6479',
                description: 'Indigenous peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of indigenous peoples.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-15',
                name: 'Topic 13.15 Non-discrimination and equal opportunity',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and an organization’s practices related to equal opportunity.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-16',
                name: 'Topic 13.16 Forced or compulsory labor',
                colour: '#8B6479',
                description: 'Forced or compulsory labor is work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-17',
                name: 'Topic 13.17 Child labor',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-18',
                name: 'Topic 13.18 Freedom of association and collective bargaining',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-19',
                name: 'Topic 13.19 Occupational health and safety',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-20',
                name: 'Topic 13.20 Employment practices',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-21',
                name: 'Topic 13.21 Living income and living wage',
                colour: '#8B6479',
                description: 'Living income and living wage refer to such level of income or wage which is sufficient to afford a decent standard of living for all household members, including nutritious food, clean water, housing, education, healthcare, and other essential needs, such as provision for unexpected events. This topic covers the organization’s approach to worker compensation in the context of whether it provides for living income or living wage.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-22',
                name: 'Topic 13.22 Economic inclusion',
                colour: '#8B6479',
                description: 'Economic inclusion concerns an organization’s impacts on access to economic opportunities for local communities and the productive potential of actual and possible suppliers. This topic covers an organization’s approach to economic inclusion of farmers and fishers, and their communities.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-23',
                name: 'Topic 13.23 Supply chain traceability',
                colour: '#8B6479',
                description: 'Traceability is the ability to trace the source, origin, or production conditions of raw materials and final products. Traceability provides a way to identify and prevent potential negative impacts linked to an organization’s products. This topic covers an organization’s approach to supply chain traceability.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-24',
                name: 'Topic 13.24 Public policy',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage public policy development that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from an organization\'s influence.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-25',
                name: 'Topic 13.25 Anti-competitive behavior',
                colour: '#8B6479',
                description: 'Anti-competitive behavior refers to actions by an organization that can result in collusion with potential competitors, abuse of dominant market position or exclusion of potential competitors, thereby limiting the effects of market competition. This can include fixing prices or coordinating bids, creating market or output restrictions, imposing geographic quotas, and allocating customers, suppliers, geographic areas, or product lines. This topic covers impacts as a result of anti-competitive behavior.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
            {
                code: 'gri_2025-13-26',
                name: 'Topic 13.26 Anti-corruption',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers the potential for corruption to occur and the related impacts.',
                src: `${imagePath$g}/gri2021-s13.png`,
            },
        ],
    },
    {
        code: 'gri_2025-14',
        name: 'GRI 14: Mining Sector',
        colour: '#8B6479',
        description: 'GRI 14: Mining Sector 2024 provides information for organizations involved in mining activities about their likely material topics. These topics are likely to be material for mining organizations on the basis of the sector’s most significant impacts on the economy, environment, and people, including on their human rights.',
        src: `${imagePath$g}/gri2021-s14.png`,
        subgroups: [
            {
                code: 'gri_2025-14-1',
                name: 'Topic 14.1 GHG emissions',
                colour: '#8B6479',
                description: 'Greenhouse gas (GHG) emissions comprise air emissions that contribute to climate change. This topic covers direct (Scope 1) and energy indirect (Scope 2) GHG emissions related to an organization’s activities, as well as other indirect (Scope 3) GHG emissions that occur upstream and downstream of the organization’s activities.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-2',
                name: 'Topic 14.2 Climate adaptation and resilience',
                colour: '#8B6479',
                description: 'Organizations contribute to climate change and are simultaneously affected by it. Climate adaptation and resilience refer to how an organization adjusts to current and anticipated climate change-related risks,',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-3',
                name: 'Topic 14.3 Air emissions ',
                colour: '#8B6479',
                description: 'Air emissions include pollutants that have negative impacts on air quality and ecosystems, including human and animal health. This topic covers impacts from emissions of sulfur oxides (SOx), nitrogen oxides (NOx), particulate matter (PM), volatile organic compounds (VOCs), carbon monoxide (CO), and heavy metals, such as mercury (Hg).',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-4',
                name: 'Topic 14.4 Biodiversity',
                colour: '#8B6479',
                description: 'Biodiversity is the variability among living organisms. It includes diversity within species, between species, and of ecosystems. Biodiversity not only has intrinsic value, but is also vital to human health, food security, economic prosperity, and mitigation of climate change and adaptation to its impacts. This topic covers impacts on biodiversity, including on genetic diversity, animal and plant species, and natural ecosystems.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-5',
                name: 'Topic 14.5 Waste',
                colour: '#8B6479',
                description: 'Waste refers to anything that a holder discards, intends to discard, or is required to discard. When inadequately managed, waste can have negative impacts on the environment and human health, which can extend beyond the locations where waste is generated and discarded. This topic covers impacts from waste and the management of waste.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-6',
                name: 'Topic 14.6 Tailings',
                colour: '#8B6479',
                description: 'Tailings are a by-product of mining that need management throughout the life of a mine and beyond closure. Poor design or management of tailings facilities can, at worst, lead to catastrophic failures with lasting impacts on workers, local communities, and damage to the environment, natural resources, and infrastructure.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-7',
                name: 'Topic 14.7 Water and effluents',
                colour: '#8B6479',
                description: 'Recognized as a human right, access to fresh water is essential for human life and well-being. The amount of water withdrawn and consumed by an organization and the quality of its discharges can have impacts on ecosystems and people. This topic covers impacts related to the withdrawal and consumption of water and the quality of water discharged.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-8',
                name: 'Topic 14.8 Closure and rehabilitation',
                colour: '#8B6479',
                description: 'At the end of commercial use, organizations are expected to close assets and facilities and rehabilitate operational sites. Impacts can occur during and after closure. This topic covers an organization’s approach to closure and rehabilitation, including how the organization considers the impacts on the environment, local communities, and workers.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-9',
                name: 'Topic 14.9 Economic impacts',
                colour: '#8B6479',
                description: 'An organization’s impacts on the economy refers to how the value it generates affects economic systems, for example, as a result of its procurement practices and employment of workers. Infrastructure investments and services supported by an organization can also have impacts on a community’s well-being and long-term development. This topic covers economic impacts at local, national, and global levels.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-10',
                name: 'Topic 14.10 Local communities',
                colour: '#8B6479',
                description: 'Local communities comprise individuals living or working in areas that are affected or that could be affected by an organization’s activities. An organization is expected to conduct community engagement to understand the vulnerabilities and priorities of local communities and how they may be affected by the organization’s activities. This topic covers socioeconomic, cultural, health, and human rights impacts on local communities.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-11',
                name: 'Topic 14.11 Rights of Indigenous Peoples',
                colour: '#8B6479',
                description: 'Indigenous Peoples are at higher risk of experiencing negative impacts more severely as a result of an organization’s activities. Indigenous Peoples have both collective and individual rights, as set out in the United Nations Declaration on the Rights of Indigenous Peoples and other authoritative international human rights instruments. This topic covers impacts on the rights of Indigenous Peoples.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-12',
                name: 'Topic 14.12 Land and resource rights',
                colour: '#8B6479',
                description: 'Land and resource rights encompass the rights to use, manage and control land, fisheries, forests, and other natural resources. An organization’s impacts on the availability and accessibility of these can affect local communities and other users. This topic covers impacts from an organization’s use of land and natural resources on human rights and tenure rights, including from resettlement of local communities.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-13',
                name: 'Topic 14.13 Artisanal and small-scale mining',
                colour: '#8B6479',
                description: 'Artisanal and small-scale mining (ASM) refers to mining by individuals, families, or cooperatives with minimal or no mechanization and often operating informally. ASM occurs throughout the world, but is particularly widespread in developing countries where it is an important source of income and livelihood. This topic covers impacts of mining organizations on ASM operators, and impacts mining organizations may be involved with through their business relationships, interactions, or co-location with ASM.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-14',
                name: 'Topic 14.14 Security practices',
                colour: '#8B6479',
                description: 'The use of security personnel can play an essential role in allowing an organization to operate safely and productively, but also has the potential to lead to human rights violations. This topic covers impacts as a result of the use or presence of security personnel.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-15',
                name: 'Topic 14.15 Critical incident management',
                colour: '#8B6479',
                description: 'Critical incident management deals with the prevention and control of incidents that can lead to fatalities, injuries or ill health, environmental impacts, and damage to local communities and infrastructure. This topic covers impacts from such incidents and an organization’s approach to managing them.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-16',
                name: 'Topic 14.16 Occupational health and safety',
                colour: '#8B6479',
                description: 'Healthy and safe work conditions are recognized as a human right. Occupational health and safety involves the prevention of physical and mental harm to workers and promotion of workers’ health. This topic covers impacts related to workers’ health and safety.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-17',
                name: 'Topic 14.17 Employment practices',
                colour: '#8B6479',
                description: 'Employment practices refer to an organization’s approach to job creation, terms of employment, and working conditions for its workers. This topic also covers the employment and working conditions in an organization’s supply chain.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-18',
                name: 'Topic 14.18 Child labor',
                colour: '#8B6479',
                description: 'Child labor is defined as work that deprives children of their childhood, their potential, and their dignity, and that is harmful to their development, including by interfering with their education. It is a violation of human rights and can lead to lifelong negative impacts. Abolition of child labor is a fundamental principle and right at work.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-19',
                name: 'Topic 14.19 Forced labor and modern slavery',
                colour: '#8B6479',
                description: 'Forced labor is defined as all work or service which is exacted from any person under the menace of penalty and for which a person has not offered themselves voluntarily. Freedom from forced labor is a human right and a fundamental right at work. This topic covers an organization’s approach to identifying and addressing forced labor and modern slavery.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-20',
                name: 'Topic 14.20 Freedom of association and collective bargaining',
                colour: '#8B6479',
                description: 'Freedom of association and collective bargaining are human rights and fundamental rights at work. They include the rights of employers and workers to form, join, and run their own organizations without prior authorization or interference, and to collectively negotiate working conditions and terms of employment. This topic covers an organization’s approach and impacts related to freedom of association and collective bargaining.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-21',
                name: 'Topic 14.21 Non-discrimination and equal opportunity',
                colour: '#8B6479',
                description: 'Freedom from discrimination is a human right and a fundamental right at work. Discrimination can impose unequal burdens on individuals or deny fair opportunities on the basis of individual merit. This topic covers impacts from discrimination and practices related to diversity, inclusion, and equal opportunity.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-22',
                name: 'Topic 14.22 Anti-corruption',
                colour: '#8B6479',
                description: 'Anti-corruption refers to how an organization manages the potential of being involved with corruption. Corruption is practices such as bribery, facilitation payments, fraud, extortion, collusion, money laundering, or the offer or receipt of an inducement to do something dishonest or illegal. This topic covers impacts related to corruption and an organization’s approach related to contract and ownership transparency.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-23',
                name: 'Topic 14.23 Payments to governments',
                colour: '#8B6479',
                description: 'Lack of transparency about payments to governments can contribute to inefficient management of public funds, illicit financial flows, and corruption. This topic covers impacts from an organization\'s practices related to payments to governments and the organization’s approach to transparency of such payments.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-24',
                name: 'Topic 14.24 Public policy',
                colour: '#8B6479',
                description: 'An organization can participate in public policy development, directly or through an intermediary organization, by means of lobbying or making financial or in-kind contributions to political parties, politicians, or causes. While an organization can encourage the development of public policy that benefits society, participation can also be associated with corruption, bribery, undue influence, or an imbalanced representation of the organization’s interests. This topic covers an organization’s approach to public policy advocacy and the impacts that can result from the influence an organization exerts.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
            {
                code: 'gri_2025-14-25',
                name: 'Topic 14.25 Conflict-affected and high-risk areas',
                colour: '#8B6479',
                description: 'When operating in or sourcing from conflict-affected and high-risk areas, organizations are more likely to be involved in human rights and legal violations and be implicated in corruption and financial flows contributing to conflict. This topic covers an organization’s approach and impacts related to operating in or sourcing from conflict-affected and high-risk areas.',
                src: `${imagePath$g}/gri2021-s14.png`,
            },
        ],
    },
];

const imagePath$f = config.imagePath;
const issbGroup = [
    {
        code: 'ifrs_s1',
        name: 'IFRS - S1',
        officialCode: '',
        src: `${imagePath$f}/IFRS.jpeg`,
        subgroups: [
            {
                code: 'issb_genreq_s1',
                shortName: 'IFRS S1 General',
                name: 'IFRS S1 General Requirements',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
            {
                code: 'issb_governance_s1',
                shortName: 'IFRS S1 Governance',
                name: 'IFRS S1 Governance',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
            {
                code: 'issb_strategy_s1',
                shortName: 'IFRS S1 Strategy',
                name: 'IFRS S1 Strategy',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
                subgroups: [
                    {
                        code: 'issb_strategy_s1_ro',
                        shortName: 'Sustainability-related risks and opportunities',
                        name: 'Sustainability-related risks and opportunities',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s1_bm',
                        shortName: 'Business model and value chain',
                        name: 'Business model and value chain',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s1_sdm',
                        shortName: 'Strategy and decision-making',
                        name: 'Strategy and decision-making',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s1_fp',
                        shortName: 'Financial position, financial performance and cash flows',
                        name: 'Financial position, financial performance and cash flows',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s1_res',
                        shortName: 'Resilience',
                        name: 'Resilience',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                ],
            },
            {
                code: 'issb_risk_s1',
                shortName: 'IFRS S1 Risk Management',
                name: 'IFRS S1 Risk Management',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
            {
                code: 'issb_metntar_s1',
                shortName: 'IFRS S1 Metrics and Targets',
                name: 'IFRS S1 Metrics and Targets',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
        ],
    },
    {
        code: 'ifrs_s2',
        name: 'IFRS - S2',
        officialCode: '',
        src: `${imagePath$f}/IFRS.jpeg`,
        subgroups: [
            {
                code: 'issb_governance_s2',
                shortName: 'IFRS S2 Governance',
                name: 'IFRS S2 Governance',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
            {
                code: 'issb_strategy_s2',
                shortName: 'IFRS S2 Strategy',
                name: 'IFRS S2 Strategy',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
                subgroups: [
                    {
                        code: 'issb_strategy_s2_ro',
                        shortName: 'Climate-related risks and opportunities',
                        name: 'Climate-related risks and opportunities',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s2_bm',
                        shortName: 'Business model and value chain',
                        name: 'Business model and value chain',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s2_sdm',
                        shortName: 'Strategy and decision-making',
                        name: 'Strategy and decision-making',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s2_fp',
                        shortName: 'Financial position, financial performance and cash flows',
                        name: 'Financial position, financial performance and cash flows',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_strategy_s2_cr',
                        shortName: 'Climate resilience',
                        name: 'Climate resilience',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                ],
            },
            {
                code: 'issb_risk_s2',
                shortName: 'IFRS S2 Risk Management',
                name: 'IFRS S2 Risk Management',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
            },
            {
                code: 'issb_metntar_s2',
                shortName: 'IFRS S2 Metrics and Targets',
                name: 'IFRS S2 Metrics and Targets',
                subtitle: 'International Sustainability Standards Board',
                officialCode: '',
                src: `${imagePath$f}/IFRS.jpeg`,
                subgroups: [
                    {
                        code: 'issb_metntar_s2_crm',
                        shortName: 'Climate-related metrics',
                        name: 'Climate-related metrics',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                    {
                        code: 'issb_metntar_s2_crt',
                        shortName: 'Climate-related targets',
                        name: 'Climate-related targets',
                        subtitle: 'International Sustainability Standards Board',
                        officialCode: '',
                        src: `${imagePath$f}/IFRS.jpeg`,
                    },
                ],
            },
        ],
    },
];

const imagePath$e = config.imagePath;
const csrdGroup = [
    {
        code: 'esrs_2',
        name: 'ESRS 2 - General Requirements',
        src: `${imagePath$e}/csrd.jpeg`,
        subgroups: [
            {
                code: 'esrs_2_bp',
                name: 'Basis for Preparation',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_2_gov',
                name: 'Governance',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_2_strat',
                name: 'Strategy',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_2_iro',
                name: 'Impact, risk and opportunity management',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_2_met',
                name: 'Metrics and targets',
                src: `${imagePath$e}/csrd.jpeg`,
            },
        ],
    },
    {
        code: 'esrs_environment',
        name: 'Environment',
        src: `${imagePath$e}/csrd.jpeg`,
        subgroups: [
            {
                code: 'esrs_environment_e1',
                name: 'ESRS E1 - Climate Change',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_environment_e2',
                name: 'ESRS E2 - Pollution',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_environment_e3',
                name: 'ESRS E3 - Water and Marine Resources',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_environment_e4',
                name: 'ESRS E4 - Biodiversity and Ecosystems',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_environment_e5',
                name: 'ESRS E5 - Resource use and circular economy',
                src: `${imagePath$e}/csrd.jpeg`,
            },
        ],
    },
    {
        code: 'esrs_social',
        name: 'Social',
        src: `${imagePath$e}/csrd.jpeg`,
        subgroups: [
            {
                code: 'esrs_social_s1',
                name: 'ESRS S1 - Own Workforce',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_social_s2',
                name: 'ESRS S2 - Workers in the Value Chain',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_social_s3',
                name: 'ESRS S3 - Affected Communities',
                src: `${imagePath$e}/csrd.jpeg`,
            },
            {
                code: 'esrs_social_s4',
                name: 'ESRS S4 - Consumers and end-users',
                src: `${imagePath$e}/csrd.jpeg`,
            },
        ],
    },
    {
        code: 'esrs_governance',
        name: 'Governance',
        src: `${imagePath$e}/csrd.jpeg`,
        subgroups: [
            {
                code: 'esrs_governance_g1',
                name: 'ESRS G1 - Business Conduct',
                src: `${imagePath$e}/csrd.jpeg`,
            },
        ],
    },
];

const imagePath$d = config.imagePath;
const ungcCopGroup = [
    {
        code: 'ungc_cop_gov',
        name: 'Governance',
        src: `${imagePath$d}/ungc_cop.svg`,
        subgroups: [
            {
                code: 'ungc_cop_gov_policies',
                name: 'Policies and Responsibilities',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_prevention',
                name: 'Prevention',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_concerns',
                name: 'Concerns and Grievance Mechanisms',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_lessons',
                name: 'Lessons',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_executive',
                name: 'Executive Pay',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_board',
                name: 'Board Composition',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_gov_data',
                name: 'Data Assurance',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
        ],
    },
    {
        code: 'ungc_cop_human',
        name: 'Human Rights',
        src: `${imagePath$d}/ungc_cop.svg`,
        subgroups: [
            {
                code: 'ungc_cop_human_commitment',
                name: 'Commitment',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_human_prevention',
                name: 'Prevention',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_human_response',
                name: 'Response and Reporting',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
        ],
    },
    {
        code: 'ungc_cop_labour',
        name: 'Labour',
        src: `${imagePath$d}/ungc_cop.svg`,
        subgroups: [
            {
                code: 'ungc_cop_labour_commitment',
                name: 'Commitment',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_labour_prevention',
                name: 'Prevention',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_labour_performance',
                name: 'Performance',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_labour_response',
                name: 'Response and Reporting',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
        ],
    },
    {
        code: 'ungc_cop_environment',
        name: 'Environment',
        src: `${imagePath$d}/ungc_cop.svg`,
        subgroups: [
            {
                code: 'ungc_cop_environment_commitment',
                name: 'Commitment',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_prevention',
                name: 'Prevention',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_climate',
                name: 'Climate Action',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_energy',
                name: 'Energy/Resource Use',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_tech',
                name: 'Technology',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_water',
                name: 'Water',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_forests',
                name: 'Forests, Biodiversity, and Land Use',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_pollution',
                name: 'Air Pollution',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_waste',
                name: 'Waste',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_environment_overall',
                name: 'Overall Environment',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
        ],
    },
    {
        code: 'ungc_cop_anti-corrup',
        name: 'Anti-Corruption',
        src: `${imagePath$d}/ungc_cop.svg`,
        subgroups: [
            {
                code: 'ungc_cop_anti-corrup_commitment',
                name: 'Commitment',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_anti-corrup_prevention',
                name: 'Prevention',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_anti-corrup_performance',
                name: 'Performance',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
            {
                code: 'ungc_cop_anti-corrup_response',
                name: 'Response and Reporting',
                src: `${imagePath$d}/ungc_cop.svg`,
            },
        ],
    },
];

const imagePath$c = config.imagePath;
const imageSrc$1 = `${imagePath$c}/gcc.png`;
const gccGroup = [
    {
        code: 'gcc_2024_env',
        name: 'Environmental',
        src: imageSrc$1,
        subgroups: [
            {
                code: 'gcc_2024_env_ghg',
                name: 'E1. GHG Emissions',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_emissions_intensity',
                name: 'E2. Emissions Intensity',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_energy_usage',
                name: 'E.3 Energy Usage',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_energy_intensity',
                name: 'E4. Energy Intensity',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_energy_mix',
                name: 'E5. Energy Mix',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_water_usage',
                name: 'E6. Water Usage',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_operations',
                name: 'E7. Environmental Operations',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_oversight',
                name: 'E8. Environmental Oversight',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_env_risk_mitigation',
                name: 'E10. Climate Risk Mitigation',
                src: imageSrc$1,
            },
        ],
    },
    {
        code: 'gcc_2024_soc',
        name: 'Social',
        src: imageSrc$1,
        subgroups: [
            {
                code: 'gcc_2024_soc_ceo',
                name: 'S1. CEO Pay Ratio',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_pay_ratio',
                name: 'S2. Gender Pay Ratio',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_turnover',
                name: 'S3. Employee Turnover',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_gender',
                name: 'S4. Gender Diversity',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_temporary',
                name: 'S5. Temporary Worker Ratio',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_non_discrimination',
                name: 'S6. Non-Discrimination',
                src: imageSrc$1,
            },
            {
                code: 'ggcc_2024_soc_injury',
                name: 'S7. Injury Rate',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_global',
                name: 'S8. Global Health & Safety',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_forced_labour',
                name: 'S9. Child & Forced Labor',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_soc_human',
                name: 'S10. Human Rights',
                src: imageSrc$1,
            },
        ],
    },
    {
        code: 'gcc_2024_gov',
        name: 'Governance',
        src: imageSrc$1,
        subgroups: [
            {
                code: 'gcc_2024_gov_diveristy',
                name: 'G1. Board Diversity',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_indepedence',
                name: 'G2. Board Independence',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_incentivized',
                name: 'G3. Incentivized Pay',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_supplier',
                name: 'G4. Supplier Code of Conduct',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_ethics',
                name: 'G5. Ethics & Prevention of Corruption',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_data',
                name: 'G6. Data Privacy',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_practices',
                name: 'G7. Sustainability Reporting',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_disclosure',
                name: 'G8. Disclosure Practices',
                src: imageSrc$1,
            },
            {
                code: 'gcc_2024_gov_ext_assur',
                name: 'G9. External Assurance',
                src: imageSrc$1,
            },
        ],
    },
];

const imagePath$b = config.imagePath;
const imageSrc = `${imagePath$b}/bursamalaysia.jpeg`;
const bursaMalaysiaGroup = [
    {
        code: 'bursa_malaysia_common',
        name: 'Common Sustainability Metrics',
        src: imageSrc,
    },
    {
        code: 'bursa_malaysia_sector',
        name: 'Sector Specific Metrics',
        src: imageSrc,
    },
];

const cdp2024LogoUrl = `${config.imagePath}/cdp2024.png`;
const cdp2024Group = [
    {
        "code": "cdp_2024_1",
        "name": "Module 1. Introduction",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_1_intro",
                "name": "Introduction",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_1_produced",
                "name": "Produced and sourced commodities",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_2",
        "name": "Module 2. Identification, assessment, and management of dependencies, impacts, risks, and opportunities",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_2_identification",
                "name": "Identification, assessment, and management of dependencies, impacts, risks, and opportunities",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_2_priority",
                "name": "Priority locations",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_3",
        "name": "Module 3. Disclosure of dependencies, risks, and opportunities",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_4",
        "name": "Module 4. Governance",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_5",
        "name": "Module 5. Business strategy",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_5_business",
                "name": "Business strategy Intorduction",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_5_pricing",
                "name": "Pricing Environmental Externalities",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_5_value",
                "name": "Value chain engagement",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_5_asset",
                "name": "Environmental requirements for asset managers",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_5_shareholder",
                "name": "Shareholder Voting",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_6",
        "name": "Module 6. Environmental Performance - Consolidation Approach",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_7",
        "name": "Module 7. Environmental performance - Climate Change",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_7_emissions",
                "name": "Emissions Methodology and Exclusions",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_7_scopes",
                "name": "Scope 1, 2, and 3 Emissions Inventory",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_7_breakdown",
                "name": "Emissions breakdown",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_7_energy",
                "name": "Energy-related activities",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_7_targets",
                "name": "Targets",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_7_land-management",
                "name": "Land-management practices",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_8",
        "name": "Module 8. Environmental performance - Forests",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_8_forests",
                "name": "Forests Introduction",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_8_commodity",
                "name": "Commodity volume data",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_8_deforestation",
                "name": "Deforestation- and- conversion free (DCF) status metrics and methods to determine DCF",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_9",
        "name": "Module 9. Environmental performance - Water security",
        "src": cdp2024LogoUrl,
        "subgroups": [
            {
                "code": "cdp_2024_9_water",
                "name": "Water Introduction",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_9_facility",
                "name": "Facility-level water accounting & Verification",
                "src": cdp2024LogoUrl
            },
            {
                "code": "cdp_2024_9_water_targets",
                "name": "Water-related targets: water quantity, water quality, WASH, other",
                "src": cdp2024LogoUrl
            }
        ]
    },
    {
        "code": "cdp_2024_10",
        "name": "Module 10. Environmental performance - Plastics",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_11",
        "name": "Module 11. Environmental performance - Biodiversity",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_12",
        "name": "Module 12. Environmental performance - Financial Services",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_13",
        "name": "Module 13. Further information & sign off",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_14",
        "name": "Module 14. SME Introduction",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_15",
        "name": "Module 15. SME Identification, Assessment and Management of Risks and Opportunities",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_16",
        "name": "Module 16. SME Disclosure of Risks and Opportunities ",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_17",
        "name": "Module 17. SME Governance",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_18",
        "name": "Module 18. SME Business Strategy",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_19",
        "name": "Module 19. SME Environmental Performance - Consolidation Approach",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_20",
        "name": "Module 20. SME Environmental Performance - Climate Change",
        "src": cdp2024LogoUrl
    },
    {
        "code": "cdp_2024_21",
        "name": "Module 21. SME Sign Off",
        "src": cdp2024LogoUrl
    }
];

const imagePath$a = config.imagePath;
const brsrGroup = [
    {
        code: 'brsr-a',
        name: 'Section A: General Disclosures',
        src: `${imagePath$a}/brsr.svg`,
        subgroups: [
            {
                code: 'brsr-a-1',
                name: '1 - Details of the Listed Entity',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-2',
                name: '2 - Products / Services',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-3',
                name: '3 - Operations',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-4',
                name: '4 - Employees',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-5',
                name: '5 - Holding, Subsidiary and Associate Companies (including joint ventures) ',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-6',
                name: '6 - CSR Details',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-a-7',
                name: '7 - Transparency and Disclosures Compliances',
                src: `${imagePath$a}/brsr.svg`,
            },
        ],
    },
    {
        code: 'brsr-b',
        name: 'Section B: Management and Process Disclosures',
        src: `${imagePath$a}/brsr.svg`,
    },
    {
        code: 'brsr-c',
        name: 'Section C: Principle Wise Performance Disclosure',
        src: `${imagePath$a}/brsr.svg`,
        subgroups: [
            {
                code: 'brsr-c-1',
                name: 'Principle 1',
                description: 'Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable.',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-2',
                name: 'Principle 2',
                description: 'Businesses should provide goods and services in a manner that is sustainable and safe',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-3',
                name: 'Principle 3',
                description: 'Businesses should respect and promote the well-being of all employees, including those in their value chains',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-4',
                name: 'Principle 4',
                description: 'Businesses should respect the interests of and be responsive to all its stakeholders',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-5',
                name: 'Principle 5',
                description: 'Businesses should respect and promote human rights',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-6',
                name: 'Principle 6',
                description: 'Businesses should respect and make efforts to protect and restore the environment',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-7',
                name: 'Principle 7',
                description: 'Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-8',
                name: 'Principle 8',
                description: 'Businesses should promote inclusive growth and equitable development',
                src: `${imagePath$a}/brsr.svg`,
            },
            {
                code: 'brsr-c-9',
                name: 'Principle 9',
                description: 'Businesses should engage with and provide value to their consumers in a responsible manner',
                src: `${imagePath$a}/brsr.svg`,
            },
        ],
    },
];

const imagePath$9 = config.imagePath;
const tnfdGroup = [
    {
        code: 'tnfd_recommended',
        name: 'Recommended Disclosures',
        src: `${imagePath$9}/tnfd-logo.png`,
        subgroups: [
            {
                code: 'tnfd_recommended_governance',
                name: 'Governance',
                src: `${imagePath$9}/tnfd-logo.png`,
            },
            {
                code: 'tnfd_recommended_strategy',
                name: 'Strategy',
                src: `${imagePath$9}/tnfd-logo.png`,
            },
            {
                code: 'tnfd_recommended_risk_impact_management',
                name: 'Risk and impact management',
                src: `${imagePath$9}/tnfd-logo.png`,
            },
            {
                code: 'tnfd_recommended_metrics_targets',
                name: 'Metrics and targets',
                src: `${imagePath$9}/tnfd-logo.png`,
            },
        ],
    },
    {
        code: 'tnfd_core_global',
        name: 'Core Global Metrics',
        src: `${imagePath$9}/tnfd-logo.png`,
    },
    {
        code: 'tnfd_additional',
        name: 'Additional Global Metrics',
        src: `${imagePath$9}/tnfd-logo.png`,
    },
    {
        code: 'tnfd_sector',
        name: 'Sector Metrics',
        src: `${imagePath$9}/tnfd-logo.png`,
        subgroups: [
            {
                code: 'tnfd_sector_aquaculture',
                name: 'Aquaculture',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_aquaculture_core',
                        name: 'Aquaculture - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_aquaculture_additional',
                        name: 'Aquaculture - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_biotech',
                name: 'Biotechnology and Pharmaceuticals',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_biotech_core',
                        name: 'Biotechnology and Pharmaceuticals - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_biotech_additional',
                        name: 'Biotechnology and Pharmaceuticals - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_chemicals',
                name: 'Chemicals ',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_chemicals_core',
                        name: 'Chemicals - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_chemicals_additional',
                        name: 'Chemicals - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_electric_power',
                name: 'Electric Utilities and Power Generators',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_electric_power_core',
                        name: 'Electric Utilities and Power Generators - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_electric_power_additional',
                        name: 'Electric Utilities and Power Generators - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_food_agri',
                name: 'Food and Agriculture',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_food_agri_core',
                        name: 'Food and Agriculture - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_food_agri_additional',
                        name: 'Food and Agriculture - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_forestry_paper',
                name: 'Forestry and Paper',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_forestry_paper_core',
                        name: 'Forestry and Paper - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_forestry_paper_additional',
                        name: 'Forestry and Paper - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_metals_mining',
                name: 'Metals and Mining',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_metals_mining_core',
                        name: 'Metals and Mining - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_metals_mining_additional',
                        name: 'Metals and Mining - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
            {
                code: 'tnfd_sector_oil_gas',
                name: 'Oil and Gas',
                src: `${imagePath$9}/tnfd-logo.png`,
                subgroups: [
                    {
                        code: 'tnfd_sector_oil_gas_core',
                        name: 'Oil and Gas - Core Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                    {
                        code: 'tnfd_sector_oil_gas_additional',
                        name: 'Oil and Gas - Additional Disclosure Metrics',
                        src: `${imagePath$9}/tnfd-logo.png`,
                    },
                ],
            },
        ],
    },
];

const imagePath$8 = config.imagePath;
const wfnGroup = [
    {
        code: 'wfn_2024_nutrition_education',
        name: '1. Nutrition Education',
        src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`,
        subgroups: [
            {
                code: 'wfn_2024_nutrition_education_quality',
                name: 'Quality',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_nutrition_education_quantity',
                name: 'Quantity',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_nutrition_education_strategy',
                name: 'Strategy',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            }
        ]
    },
    {
        code: 'wfn_2024_nutrition_follow-up',
        name: '2. Nutrition Related Health Checks And Follow-Up',
        src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`,
        subgroups: [
            {
                code: 'wfn_2024_nutrition_follow-up_quality',
                name: 'Quality',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_nutrition_follow-up_quantity',
                name: 'Quantity',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_nutrition_follow-up_strategy',
                name: 'Strategy',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            }
        ]
    },
    {
        code: 'wfn_2024_health_food',
        name: '3. Healthy Food at Work',
        src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`,
        subgroups: [
            {
                code: 'wfn_2024_health_food_quality',
                name: 'Quality',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_health_food_quantity',
                name: 'Quantity',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_health_food_strategy',
                name: 'Strategy',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            }
        ]
    },
    {
        code: 'wfn_2024_feeding_support',
        name: '4. Breastfeeding Support',
        src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`,
        subgroups: [
            {
                code: 'wfn_2024_feeding_support_quality',
                name: 'Quality',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_feeding_support_quantity',
                name: 'Quantity',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            },
            {
                code: 'wfn_2024_feeding_support_strategy',
                name: 'Strategy',
                src: `${imagePath$8}/workforce_nutrition_alliance_logo.png`
            }
        ]
    }
];

const imagePath$7 = config.imagePath;
const irisGroup = [
    {
        code: 'iris_agriculture',
        shortName: 'Agri',
        name: 'Agriculture',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_air',
        shortName: 'Air',
        name: 'Air',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_biodiversity',
        shortName: 'Bio',
        name: 'Biodiversity & Ecosystems',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_climate',
        shortName: 'Climate',
        name: 'Climate',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_diversity',
        shortName: 'Diversity',
        name: 'Diversity & Inclusion',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_education',
        shortName: 'Education',
        name: 'Education',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_employment',
        shortName: 'Employment',
        name: 'Employment',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_energy',
        shortName: 'Energy',
        name: 'Energy',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_financial',
        shortName: 'Financial',
        name: 'Financial Services',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_health',
        shortName: 'Health',
        name: 'Health',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_real_estate',
        shortName: 'Estate',
        name: 'Real Estate',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_land',
        shortName: 'Land',
        name: 'Land',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_oceans',
        shortName: 'Oceans',
        name: 'Oceans & Coastal Zones',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_water',
        shortName: 'Water',
        name: 'Water',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_pollution',
        shortName: 'Pollution',
        name: 'Pollution',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_waste',
        shortName: 'Waste',
        name: 'Waste',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_infrastructure',
        shortName: 'Infrastructure',
        name: 'Infrastructure',
        src: `${imagePath$7}/iris.png`,
    },
    {
        code: 'iris_cross',
        shortName: 'Cross',
        name: 'Cross Category',
        src: `${imagePath$7}/iris.png`,
    },
];

const imagePath$6 = config.imagePath;
const wdiGroup = [
    {
        code: 'wdi_2025_details',
        name: 'Company Details',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_governance',
        name: '1. Governance',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_risk_assess',
        name: '2. Risk assessment and human rights due diligence',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_workforce',
        name: '3. Workforce composition',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_diversity',
        name: '4. Diversity and inclusion',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_wages',
        name: '5. Workforce wage levels and pay gaps',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_stability',
        name: '6. Stability',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_development',
        name: '7. Workforce development and adaptation',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_health',
        name: '8. Health, safety and wellbeing',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_representation',
        name: '9. Worker voice and representation',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_grievance',
        name: '10. Grievance mechanisms',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_transparency',
        name: '11. Value chain transparency',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_sourcing',
        name: '12. Responsible sourcing',
        src: `${imagePath$6}/wdi.png`,
    },
    {
        code: 'wdi_2025_valuechain',
        name: '13. Value chain working conditions',
        src: `${imagePath$6}/wdi.png`,
    },
];

const imagePath$5 = config.imagePath;
const msciGroup = [
    {
        code: 'msci_environmental',
        name: 'Environmental',
        src: `${imagePath$5}/msci.png`,
        subgroups: [
            {
                code: 'msci_environmental_carbon',
                name: 'Carbon Emissions',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_climate',
                name: 'Climate Change Vulnerability',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_financing',
                name: 'Financing Environmental Impact',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_product',
                name: 'Product Carbon Footprint',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_biodiversity',
                name: 'Biodiversity & Land Use',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_raw',
                name: 'Raw Material Sourcing',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_water',
                name: 'Water Stress',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_electronic',
                name: 'Electronic Waste',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_packaging',
                name: 'Packaging Material & Waste',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_toxic',
                name: 'Toxic Emissions & Waste',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_opportunities',
                name: 'Opportunities in Clean Tech',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_green',
                name: 'Opportunities in Green Building',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_environmental_renewable',
                name: 'Opportunities in Renewable Energy',
                src: `${imagePath$5}/msci.png`,
            },
        ],
    },
    {
        code: 'msci_social',
        name: 'Social',
        src: `${imagePath$5}/msci.png`,
        subgroups: [
            {
                code: 'msci_social_health',
                name: 'Health & Safety',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_human',
                name: 'Human Capital Development',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_labor',
                name: 'Labor Management',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_supply',
                name: 'Supply Chain Labor Standards',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_chemical',
                name: 'Chemical Safety',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_consumer',
                name: 'Consumer Financial Protection',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_privacy',
                name: 'Privacy & Data Security',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_product',
                name: 'Product Safety & Quality',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_responsible',
                name: 'Responsible Investment',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_community',
                name: 'Community Relations',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_controversial',
                name: 'Controversial Sourcing',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_finance',
                name: 'Access to Finance',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_access',
                name: 'Access to Health Care',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_social_opportunities',
                name: 'Opportunities in Nutrition & Health',
                src: `${imagePath$5}/msci.png`,
            },
        ],
    },
    {
        code: 'msci_governance',
        name: 'Governance',
        src: `${imagePath$5}/msci.png`,
        subgroups: [
            {
                code: 'msci_governance_board',
                name: 'Board',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_governance_pay',
                name: 'Pay',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_governance_ownership',
                name: 'Ownership & Control',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_governance_accounting',
                name: 'Accounting',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_governance_ethics',
                name: 'Business Ethics',
                src: `${imagePath$5}/msci.png`,
            },
            {
                code: 'msci_governance_tax',
                name: 'Tax Transparency',
                src: `${imagePath$5}/msci.png`,
            },
        ],
    },
];

const imagePath$4 = config.imagePath;
const aasbGroup = [
    {
        code: 'aasb_s1',
        name: 'AASB S1',
        src: `${imagePath$4}/aasb_logo.png`,
        subgroups: [
            {
                code: 'aasb_s1_gen_req',
                name: 'AASB S1 General Requirements',
                src: `${imagePath$4}/aasb_logo.png`,
            },
            {
                code: 'aasb_s1_governance',
                name: 'AASB S1 Governance',
                src: `${imagePath$4}/aasb_logo.png`,
            },
            {
                code: 'aasb_s1_strategy',
                name: 'AASB S1 Strategy',
                src: `${imagePath$4}/aasb_logo.png`,
                subgroups: [
                    {
                        code: 'aasb_s1_strategy_ro',
                        name: 'Sustainability-related risks and opportunities',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s1_strategy_bm',
                        name: 'Business model and value chain',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s1_strategy_sdm',
                        name: 'Strategy and decision-making',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s1_strategy_fp',
                        name: 'Financial position, financial performance and cash flows',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s1_strategy_res',
                        name: 'Resilience',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                ],
            },
            {
                code: 'aasb_s1_risk',
                name: 'AASB S1 Risk Management',
                src: `${imagePath$4}/aasb_logo.png`,
            },
            {
                code: 'aasb_s1_met_tar',
                name: 'AASB S1 Metrics and Targets',
                src: `${imagePath$4}/aasb_logo.png`,
            },
        ],
    },
    {
        code: 'aasb_s2',
        name: 'AASB S2',
        src: `${imagePath$4}/aasb_logo.png`,
        subgroups: [
            {
                code: 'aasb_s2_governance',
                name: 'AASB S2 Governance',
                src: `${imagePath$4}/aasb_logo.png`,
            },
            {
                code: 'aasb_s2_strategy',
                name: 'AASB S2 Strategy',
                src: `${imagePath$4}/aasb_logo.png`,
                subgroups: [
                    {
                        code: 'aasb_s2_strategy_ro',
                        name: 'Sustainability-related risks and opportunities',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s2_strategy_bm',
                        name: 'Business model and value chain',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s2_strategy_sdm',
                        name: 'Strategy and decision-making',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s2_strategy_fp',
                        name: 'Financial position, financial performance and cash flows',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s2_strategy_res',
                        name: 'Climate Resilience',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                ],
            },
            {
                code: 'aasb_s2_risk',
                name: 'AASB S2 Risk Management',
                src: `${imagePath$4}/aasb_logo.png`,
            },
            {
                code: 'aasb_s2_met_tar',
                name: 'AASB S2 Metrics and Targets',
                src: `${imagePath$4}/aasb_logo.png`,
                subgroups: [
                    {
                        code: 'aasb_s2_met_tar_crm',
                        name: 'Climate Related Metrics',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                    {
                        code: 'aasb_s2_met_tar_crt',
                        name: 'Climate Related Targets',
                        src: `${imagePath$4}/aasb_logo.png`,
                    },
                ],
            },
        ],
    },
];

const imagePath$3 = config.imagePath;
const vsmeGroup = [
    {
        code: 'vsme_general_basic',
        name: 'Basic Module - General Requirements',
        src: `${imagePath$3}/csrd.jpeg`,
    },
    {
        code: 'vsme_basic',
        name: 'Basic Module',
        src: `${imagePath$3}/csrd.jpeg`,
        subgroups: [
            {
                code: 'vsme_basic_environmental',
                name: 'Basic Module - Environmental Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
            {
                code: 'vsme_basic_social',
                name: 'Basic Module - Social Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
            {
                code: 'vsme_basic_governance',
                name: 'Basic Module - Governance Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
        ],
    },
    {
        code: 'vsme_general_comprehensive',
        name: 'Comprehensive Module - General Requirements',
        src: `${imagePath$3}/csrd.jpeg`,
    },
    {
        code: 'vsme_comprehensive',
        name: 'Comprehensive Module',
        src: `${imagePath$3}/csrd.jpeg`,
        subgroups: [
            {
                code: 'vsme_comprehensive_environmental',
                name: 'Comprehensive Module - Environmental Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
            {
                code: 'vsme_comprehensive_social',
                name: 'Comprehensive Module - Social Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
            {
                code: 'vsme_comprehensive_governance',
                name: 'Comprehensive Module - Governance Metrics',
                src: `${imagePath$3}/csrd.jpeg`,
            },
        ],
    },
];

const imagePath$2 = config.imagePath;
const iso9001Group = [
    {
        "code": "iso9001_2015_4",
        "name": "4 Context of the organization",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_4_1",
                "name": "4.1 Understanding the organization and its context",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_4_2",
                "name": "4.2 Understanding the needs and expectations of interested parties",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_4_3",
                "name": "4.3 Determining the scope of the quality management system",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_4_4",
                "name": "4.4 Quality management system and its processes",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_4_4_1",
                        "name": "4.4.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_4_4_2",
                        "name": "4.4.2 Documented information",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "iso9001_2015_5",
        "name": "5 Leadership",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_5_1",
                "name": "5.1 Leadership and commitment",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_5_1_1",
                        "name": "5.1.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_5_1_2",
                        "name": "5.1.2 Customer focus",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_5_2",
                "name": "5.2 Policy",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_5_2_1",
                        "name": "5.2.1 Establishing the quality policy",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_5_2_2",
                        "name": "5.2.2 Communicating the quality policy",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_5_3",
                "name": "5.3 Organizational roles, responsibilities and authorities",
                "src": `${imagePath$2}/iso_logo.png`
            }
        ]
    },
    {
        "code": "iso9001_2015_6",
        "name": "6 Planning",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_6_1",
                "name": "6.1 Actions to address risks and opportunities",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_6_1_1",
                        "name": "6.1.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_6_1_2",
                        "name": "6.1.2 Planning actions",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_6_2",
                "name": "6.2 Quality objectives and planning to achieve them",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_6_2_1",
                        "name": "6.2.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_6_2_2",
                        "name": "6.2.2 Planning actions to achieve quality objectives",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_6_3",
                "name": "6.3 Planning of changes",
                "src": `${imagePath$2}/iso_logo.png`
            }
        ]
    },
    {
        "code": "iso9001_2015_7",
        "name": "7 Support",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_7_1",
                "name": "7.1 Resources",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_7_1_1",
                        "name": "7.1.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_1_2",
                        "name": "7.1.2 People",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_1_3",
                        "name": "7.1.3 Infrastructure",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_1_4",
                        "name": "7.1.4 Environment for the operation of processes",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_1_5",
                        "name": "7.1.5 Monitoring and measuring resources",
                        "src": `${imagePath$2}/iso_logo.png`,
                        "subgroups": [
                            {
                                "code": "iso9001_2015_7_1_5_1",
                                "name": "7.1.5.1 General",
                                "src": `${imagePath$2}/iso_logo.png`
                            },
                            {
                                "code": "iso9001_2015_7_1_5_2",
                                "name": "7.1.5.2 Measurement traceability",
                                "src": `${imagePath$2}/iso_logo.png`
                            }
                        ]
                    },
                    {
                        "code": "iso9001_2015_7_1_6",
                        "name": "7.1.6 Organizational knowledge",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_7_2",
                "name": "7.2 Competence",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_7_3",
                "name": "7.3 Awareness",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_7_4",
                "name": "7.4 Communication",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_7_5",
                "name": "7.5 Documented information",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_7_5_1",
                        "name": "7.5.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_5_2",
                        "name": "7.5.2 Creating and updating",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_7_5_3",
                        "name": "7.5.3 Control of documented information",
                        "src": `${imagePath$2}/iso_logo.png`,
                        "subgroups": [
                            {
                                "code": "iso9001_2015_7_5_3_1",
                                "name": "7.5.3.1 General",
                                "src": `${imagePath$2}/iso_logo.png`
                            },
                            {
                                "code": "iso9001_2015_7_5_3_2",
                                "name": "7.5.3.2 Activities for control",
                                "src": `${imagePath$2}/iso_logo.png`
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "code": "iso9001_2015_8",
        "name": "8 Operation",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_8_1",
                "name": "8.1 Operational planning and control",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_8_2",
                "name": "8.2 Requirements for products and services",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_8_2_1",
                        "name": "8.2.1 Customer communication",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_2_2",
                        "name": "8.2.2 Determining the requirements for products and services",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_2_3",
                        "name": "8.2.3 Review of the requirements for products and services",
                        "src": `${imagePath$2}/iso_logo.png`,
                        "subgroups": [
                            {
                                "code": "iso9001_2015_8_2_3_1",
                                "name": "8.2.3.1 General",
                                "src": `${imagePath$2}/iso_logo.png`
                            },
                            {
                                "code": "iso9001_2015_8_2_3_2",
                                "name": "8.2.3.2 Retention of documented information",
                                "src": `${imagePath$2}/iso_logo.png`
                            }
                        ]
                    },
                    {
                        "code": "iso9001_2015_8_2_4",
                        "name": "8.2.4 Changes to requirements for products and services",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_8_3",
                "name": "8.3 Design and development of products and services",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_8_3_1",
                        "name": "8.3.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_3_2",
                        "name": "8.3.2 Design and development planning",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_3_3",
                        "name": "8.3.3 Design and development inputs",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_3_4",
                        "name": "8.3.4 Design and development controls",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_3_5",
                        "name": "8.3.5 Design and development outputs",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_3_6",
                        "name": "8.3.6 Design and development changes",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_8_4",
                "name": "8.4 Control of externally provided processes, products and services",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_8_4_1",
                        "name": "8.4.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_4_2",
                        "name": "8.4.2 Type and extent of control",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_4_3",
                        "name": "8.4.3 Information for external providers",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_8_5",
                "name": "8.5 Production and service provision",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_8_5_1",
                        "name": "8.5.1 Control of production and service provision",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_5_2",
                        "name": "8.5.2 Identification and traceability",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_5_3",
                        "name": "8.5.3 Property belonging to customers or external providers",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_5_4",
                        "name": "8.5.4 Preservation",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_5_5",
                        "name": "8.5.5 Post-delivery activities",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_5_6",
                        "name": "8.5.6 Control of changes",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_8_6",
                "name": "8.6 Release of products and services",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_8_7",
                "name": "8.7 Control of nonconforming outputs",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_8_7_1",
                        "name": "8.7.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_8_7_2",
                        "name": "8.7.2 Retention of documented information",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "iso9001_2015_9",
        "name": "9 Performance evaluation",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_9_1",
                "name": "9.1 Monitoring, measurement, analysis and evaluation",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_9_1_1",
                        "name": "9.1.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_9_1_2",
                        "name": "9.1.2 Customer satisfaction",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_9_1_3",
                        "name": "9.1.3 Analysis and evaluation",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_9_2",
                "name": "9.2 Internal audit",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_9_2_1",
                        "name": "9.2.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_9_2_2",
                        "name": "9.2.2 Internal audit programme",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_9_3",
                "name": "9.3 Management review",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_9_3_1",
                        "name": "9.3.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_9_3_2",
                        "name": "9.3.2 Management review inputs",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_9_3_3",
                        "name": "9.3.3 Management review outputs",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "iso9001_2015_10",
        "name": "10 Improvement",
        "src": `${imagePath$2}/iso_logo.png`,
        "subgroups": [
            {
                "code": "iso9001_2015_10_1",
                "name": "10.1 General",
                "src": `${imagePath$2}/iso_logo.png`
            },
            {
                "code": "iso9001_2015_10_2",
                "name": "10.2 Nonconformity and corrective action",
                "src": `${imagePath$2}/iso_logo.png`,
                "subgroups": [
                    {
                        "code": "iso9001_2015_10_2_1",
                        "name": "10.2.1 General",
                        "src": `${imagePath$2}/iso_logo.png`
                    },
                    {
                        "code": "iso9001_2015_10_2_2",
                        "name": "10.2.2 Retention of documented information",
                        "src": `${imagePath$2}/iso_logo.png`
                    }
                ]
            },
            {
                "code": "iso9001_2015_10_3",
                "name": "10.3 Continual improvement",
                "src": `${imagePath$2}/iso_logo.png`
            }
        ]
    },
];

const imagePath$1 = config.imagePath;
const cosiriGroup = [
    {
        "code": "cosiri_strategy_risk",
        "name": "1. Strategy and Risk Management",
        "src": `${imagePath$1}/cosiri.png`,
        "subgroups": [
            {
                "code": "cosiri_strategy",
                "name": "Strategy",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_strategy_targets",
                        "name": "Strategy & Targets",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_strategy_integration",
                        "name": "ESG Integration",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_strategy_modelling",
                        "name": "Green Business Modeling",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_strategy_capital",
                        "name": "Capital Allocation",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            },
            {
                "code": "cosiri_risk_management",
                "name": "Risk Management",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_risk_physical",
                        "name": "Physical Climate Risk",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_risk_transition",
                        "name": "Transition Climate Risk",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_risk_compliance",
                        "name": "Compliance Risk",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_risk_reputation",
                        "name": "Reputation Risk",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "cosiri_business_process",
        "name": "2. Sustainable Business Process",
        "src": `${imagePath$1}/cosiri.png`,
        "subgroups": [
            {
                "code": "cosiri_operation",
                "name": "Operation",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_operation_ghg",
                        "name": "Greenhouse Gas Emissions",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_operation_resources",
                        "name": "Resources (Water, Energy)",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_operation_waste",
                        "name": "Material Waste",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_operation_pollution",
                        "name": "Pollution (Air, Soil, Water)",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            },
            {
                "code": "cosiri_procurement",
                "name": "Procurement",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_procurement_assessment",
                        "name": "Supplier Assessment",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_procurement_selection",
                        "name": "Supplier Selection and Collaboration",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            },
            {
                "code": "cosiri_supply_chain",
                "name": "Supply Chain",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_supply_transport",
                        "name": "Transportation & Distribution",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_supply_planning",
                        "name": "Supply Chain Planning",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            },
            {
                "code": "cosiri_product_lifecycle",
                "name": "Product Lifecycle (Circularity)",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_product_design",
                        "name": "Product Design",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_product_process",
                        "name": "Process Design and Responsible End-of-Life",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "cosiri_technology",
        "name": "3. Technology",
        "src": `${imagePath$1}/cosiri.png`,
        "subgroups": [
            {
                "code": "cosiri_clean_technology",
                "name": "Clean Technology",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_tech_adoption",
                        "name": "Adoption",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_tech_transparency",
                        "name": "Transparency & Optimization",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "cosiri_governance",
        "name": "4. Organization and Governance",
        "src": `${imagePath$1}/cosiri.png`,
        "subgroups": [
            {
                "code": "cosiri_talent",
                "name": "Talent Readiness",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_talent_workforce",
                        "name": "Workforce Development",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_talent_leadership",
                        "name": "Leadership Involvement",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            },
            {
                "code": "cosiri_structure",
                "name": "Structure and Management",
                "src": `${imagePath$1}/cosiri.png`,
                "subgroups": [
                    {
                        "code": "cosiri_structure_communication",
                        "name": "External Communication and Engagement",
                        "src": `${imagePath$1}/cosiri.png`
                    },
                    {
                        "code": "cosiri_structure_governance",
                        "name": "Governance",
                        "src": `${imagePath$1}/cosiri.png`
                    }
                ]
            }
        ]
    },
    {
        "code": "cosiri_esg_questionnaire",
        "name": "5. ESG Questionnaire",
        "src": `${imagePath$1}/cosiri.png`
    },
];

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const imagePath = config.imagePath;
const standards = {
    kpi: {
        code: 'kpi',
        name: 'G17Eco',
        shortName: 'G17Eco',
        subtitle: 'Normalization',
        src: `${imagePath}/wwg.png`,
        description: 'Additional questions used to enable accurate calculation of SDG contributions',
    },
    aichi: {
        code: 'aichi',
        shortName: 'Aichi',
        name: 'Aichi Biodiversity Targets',
        description: 'The Aichi Biodiversity Targets are part of the Strategic Plan for Biodiversity 2011-2020. The twenty headline Aichi Biodiversity Targets for 2015 or 2020 are organized under the five strategic goals. The goals and targets comprise both aspirations for achievement at the global level, and a flexible framework for the establishment of national or regional targets.',
        src: `${imagePath}/aichi.png`,
        link: 'https://www.cbd.int/sp/targets/',
        archived: true,
    },
    atni: {
        code: 'atni',
        shortName: 'ATNI',
        name: 'ATNI (Access to Nutrition Initiative)',
        src: `${imagePath}/atni.png`,
        description: 'The aim of ATNI is to encourage companies to both increase access to healthy products and also to responsibly exercise their influence on consumers\' choice and behaviour. The Access to Nutrition Index (ATNI) was designed through an extensive, multi-stakeholder consultative process.',
        link: 'https://accesstonutrition.org/'
    },
    bca: {
        code: 'bca',
        shortName: 'BCA',
        name: 'Business Call to Action',
        description: 'Aims to accelerate progress towards the Sustainable Development Goals (SDGs) by challenging companies to develop inclusive business models that engage people at the base of the economic pyramid (BoP) – people with less than US$10 per day in purchasing power in 2015 US dollars – as consumers, producers, suppliers, distributors of goods and services and employees.',
        src: `${imagePath}/bca.png`,
        link: 'https://www.businesscalltoaction.org/'
    },
    blabs: {
        code: 'blabs',
        shortName: 'B-Labs',
        name: 'B-Labs',
        src: `${imagePath}/blabs.png`,
        description: 'B Lab is a nonprofit that serves a global movement of people using business as a force for good. B Lab’s initiatives include B Corp Certification, administration of the B Impact Management programs and software, and advocacy for governance structures like the benefit corporation.',
        link: 'https://bcorporation.net/',
        tags: [Tags.UsRating],
    },
    cdp: {
        code: 'cdp',
        name: 'CDP',
        shortName: 'CDP',
        src: `${imagePath}/cdp.png`,
        description: 'CDP is a not-for-profit charity that runs the global environmental disclosure system for investors, companies, cities, states and regions to measure and manage their risks and opportunities on climate change, water security and deforestation.',
        link: 'https://www.cdp.net/en',
        subgroups: cdpGroup,
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.CDP],
        versionGroupCode: 'cdp',
        version: 2020,
        hidden: true
    },
    cdp_2022: {
        code: 'cdp_2022',
        name: 'CDP 2022',
        shortName: 'CDP 2022',
        src: `${imagePath}/cdp.png`,
        description: 'CDP is a not-for-profit charity that runs the global environmental disclosure system for investors, companies, cities, states and regions to measure and manage their risks and opportunities on climate change, water security and deforestation.',
        link: 'https://www.cdp.net/en',
        subgroups: cdp2020Group,
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.CDP],
        versionGroupCode: 'cdp',
        version: 2022,
        hidden: true
    },
    cdp_2024: {
        code: "cdp_2024",
        name: "CDP (Carbon Disclosure Project)",
        shortName: 'CDP 2024',
        src: cdp2024LogoUrl,
        description: 'CDP is a not-for-profit charity that runs the global environmental disclosure system for investors, companies, cities, states and regions to measure and manage their risks and opportunities on climate change, water security and deforestation.',
        link: 'https://www.cdp.net/en',
        subgroups: cdp2024Group,
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.CDP],
        versionGroupCode: 'cdp',
        version: 2024,
        hidden: false,
    },
    ceo_wm: {
        code: 'ceo_wm',
        name: 'CEO Water Mandate',
        shortName: 'CEO WM',
        src: `${imagePath}/ceo_wm.png`,
        description: 'The CEO Water Mandate is a UN Global Compact initiative that mobilizes business leaders on water, sanitation, and the Sustainable Development Goals. Endorsers of the CEO Water Mandate commit to continuous progress against six core elements of stewardship and in so doing understand and manage their own water risks.',
        link: 'https://ceowatermandate.org/'
    },
    chrb: {
        code: 'chrb',
        shortName: 'CHRB',
        name: 'CHRB (Corporate Human Rights Benchmark)',
        src: `${imagePath}/chrb.png`,
        description: 'The Corporate Human Rights Benchmark (CHRB) was launched in 2013 as a multi-stakeholder initiative and draws on investor, business and human rights, and benchmarking expertise from 6 organisations: ... The Institute for Human Rights and Business (IHRB) is the leading international think tank on business and human rights.',
        link: 'https://www.corporatebenchmark.org/'
    },
    context: {
        code: 'context',
        name: 'Contextual Reporting',
        shortName: 'Contextual Reporting',
        src: `${imagePath}/wwg.png`,
        description: 'The Contextual Reporting questions give the data you have answered in your survey context. By answering these questions you can create UNGC or TCFD reports with the metrics and data you have answered.',
        link: ''
    },
    cosiri: {
        code: 'cosiri',
        name: 'COSIRI (Consumer Sustainability Industry Readiness Index)',
        shortName: 'COSIRI',
        src: `${imagePath}/cosiri.png`,
        description: 'COSIRI is a sustainability prioritisation framework for manufacturers, designed to help industrial operations benchmark and improve their sustainability performance across strategy, business processes, technology, and governance.',
        link: 'https://www.incit.org/cosiri',
        subgroups: cosiriGroup,
    },
    cwdg: {
        code: 'cwdg',
        name: 'Corporate Water Disclosure Guidelines',
        shortName: 'CWDG',
        src: `${imagePath}/cwdg.png`,
        description: 'The Corporate Water Disclosure Guidelines seek to advance a common approach to corporate water disclosure that addresses the complexity and local nature of water resources. This website presents key elements of this guidance in a user-friendly manner.',
        link: 'https://ceowatermandate.org/disclosure/'
    },
    dgepr: {
        code: 'dgepr',
        name: 'EPR (Development of Guidance on Extended Producer Responsibility)',
        shortName: 'EPR',
        src: `${imagePath}/dgepr.png`,
        description: 'Extended producer responsibility (EPR) can be defined as “an environmental policy approach in which a producer’s responsibility for a product is asended to the post-consumer stage of a product’s life cycle.”',
        link: 'https://ec.europa.eu/environment/waste/pdf/target_review/Guidance%20on%20EPR%20-%20Final%20Report.pdf'
    },
    fao: {
        code: 'fao',
        name: 'Food and Agriculture Organization of the United Nations',
        shortName: 'FAO',
        src: `${imagePath}/fao_logo.png`,
        description: 'The Food and Agriculture Organization of the United Nations is a specialized agency of the United Nations that leads international efforts to defeat hunger and improve nutrition and food security.',
        link: 'http://www.fao.org/home/en/',
        archived: true,
    },
    eeo: {
        code: 'eeo',
        shortName: 'U.S. EEOC',
        name: 'U.S. EEOC (U.S. Equal Employment Opportunity Commission)',
        src: `${imagePath}/eeo.png`,
        description: 'The EEO-1 Component 1 report is a mandatory annual data collection that requires all private sector employers with 100 or more employees, and federal contractors with 50 or more employees meeting certain criteria, to submit demographic workforce data, including data by race/ethnicity, sex and job categories.',
        link: 'https://www.eeoc.gov/employers/eeo-1-data-collection',
        tags: [Tags.UsRegulatory],
    },
    erq_metrics_2022: {
        code: "erq_metrics_2022",
        name: "ERQ Metrics (Environmental Risk Questionnaire)",
        shortName: "ERQ Metrics",
        src: `${imagePath}/erq.png`,
        description: "Environmental Risk Questionnaire",
        subgroups: erqGroup,
    },
    futurefit: {
        code: 'futurefit',
        name: 'Future-Fit',
        shortName: 'FF',
        src: `${imagePath}/futureFit.svg`,
        description: 'The Future-Fit Business Benchmark is a free business tool designed to guide real progress toward a flourishing future – and make the SDGs a reality.',
        link: 'https://futurefitbusiness.org/'
    },
    bmz: {
        code: 'bmz',
        name: 'Federal Ministry for Economic Cooperation and Development',
        shortName: 'BMZ',
        src: `${imagePath}/bmz.png`,
        description: 'The Federal Ministry for Economic Cooperation and Development works to encourage economic development within Germany and in other countries through international cooperation and partnerships. It cooperates with international organizations involved in development including the International Monetary Fund, World Bank, and the United Nations.',
        link: 'https://www.bmz.de/en/',
        archived: true,
    },
    gii: {
        code: 'gii',
        name: 'Global Innovation Index',
        shortName: 'GII',
        src: `${imagePath}/gii.png`,
        description: 'The Global Innovation Index is an annual ranking of countries by their capacity for, and success in, innovation.',
        link: 'https://www.globalinnovationindex.org/'
    },
    glwc: {
        code: 'glwc',
        shortName: 'GLWC',
        name: 'GLWC (Global Living Wage Coalition)',
        src: `${imagePath}/glwc.png`,
        description: 'The GLWC comes together with the shared mission to see continuous improvements in workers’ wages in the farms, factories, and supply chains participating in their respective certification systems and beyond, and with the long term goal for workers to be paid a living wage.',
        link: 'https://www.globallivingwage.org/'
    },
    gtcc: {
        code: 'gtcc',
        name: 'GSTC (Global Sustainable Tourism Council)',
        shortName: 'GSTC',
        src: `${imagePath}/gtcc.png`,
        description: 'The GSTC Criteria serve as the global baseline standards for sustainability in travel and tourism. The Criteria are used for education and awareness-raising, policy-making for businesses and government agencies and other organization types, measurement and evaluation, and as a basis for certification.',
        link: 'https://www.gstcouncil.org/'
    },
    gri_g4: {
        code: 'gri_g4',
        shortName: 'GRI G4',
        name: 'GRI G4*',
        src: `${imagePath}/gri_g4.png`,
        description: 'The G4 Guidelines have been superseded by the GRI Sustainability Reporting Standards (GRI Standards).',
        link: 'https://www2.globalreporting.org/standards/g4/Pages/default.aspx'
    },
    gri_g4_gri: {
        code: 'gri_g4_gri',
        shortName: 'GRI G4/GRI',
        name: 'GRI G4*/ GRI Standards',
        src: `${imagePath}/gri_g4_gri.png`,
        description: 'The G4 Guidelines have been superseded by the GRI Sustainability Reporting Standards (GRI Standards).',
        link: 'https://www2.globalreporting.org/standards/g4/Pages/default.aspx'
    },
    gri: {
        code: 'gri',
        name: 'GRI 2019 (Global Reporting Initiative)',
        shortName: 'GRI 2019',
        src: `${imagePath}/gri.png`,
        description: 'The Global Reporting Initiative is an international independent standards organization that helps businesses, governments and other organizations understand and communicate their impacts on issues such as climate change, human rights and corruption.',
        link: 'https://www.globalreporting.org/',
        subgroups: griGroup,
        versionGroupCode: 'gri',
        version: 2020,
        archived: true,
    },
    gri2021: {
        code: 'gri2021',
        name: 'GRI 2021 (Global Reporting Initiative)',
        shortName: 'GRI 2021',
        src: `${imagePath}/gri2021.png`,
        description: 'The GRI Standards enable any organization, large or small, private or public, to understand and report on their impacts on the economy, environment and people in a comparable and credible way. Thereby increasing transparency on their contribution to sustainable development. In addition to reporting companies, the Standards are highly relevant to many stakeholders including investors, policymakers, capital markets, and civil society.',
        link: 'https://www.globalreporting.org/',
        subgroups: gri2021Group,
        versionGroupCode: 'gri',
        version: 2021,
    },
    // No versionGroupCode/version: GRI 2021 would be archived and treated as an older version while both are in use
    gri2025: {
        code: 'gri2025',
        name: 'GRI 2025 (Global Reporting Initiative)',
        shortName: 'GRI 2025',
        src: `${imagePath}/gri2021.png`,
        description: 'The GRI Standards for reports published from 1 January 2027: GRI 102: Climate Change 2025 and GRI 103: Energy 2025 replace GRI 302: Energy and GRI 305-1 to 305-5, and GRI 101: Biodiversity replaces GRI 304.',
        link: 'https://www.globalreporting.org/',
        subgroups: gri2025Group,
        hidden: true,
        betaFeature: FeatureCode.Gri2025Beta,
    },
    ifc: {
        code: "ifc",
        shortName: "IFC",
        name: "IFC (International Finance Corporation)",
        src: `${imagePath}/ifc.png`,
        description: "The International Finance Corporation, a member organization of the World Bank Group advances economic development and improves the lives of people by encouraging the growth of the private sector in developing countries. The IFC’s Sustainability and Governance Performance Standards and indicators are a good practice framework for managing risks and operating sustainably. The Standards define an organization’s role and responsibilities in relation to environmental, social and governance risks, and access to information policy which defines IFC’s institutional obligations in relation to transparency and accountability.",
        link: "https://www.ifc.org/wps/wcm/connect/corp_ext_content/ifc_external_corporate_site/home",
        subgroups: ifcGroups,
    },
    ilo: {
        code: 'ilo',
        shortName: 'ILO',
        name: 'ILO (International Labour Organization)',
        src: `${imagePath}/ilo.png`,
        description: 'The International Labour Organization is a United Nations agency whose mandate is to advance social justice and promote decent work by setting international labour standards. It was the first specialised agency of the UN.',
        link: 'https://www.ilo.org/'
    },
    iris: {
        code: 'iris',
        shortName: 'IRIS+',
        name: 'IRIS+ (Impact Reporting & Investment Standards)',
        src: `${imagePath}/iris.png`,
        description: ' Credible, comparable impact data are needed to inform impact investment decisions and drive greater impact results. IRIS+ solves for this by increasing data clarity and comparability, and it provides streamlined, practical, how-to guidance that impact investors need, all in one easy-to-navigate system. It is a free, publicly available resource that is managed by the Global Impact Investing Network (GIIN) – the global champion of impact investing.',
        link: 'https://iris.thegiin.org/',
        subgroups: irisGroup,
    },
    iso9001_2015: {
        code: 'iso9001_2015',
        name: 'ISO 9001:2015 (Quality Management Systems)',
        shortName: 'ISO 9001:2015',
        src: `${imagePath}/iso_logo.png`,
        description: 'ISO 9001 is a standard that specifies requirements for a quality management system (QMS). It is one of the most widely used standards in the world.',
        link: 'https://www.iso.org/standard/62085.html',
        subgroups: iso9001Group,
    },
    refinitiv: {
        code: 'refinitiv',
        shortName: 'LSEG',
        name: 'LSEG Data & Analytics',
        src: `${imagePath}/lseg.png`,
        link: 'https://www.lseg.com/en/data-analytics',
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.Refinitiv]
    },
    rspo: {
        code: 'rspo',
        shortName: 'RSPO',
        name: 'RSPO (Roundtable on Sustainable Palm Oil)',
        src: `${imagePath}/rspo_logo.png`,
        link: 'https://rspo.org/',
        subgroups: rspoGroup,
        requiredTags: [RequiredTags.RSPO]
    },
    ca100: {
        code: 'ca100',
        shortName: 'CA100+',
        name: 'Climate Action 100+ - Net Zero Company Benchmark',
        description: 'Climate Action 100+ Net Zero Company Benchmark - A framework to assess focus companies based on their publicly disclosed information',
        src: `${imagePath}/ca100.png`,
        link: 'https://www.climateaction100.org/progress/net-zero-company-benchmark/methodology/',
    },
    cbr: {
        code: 'cbr',
        shortName: 'CBR',
        name: 'CBR',
        tags: [Tags.UsRegulatory],
        description: '',
        src: `${imagePath}/cbr.jpeg`,
        link: '',
    },
    gresb: {
        code: 'gresb',
        shortName: 'GRESB',
        name: 'Real Estate ESG Benchmark – GRESB Real Estate Assessment',
        description: 'The GRESB Real Estate Assessment is the investor-driven global ESG benchmark and reporting framework for listed property companies, private property funds, developers and investors that invest directly in real estate.',
        src: `${imagePath}/gresb.png`,
        link: 'https://gresb.com/gresb-real-estate-assessment/',
        archived: true,
    },
    ppp: {
        code: 'ppp',
        shortName: 'PPP',
        name: 'PPC (Prompt Payment Code)',
        description: 'The Prompt Payment Code (PPC) is a voluntary code of practice for businesses, administered by the Office of the Small Business Commissioner (SBC) on behalf of BEIS. It was established in December 2008 and sets standards for payment practices between organisations of any size and their suppliers.',
        src: `${imagePath}/ppp.png`,
        link: 'https://www.smallbusinesscommissioner.gov.uk/ppc/',
        archived: true,
    },
    sam_csa: {
        code: 'sam_csa',
        name: 'DJSI CSA (Dow Jones Sustainability Indices Corporate Sustainability Assessment)',
        shortName: 'DJSI CSA',
        src: `${imagePath}/djsi.png`,
        description: 'The S&P Global CSA is an annual evaluation of companies sustainability practices. Each year over 10,000 companies around the world are assessed. The CSA focuses on criteria that are both industry-specific and financially material and have been doing so since 1999.',
        link: 'https://www.spglobal.com/esg/csa/',
        tags: [Tags.UsRating],
        subgroups: samCsaGroup,
        requiredTags: [RequiredTags.DJSI],
        archived: true,
    },
    sbti: {
        code: 'sbti',
        name: 'SBTi (Science Based Target Initiative)',
        shortName: 'SBTi',
        src: `${imagePath}/sbti.png`,
        description: 'The Science Based Targets initiative champions science-based target setting as a powerful way of boosting companies’ competitive advantage in the transition to the low-carbon economy. The initiative’s overall aim is that by 2020, science-based target setting will become standard business practice and corporations will play a major role in driving down global greenhouse gas emissions.',
        link: 'https://sciencebasedtargets.org/',
    },
    sasb: {
        code: 'sasb',
        name: 'SASB (Sustainability Accounting Standards Board)',
        shortName: 'SASB',
        src: `${imagePath}/sasb.svg`,
        description: 'SASB standards enable businesses around the world to identify, manage and communicate financially-material sustainability information to their investors.',
        link: 'https://www.sasb.org/',
        subgroups: sasbGroup,
        requiredTags: [RequiredTags.SASB],
    },
    sasb_it: {
        code: 'sasb_it',
        name: 'SASB - Software & IT',
        shortName: 'SASB',
        src: `${imagePath}/sasb.svg`,
        description: 'SASB standards enable businesses around the world to identify, manage and communicate financially-material sustainability information to their investors.',
        link: 'https://www.sasb.org/',
    },
    sasb_tele: {
        code: 'sasb_tele',
        name: 'SASB - Telecommunication Services',
        shortName: 'SASB',
        src: `${imagePath}/sasb.svg`,
        description: 'SASB standards enable businesses around the world to identify, manage and communicate financially-material sustainability information to their investors.',
        link: 'https://www.sasb.org/',
    },
    sasb_internet: {
        code: 'sasb_internet',
        name: 'SASB - Internet Media & Services',
        shortName: 'SASB',
        src: `${imagePath}/sasb.svg`,
        description: 'SASB standards enable businesses around the world to identify, manage and communicate financially-material sustainability information to their investors.',
        link: 'https://www.sasb.org/',
    },
    sfdr: {
        code: 'sfdr',
        shortName: 'SFDR',
        tags: [Tags.UsRegulatory],
        name: 'SFDR (Sustainable Finance Disclosure Regulation)',
        description: 'The Sustainable Finance Disclosure Regulation (SFDR) is a central plank of the European Commission\'s 2018 Action Plan for financing sustainable growth. The SFDR provides  a greater transparency on the degree of sustainability of financial products. The objective is to  channel private investment towards sustainable investing while preventing \'greenwashing\'. The regulation will be phased in from 10 March 2021.',
        src: `${imagePath}/eu_commission.jpeg`,
        link: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=celex%3A32019R2088',
        subgroups: [
            {
                code: 'sfdr_pai',
                name: 'Principle Adverse Impact (PAI) Indicators',
                src: `${imagePath}/eu_commission.jpeg`,
                subgroups: [
                    {
                        code: 'sfdr_pai_mandatory',
                        name: 'Mandatory Adverse Impact Indicators',
                        src: `${imagePath}/eu_commission.jpeg`,
                        subgroups: [
                            {
                                code: 'sfdr_pai_mandatory_climate',
                                name: 'Climate and other Environment-related Indicators',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_mandatory_social',
                                name: 'Social and employee, respect for human rights, anti-corruption and anti-bribery matters',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_mandatory_sovereigns',
                                name: 'Indicators applicable to investments in sovereigns and supranationals',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_mandatory_real_estate',
                                name: 'Indicators applicable to investments in real estate assets',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                        ],
                    },
                    {
                        code: 'sfdr_pai_optional',
                        name: 'Optional Adverse Impact Indicators',
                        src: `${imagePath}/eu_commission.jpeg`,
                        subgroups: [
                            {
                                code: 'sfdr_pai_optional_climate',
                                name: 'Climate and other environment-related indicators',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_optional_social',
                                name: 'Social and employee, respet for human rights, anti-corruption and anti-bribery matters',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_optional_sovereigns',
                                name: 'Indicators applicable to investments in sovereigns and supranationals',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                            {
                                code: 'sfdr_pai_optional_real_estate',
                                name: 'Indicators applicable to investments in real estate assets',
                                src: `${imagePath}/eu_commission.jpeg`,
                            },
                        ],
                    },
                ],
            },
            {
                code: 'sfdr_other',
                name: 'Other Indicator Areas',
                src: `${imagePath}/eu_commission.jpeg`,
            },
        ],
    },
    sdg: {
        code: 'sdg',
        name: 'SDGs (UN Sustainable Development Goals)',
        shortName: 'SDGs',
        src: `${imagePath}/SDG_colour_wheel.svg`,
        link: 'https://sustainabledevelopment.un.org/',
    },
    tcfd_standard: {
        code: 'tcfd_standard',
        src: `${imagePath}/tcfd.png`,
        name: 'TCFD V2 (Task Force on Climate-Related Financial Disclosures)',
        shortName: 'TCFD V2',
        description: 'The Task Force on Climate-Related Financial Disclosures (TCFD) was set up in 2015 by the Financial Stability Board (FSB) to develop voluntary, consistent climate-related financial risk disclosures for use by companies, banks, and investors in providing information to stakeholders.',
        link: 'https://www.fsb-tcfd.org/',
        subgroups: [
            {
                code: 'tcfd_standard_governance',
                shortName: 'TCFD V2 Governance',
                name: 'TCFD V2 Governance',
                subtitle: 'Task Force on Climate-related Financial Disclosures',
                officialCode: '1',
                src: `${imagePath}/tcfd_gov.png`,
            },
            {
                code: 'tcfd_standard_strategy',
                shortName: 'TCFD V2 Strategy',
                name: 'TCFD V2 Strategy',
                subtitle: 'Task Force on Climate-related Financial Disclosures',
                officialCode: '2',
                src: `${imagePath}/tcfd_strategy.png`,
            },
            {
                code: 'tcfd_standard_risk_management',
                shortName: 'TCFD V2 Risk Management',
                name: 'TCFD V2 Risk Management',
                subtitle: 'Task Force on Climate-related Financial Disclosures',
                officialCode: '3',
                src: `${imagePath}/tcfd_risk.png`,
            },
            {
                code: 'tcfd_standard_metrics_and_targets',
                shortName: 'TCFD V2 Metrics and Targets',
                name: 'TCFD V2 Metrics and Targets',
                subtitle: 'Task Force on Climate-related Financial Disclosures',
                officialCode: '4',
                src: `${imagePath}/tcfd_metric.png`,
            },
        ],
        versionGroupCode: 'tcfd',
        version: 2023,
    },
    trucost: {
        code: 'trucost',
        shortName: 'Trucost',
        name: 'Trucost',
        src: `${imagePath}/trucost.png`,
        link: 'https://www.trucost.com/',
    },
    un_gc: {
        code: 'un_gc',
        name: 'UN Global Compact - An Analysis of the Goals and Targets',
        shortName: 'UNGC',
        src: `${imagePath}/un_gc.svg`,
        description: 'Developed by the UN Global Compact and GRI, the publication "An Analysis of the Goals and Targets" aims to aid progress towards these global top priorities by helping businesses large or small, all over the world, improve their reporting and performance on the SDGs.This Analysis is an inventory of possible disclosures per SDG, at the level of the 169 targets.',
        link: 'https://www.globalreporting.org/resourcelibrary/GRI_UNGC_Business-Reporting-on-SDGs_Analysis-of-Goals-and-Targets.pdf',
    },
    un_gc_opf: {
        code: 'un_gc_opf',
        name: 'UN Global Compact Oxfam Poverty Footprint',
        shortName: 'OPF',
        src: `${imagePath}/un_gc_opf.png`,
        description: 'The Poverty Footprint – A People-centred Approach to Assessing Business Impacts on Sustainable Development. An assessment tool that enables companies and civil society partners to understand corporate impacts on multi-dimensional poverty.',
        link: 'https://www.unglobalcompact.org/library/3131'
    },
    uk_finance: {
        code: 'uk_finance',
        name: 'UK Finance - Climate Change Stress Test Sample',
        shortName: 'UK Finance',
        src: `${imagePath}/ukfinance.png`,
        description: 'UK Finance - Climate Change Stress Test Sample Questionnaire.',
    },
    unctad: {
        code: 'unctad',
        name: 'UNCTAD Core SDG Indicators',
        shortName: 'UNCTAD',
        src: `${imagePath}/unctad.png`,
        description: 'The United Nations Conference on Trade and Development was established in 1964 as a permanent intergovernmental body. UNCTAD is the part of the United Nations Secretariat dealing with trade, investment, and development issues.',
        link: 'https://unctad.org/en/Pages/Home.aspx'
    },
    udhr: {
        code: 'udhr',
        name: 'Universal Declaration of Human Rights',
        shortName: 'UNDHR',
        src: `${imagePath}/udhr.png`,
        description: 'The Universal Declaration of Human Rights (UDHR) is a milestone document in the history of human rights. Drafted by representatives with different legal and cultural backgrounds from all regions of the world, the Declaration was proclaimed by the United Nations General Assembly in Paris on 10 December 1948 (General Assembly resolution 217 A) as a common standard of achievements for all peoples and all nations.',
        link: 'https://www.un.org/en/universal-declaration-human-rights/',
    },
    unsdsn: {
        code: 'unsdsn',
        name: 'UNSDSN (United Nations Sustainable Development Solutions Network)',
        shortName: 'UNSDSN',
        src: `${imagePath}/unsdsn.png`,
        description: 'UNSDSN mobilizes global scientific and technological expertise to promote practical solutions for sustainable development, including the implementation of the Sustainable Development Goals (SDGs) and the Paris Climate Agreement.',
        link: 'https://www.unsdsn.org/'
    },
    vigeo_eiris: {
        code: 'vigeo_eiris',
        name: 'Vigeo Eiris ESG Assessment',
        shortName: 'Vigeo Eiris',
        src: `${imagePath}/VigeoEiris.png`,
        description: 'ESG has gone mainstream. Investors are looking for robust ways to integrate ESG data into their workflow. Whether its for risk management, index construction, portfolio management or reporting, V.E\'s ESG Assessment provides you with the insights required to integrate ESG with confidence.',
        link: 'https://vigeo-eiris.com/',
        tags: [Tags.UsRating],
        subgroups: vigeoEiris,
        requiredTags: [RequiredTags.VigeoEiris],
        archived: true,
    },
    bof: {
        code: 'bof',
        shortName: 'BoF',
        name: 'Business of Fashion: Fashion Sustainability Benchmark',
        description: 'The Business of Fashion and McKinsey & Company have teamed up to bring our trademark rigour and evidence to debates within the global fashion industry and to provide an authoritative annual picture of The State of Fashion.',
        src: `${imagePath}/bof-logo.svg`,
        link: 'https://www.businessoffashion.com/',
        tags: [Tags.UsRating],
        subgroups: bofGroup,
        requiredTags: [RequiredTags.BOF]
    },
    wash_pledge: {
        code: 'wash_pledge',
        name: 'WASH Pledge (Water, Sanitation, and Hygiene Pledge)',
        shortName: 'WASH',
        src: `${imagePath}/wash_pledge.png`,
        description: 'The WASH at the workplace Pledge. ... By signing the WASH Pledge, companies commit to implementing access to safe water, sanitation and hygiene at the workplace at an appropriate level of standard for all employees in all premises under their control within three years of signature.',
        link: 'https://www.wbcsd.org/Programs/Food-and-Nature/Water/WASH-access-to-water-sanitation-and-hygiene/WASH-at-the-workplace-Pledge'
    },
    who_ghoi: {
        code: 'who_ghoi',
        name: 'WHO Global Health Observatory Indicator',
        shortName: 'WHO',
        src: `${imagePath}/who_ghoi.png`,
        description: 'The GHO "By indicator" provides a list of all indicators for which the Observatory contains data. Each indicator page consists of a link to the definition of the indicator and a series of links to the various data views that contain information about the selected indicator.',
        link: 'https://www.who.int/'
    },
    w_empowerment: {
        code: 'w_empowerment',
        name: 'Women\'s Empowerment Principles',
        shortName: 'WEP',
        src: `${imagePath}/w_empowerment.png`,
        description: 'The Women’s Empowerment Principles (WEPs) are a set of Principles offering guidance to business on how to promote gender equality and women’s empowerment in the workplace, marketplace and community. Established by UN Global Compact and UN Women, the WEPs are informed by international labour and human rights standards and grounded in he recognition that businesses have a stake in, and a responsibility for, gender equality and women’s empowerment.',
        link: 'https://www.weps.org/'
    },
    w_wbgp: {
        code: 'w_wbgp',
        name: 'Women\'s World Banking Gender Performance',
        shortName: 'WWBGP',
        src: `${imagePath}/w_wbgp.png`,
        description: 'Women\'s World Banking creates greater economic stability and prosperity for women by investing in market-driven financial solutions, institutions, and policy.',
        link: 'https://www.womensworldbanking.org/'
    },
    wb_wdi: {
        code: 'wb_wdi',
        name: 'WDI (World Development Indicators - World Bank)',
        shortName: 'WDI',
        src: `${imagePath}/worldbank_logo.svg`,
        description: 'World Development Indicators (WDI) is the primary World Bank collection of development indicators, compiled from officially recognized international sources.',
        link: 'http://datatopics.worldbank.org/world-development-indicators/'
    },
    wba: {
        code: 'wba',
        shortName: 'WBA',
        name: 'WBA (World Benchmarking Alliance)',
        src: `${imagePath}/wba.png`,
        description: 'The World Benchmarking Alliance (WBA) seeks to generate a movement around increasing the private sector’s impact towards a sustainable future for all. In 2015, the United Nations developed 17 Sustainable Development Goals (SDGs) to help guide us. The WBA is now working to incentivise and accelerate companies’ efforts towards achieving these goals.',
        link: 'https://www.worldbenchmarkingalliance.org/gender-equality-and-empowerment-benchmark/'
    },
    yale_epi: {
        code: 'yale_epi',
        name: 'Yale EPI (Yale Environmental Performance Index)',
        shortName: 'YEPI',
        src: `${imagePath}/yale_epi.png`,
        description: 'The 2018 Environmental Performance Index (EPI) ranks 180 countries on 24 performance indicators across ten issue categories covering environmental health and ecosystem vitality. These metrics provide a gauge at a national scale of how close countries are to established environmental policy goals.',
        link: 'https://epi.envirocenter.yale.edu/'
    },
    ipieca: {
        code: 'ipieca',
        name: 'IPIECA',
        shortName: 'IPIECA',
        src: `${imagePath}/ipieca.png`,
        description: 'IPIECA is the global oil and gas industry association for advancing environmental and social performance. We have been championing good practice for 45 years.',
        link: 'https://www.ipieca.org/about-us/',
        subgroups: ipiecaGroup,
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.Ipieca]
    },
    iogp: {
        code: 'iogp',
        name: 'IOGP (International Association of Oil & Gas Producers)',
        shortName: 'IOGP',
        src: `${imagePath}/iogp.png`,
        description: 'The International Association of Oil & Gas Producers (IOGP) is the petroleum industry\'s global forum in which members identify and share best practices to achieve improvements in health, safety, the environment, security, social responsibility, engineering and operations.',
        link: 'https://www.iogp.org',
        subgroups: iogpGroup,
        tags: [Tags.UsRating],
        requiredTags: [RequiredTags.IOGP]
    },
    sgx_metrics: {
        code: 'sgx_metrics',
        name: 'SG Core',
        shortName: 'SG Core',
        description: '',
        src: `${imagePath}/wwg.png`,
        tags: [Tags.SgRegulatory],
        archived: true,
    },
    sgx_extended: {
        code: 'sgx_extended',
        name: 'SG Extended',
        shortName: 'SG Extended',
        description: '',
        src: `${imagePath}/wwg.png`,
        tags: [Tags.SgRegulatory],
        archived: true,
    },
    issb: {
        code: 'issb',
        name: 'ISSB - International Sustainability Standards Board',
        shortName: 'ISSB',
        src: `${imagePath}/issb_logo.png`,
        description: 'The International Sustainability Standards Board is a standard-setting body established in 2021–2022 under the IFRS Foundation, whose mandate is the creation and development of sustainability-related financial reporting standards to meet investors’ needs for sustainability reporting.',
        link: 'https://www.ifrs.org/',
        subgroups: issbGroup,
        requiredTags: [RequiredTags.ISSB],
    },
    csrd: {
        code: 'csrd',
        name: 'CSRD (Corporate Sustainability Reporting Directive)',
        shortName: 'CSRD',
        src: `${imagePath}/csrd.jpeg`,
        description: '',
        subgroups: csrdGroup,
        requiredTags: [RequiredTags.CSRD],
    },
    ungc_cop: {
        code: 'ungc_cop',
        name: 'UNGC CoP (Communication on Progress)',
        shortName: 'UNGC COP',
        src: `${imagePath}/ungc_cop.svg`,
        subgroups: ungcCopGroup,
    },
    gcc_2024: {
        code: 'gcc_2024',
        name: 'GCC (Gulf Cooperation Council) ESG disclosure',
        shortName: 'GCC',
        src: `${imagePath}/gcc.png`,
        subgroups: gccGroup,
    },
    bursa_malaysia: {
        code: 'bursa_malaysia',
        name: 'Bursa Malaysia',
        shortName: 'Bursa Malaysia',
        src: `${imagePath}/bursamalaysia.jpeg`,
        subgroups: bursaMalaysiaGroup,
    },
    asean_2024: {
        code: 'asean_2024',
        name: 'ASEAN Exchanges Common ESG Metrics',
        shortName: 'ASEAN ESG',
        src: `${imagePath}/asean-2024.svg`,
        link: 'https://www.aseanexchanges.org/',
        subgroups: [
            {
                code: 'asean_2024_env',
                name: 'Environmental Metrics',
                src: `${imagePath}/asean-2024.svg`
            },
            {
                code: 'asean_2024_soc',
                name: 'Social Metrics',
                src: `${imagePath}/asean-2024.svg`
            },
            {
                code: 'asean_2024_gov',
                name: 'Governance Metrics',
                src: `${imagePath}/asean-2024.svg`
            }
        ]
    },
    brsr: {
        code: 'brsr',
        name: 'BRSR - Business Responsibility and Sustainability Report',
        shortName: 'BRSR',
        src: `${imagePath}/brsr.svg`,
        subgroups: brsrGroup,
    },
    tnfd: {
        code: 'tnfd',
        name: 'TNFD (Task Force on Nature-Related Financial Disclosures)',
        shortName: 'TNFD',
        link: 'https://tnfd.global/',
        src: `${imagePath}/tnfd-logo.png`,
        subgroups: tnfdGroup,
    },
    wfn_2024: {
        code: 'wfn_2024',
        name: 'WFN (Workforce Nutrition Alliance)',
        shortName: 'WFN',
        src: `${imagePath}/workforce_nutrition_alliance_logo.png`,
        description: 'The Workforce Nutrition Alliance was launched in October 2019 by the Consumer Goods Forum (CGF) and the Global Alliance for Improved Nutrition (GAIN) to help employers ensure their employees have access to and knowledge about healthy nutrition, breastfeeding support and nutrition-focused health checks. The Workforce Nutrition Alliance’s aim is to support employers to adopt and expand healthier workforce nutrition programmes to reach three million employees in organisations and supply chains by 2025 and over ten million by 2030. We make this impact by focusing on three areas of work.',
        link: 'https://workforcenutrition.org/',
        subgroups: wfnGroup,
        requiredTags: [RequiredTags.WFN],
    },
    wdi_2025: {
        code: 'wdi_2025',
        name: 'WDi (Workforce Disclosure Initiative)',
        shortName: 'WDi',
        src: `${imagePath}/wdi.png`,
        link: 'https://workforcedisclosureinitiative.org/',
        subgroups: wdiGroup,
    },
    msci: {
        code: 'msci',
        shortName: 'MSCI',
        name: 'MSCI Key ESG Issues',
        src: `${imagePath}/msci.png`,
        subgroups: msciGroup,
    },
    aasb: {
        code: 'aasb',
        shortName: 'AASB',
        name: 'AASB (Australian Accounting Standards Board)',
        src: `${imagePath}/aasb_logo.png`,
        subgroups: aasbGroup,
    },
    vsme: {
        code: 'vsme',
        name: "CSRD - VSME (Voluntary Reporting Standard for SMEs)",
        shortName: 'VSME',
        src: `${imagePath}/csrd.jpeg`,
        subgroups: vsmeGroup,
    },
};
const customMetric = {
    code: 'custom_kpi',
    name: 'Custom Metrics',
    shortName: 'Custom Metrics',
    subtitle: '',
    src: `${imagePath}/wwg.png`,
    description: 'Organisation Custom Metrics',
    link: '',
};

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const standardKeys = Object.keys(standards);
const frameworkKeys = Object.keys(frameworks);
const regulatory = {};
standardKeys.forEach(k => {
    if (regulatoryTags.some(tag => standards[k].tags?.includes(tag))) {
        regulatory[k] = standards[k];
    }
});
frameworkKeys.forEach(k => {
    if (regulatoryTags.some(tag => frameworks[k].tags?.includes(tag))) {
        regulatory[k] = frameworks[k];
    }
});

/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
const ratings = [
    ...Object.values(standards),
    ...Object.values(frameworks),
].reduce((acc, group) => {
    if (group.tags?.some(tag => ratingsTags.includes(tag))) {
        acc[group.code] = group;
    }
    return acc;
}, {});

const sdgGroupFull = [
    {
        "code": "1",
        "name": "No Poverty",
        "subgroups": [
            {
                "code": "1.1",
                "name": "Eradicate Extreme Poverty"
            },
            {
                "code": "1.2",
                "name": "Reduce Poverty By At Least 50%"
            },
            {
                "code": "1.3",
                "name": "Implement Social Protection Systems"
            },
            {
                "code": "1.4",
                "name": "Equal Rights To Ownership, Basic Services, Technology And Economic Resources"
            },
            {
                "code": "1.5",
                "name": "Build Resilience To Environmental, Economic And Social Disasters"
            },
            {
                "code": "1.a",
                "name": "Mobilize Resources To Implement Policies To End Poverty",
                "hidden": true
            },
            {
                "code": "1.b",
                "name": "Create Pro-Poor And Gender-Sensitive Policy Frameworks",
                "hidden": true
            }
        ]
    },
    {
        "code": "2",
        "name": "Zero Hunger",
        "subgroups": [
            {
                "code": "2.1",
                "name": "Universal Access To Safe And Nutritious Food"
            },
            {
                "code": "2.2",
                "name": "End All Forms Of Malnutrition"
            },
            {
                "code": "2.3",
                "name": "Double The Productivity And Incomes Of Small-Scale Food Producers"
            },
            {
                "code": "2.4",
                "name": "Sustainable Food Production And Resilient Agricultural Practices"
            },
            {
                "code": "2.5",
                "name": "Maintain The Genetic Diversity In Food Production"
            },
            {
                "code": "2.a",
                "name": "Invest In Rural Infrastructure, Agricultural Research, Technology And Gene Banks",
                "hidden": true
            },
            {
                "code": "2.b",
                "name": "Prevent Agricultural Trade Restrictions, Market Distortions And Export Subsidies",
                "hidden": true
            },
            {
                "code": "2.c",
                "name": "Ensure Stable Food Commodity Markets And Timely Access To Information",
                "hidden": true
            }
        ]
    },
    {
        "code": "3",
        "name": "Good Health And Well-Being",
        "subgroups": [
            {
                "code": "3.1",
                "name": "Reduce Maternal Mortality"
            },
            {
                "code": "3.2",
                "name": "End All Preventable Deaths Under 5 Years Of Age"
            },
            {
                "code": "3.3",
                "name": "Fight Communicable Diseases"
            },
            {
                "code": "3.4",
                "name": "Reduce Mortality From Non-Communicable Diseases And Promote Mental Health"
            },
            {
                "code": "3.5",
                "name": "Prevent And Treat Substance Abuse"
            },
            {
                "code": "3.6",
                "name": "Reduce Road Injuries And Deaths"
            },
            {
                "code": "3.7",
                "name": "Universal Access To Sexual And Reproductive Care, Family Planning And Education"
            },
            {
                "code": "3.8",
                "name": "Achieve Universal Health Coverage"
            },
            {
                "code": "3.9",
                "name": "Reduce Illnesses And Death From Hazardous Chemicals And Pollution"
            },
            {
                "code": "3.a",
                "name": "Implement The Who Framework Convention On Tobacco Control",
                "hidden": true
            },
            {
                "code": "3.b",
                "name": "Support Research, Development And Universal Access To Affordable Vaccines And Medicines",
                "hidden": true
            },
            {
                "code": "3.c",
                "name": "Increase Health Financing And Support Health Workforce In Developing Countries",
                "hidden": true
            },
            {
                "code": "3.d",
                "name": "Improve Early Warning Systems For Global Health Risks",
                "hidden": true
            }
        ]
    },
    {
        "code": "4",
        "name": "Quality Education",
        "subgroups": [
            {
                "code": "4.1",
                "name": "Free Primary And Secondary Education"
            },
            {
                "code": "4.2",
                "name": "Equal Access To Quality Pre-Primary Education"
            },
            {
                "code": "4.3",
                "name": "Equal Access To Affordable Technical, Vocational And Higher Education"
            },
            {
                "code": "4.4",
                "name": "Increase The Number Of People With Relevant Skills For Financial Success"
            },
            {
                "code": "4.5",
                "name": "Eliminate All Discrimination In Education"
            },
            {
                "code": "4.6",
                "name": "Universal Literacy And Numeracy"
            },
            {
                "code": "4.7",
                "name": "Education For Sustainable Development And Global Citizenship"
            },
            {
                "code": "4.a",
                "name": "Build And Upgrade Inclusive And Safe Schools",
                "hidden": true
            },
            {
                "code": "4.b",
                "name": "Expand Higher Education Scholarships For Developing Countries",
                "hidden": true
            },
            {
                "code": "4.c",
                "name": "Increase The Supply Of Qualified Teachers In Developing Countries",
                "hidden": true
            }
        ]
    },
    {
        "code": "5",
        "name": "Gender Equality",
        "subgroups": [
            {
                "code": "5.1",
                "name": "End Discrimination Against Women And Girls"
            },
            {
                "code": "5.2",
                "name": "End All Violence Against And Exploitation Of Women And Girls"
            },
            {
                "code": "5.3",
                "name": "Eliminate Forced Marriages And Genital Mutilation"
            },
            {
                "code": "5.4",
                "name": "Value Unpaid Care And Promote Shared Domestic Responsibilities"
            },
            {
                "code": "5.5",
                "name": "Ensure Full Participation In Leadership And Decision-Making"
            },
            {
                "code": "5.6",
                "name": "Universal Access To Reproductive Health And Rights"
            },
            {
                "code": "5.a",
                "name": "Equal Rights To Economic Resources, Property Ownership And Financial Services",
                "hidden": true
            },
            {
                "code": "5.b",
                "name": "Promote Empowerment Of Women Through Technology",
                "hidden": true
            },
            {
                "code": "5.c",
                "name": "Adopt And Strengthen Policies And Enforceable Legislation For Gender Equality",
                "hidden": true
            }
        ]
    },
    {
        "code": "6",
        "name": "Clean Water And Sanitation",
        "subgroups": [
            {
                "code": "6.1",
                "name": "Safe And Affordable Drinking Water"
            },
            {
                "code": "6.2",
                "name": "End Open Defecation And Provide Access To Sanitation And Hygiene"
            },
            {
                "code": "6.3",
                "name": "Improve Water Quality, Wastewater Treatment And Safe Reuse"
            },
            {
                "code": "6.4",
                "name": "Increase Water-Use Efficiency And Ensure Freshwater Supplies"
            },
            {
                "code": "6.5",
                "name": "Implement Integrated Water Resources Management"
            },
            {
                "code": "6.6",
                "name": "Protect And Restore Water-Related Ecosystems"
            },
            {
                "code": "6.a",
                "name": "Expand Water And Sanitation Support To Developing Countries",
                "hidden": true
            },
            {
                "code": "6.b",
                "name": "Support Local Engagement In Water And Sanitation Management",
                "hidden": true
            }
        ]
    },
    {
        "code": "7",
        "name": "Affordable And Clean Energy",
        "subgroups": [
            {
                "code": "7.1",
                "name": "Universal Access To Modern Energy"
            },
            {
                "code": "7.2",
                "name": "Increase Global Percentage Of Renewable Energy"
            },
            {
                "code": "7.3",
                "name": "Double The Improvement In Energy Efficiency"
            },
            {
                "code": "7.a",
                "name": "Promote Access To Research, Technology And Investments In Clean Energy",
                "hidden": true
            },
            {
                "code": "7.b",
                "name": "Expand And Upgrade Energy Services For Developing Countries",
                "hidden": true
            }
        ]
    },
    {
        "code": "8",
        "name": "Decent Work And Economic Growth",
        "subgroups": [
            {
                "code": "8.2",
                "name": "Sustainable Economic Growth"
            },
            {
                "code": "8.3",
                "name": "Diversify, Innovate And Upgrade For Economic Productivity"
            },
            {
                "code": "8.4",
                "name": "Promote Policies To Support Job Creation And Growing Enterprises"
            },
            {
                "code": "8.5",
                "name": "Improve Resource Efficiency In Consumption And Production"
            },
            {
                "code": "8.6",
                "name": "Full Employment And Decent Work With Equal Pay"
            },
            {
                "code": "8.7",
                "name": "Promote Youth Employment, Education And Training"
            },
            {
                "code": "8.1",
                "name": "End Modern Slavery, Trafficking And Child Labour"
            },
            {
                "code": "8.8",
                "name": "Protect Labour Rights And Promote Safe Working Environments"
            },
            {
                "code": "8.9",
                "name": "Promote Beneficial And Sustainable Tourism"
            },
            {
                "code": "8.10",
                "name": "Universal Access To Banking, Insurance And Financial Services"
            },
            {
                "code": "8.a",
                "name": "Increase Aid For Trade Support",
                "hidden": true
            },
            {
                "code": "8.b",
                "name": "Develop A Global Youth Employment Strategy",
                "hidden": true
            }
        ]
    },
    {
        "code": "9",
        "name": "Industry, Innovation And Infrastructure",
        "subgroups": [
            {
                "code": "9.1",
                "name": "Develop Sustainable, Resilient And Inclusive Infrastructures"
            },
            {
                "code": "9.2",
                "name": "Promote Inclusive And Sustainable Industrialization"
            },
            {
                "code": "9.3",
                "name": "Increase Access To Financial Services And Markets"
            },
            {
                "code": "9.4",
                "name": "Upgrade All Industries And Infrastructures For Sustainability"
            },
            {
                "code": "9.5",
                "name": "Enhance Research And Upgrade Industrial Technologies"
            },
            {
                "code": "9.a",
                "name": "Facilitate Sustainable Infrastructure Development For Developing Countries",
                "hidden": true
            },
            {
                "code": "9.b",
                "name": "Support Domestic Technology Development And Industrial Diversification",
                "hidden": true
            },
            {
                "code": "9.c",
                "name": "Universal Access To Information And Communications Technology",
                "hidden": true
            }
        ]
    },
    {
        "code": "10",
        "name": "Reduced Inequalities",
        "subgroups": [
            {
                "code": "10.1",
                "name": "Reduce Income Inequalities"
            },
            {
                "code": "10.2",
                "name": "Promote Universal Social, Economic And Political Inclusion"
            },
            {
                "code": "10.3",
                "name": "Ensure Equal Opportunities And End Discrimination"
            },
            {
                "code": "10.4",
                "name": "Adopt Fiscal And Social Policies That Promotes Equality"
            },
            {
                "code": "10.5",
                "name": "Improved Regulation Of Global Financial Markets And Institutions"
            },
            {
                "code": "10.6",
                "name": "Enhanced Representation For Developing Countries In Financial Institutions"
            },
            {
                "code": "10.7",
                "name": "Responsible And Well-Managed Migration Policies"
            },
            {
                "code": "10.a",
                "name": "Special And Differential Treatment For Developing Countries",
                "hidden": true
            },
            {
                "code": "10.b",
                "name": "Encourage Development Assistance And Investment In Least Developed Countries",
                "hidden": true
            },
            {
                "code": "10.c",
                "name": "Reduce Transaction Costs For Migrant Remittances",
                "hidden": true
            }
        ]
    },
    {
        "code": "11",
        "name": "Sustainable Cities And Communities",
        "subgroups": [
            {
                "code": "11.1",
                "name": "Safe And Affordable Housing"
            },
            {
                "code": "11.2",
                "name": "Affordable And Sustainable Transport Systems"
            },
            {
                "code": "11.3",
                "name": "Inclusive And Sustainable Urbanization"
            },
            {
                "code": "11.4",
                "name": "Protect The World’s Cultural And Natural Heritage"
            },
            {
                "code": "11.5",
                "name": "Reduce The Adverse Effects Of Natural Disasters"
            },
            {
                "code": "11.6",
                "name": "Reduce The Environmental Impact Of Cities"
            },
            {
                "code": "11.7",
                "name": "Provide Access To Safe And Inclusive Green And Public Spaces"
            },
            {
                "code": "11.a",
                "name": "Strong National And Regional Development Planning",
                "hidden": true
            },
            {
                "code": "11.b",
                "name": "Implement Policies For Inclusion, Resource Efficiency And Disaster Risk Reduction",
                "hidden": true
            },
            {
                "code": "11.c",
                "name": "Support Least Developed Countries In Sustainable And Resilient Building",
                "hidden": true
            }
        ]
    },
    {
        "code": "12",
        "name": "Responsible Consumption And Production",
        "subgroups": [
            {
                "code": "12.1",
                "name": "Implement The 10-Year Sustainable Consumption And Production Framework"
            },
            {
                "code": "12.2",
                "name": "Sustainable Management And Use Of Natural Resources"
            },
            {
                "code": "12.3",
                "name": "Halve Global Per Capita Food Waste"
            },
            {
                "code": "12.4",
                "name": "Responsible Management Of Chemicals And Waste"
            },
            {
                "code": "12.5",
                "name": "Substantially Reduce Waste Generation"
            },
            {
                "code": "12.6",
                "name": "Encourage Companies To Adopt Sustainable Practices And Sustainability Reporting"
            },
            {
                "code": "12.7",
                "name": "Promote Sustainable Public Procurement Practices"
            },
            {
                "code": "12.8",
                "name": "Promote Universal Understanding Of Sustainable Lifestyles"
            },
            {
                "code": "12.a",
                "name": "Support Developing Countries' Scientific And Technological Capacity For Sustainable CONSUMPTION AND PRODUCTION",
                "hidden": true
            },
            {
                "code": "12.b",
                "name": "Develop And Implement Tools To Monitor Sustainable Tourism",
                "hidden": true
            },
            {
                "code": "12.c",
                "name": "Remove Market Distortions That Encourage Wasteful Consumption",
                "hidden": true
            }
        ]
    },
    {
        "code": "13",
        "name": "Climate Action",
        "subgroups": [
            {
                "code": "13.1",
                "name": "Strengthen Resilience And Adaptive Capacity To Climate Related Disasters"
            },
            {
                "code": "13.2",
                "name": "Integrate Climate Change Measures Into Policies And Planning"
            },
            {
                "code": "13.3",
                "name": "Build Knowledge And Capacity To Meet Climate Change"
            },
            {
                "code": "13.a",
                "name": "Implement The Un Framework Convention On Climate Change",
                "hidden": true
            },
            {
                "code": "13.b",
                "name": "Promote Mechanisms To Raise Capacity For Planning And Management",
                "hidden": true
            }
        ]
    },
    {
        "code": "14",
        "name": "Life Below Water",
        "subgroups": [
            {
                "code": "14.1",
                "name": "Reduce Marine Pollution"
            },
            {
                "code": "14.6",
                "name": "Protect And Restore Ecosystems"
            },
            {
                "code": "14.2",
                "name": "Reduce Ocean Acidification"
            },
            {
                "code": "14.7",
                "name": "Sustainable Fishing"
            },
            {
                "code": "14.3",
                "name": "Conserve Coastal And Marine Areas"
            },
            {
                "code": "14.a",
                "name": "End Subsidies Contributing To Overfishing",
                "hidden": true
            },
            {
                "code": "14.4",
                "name": "Increase The Economic Benefits From Sustainable Use Of Marine Resources"
            },
            {
                "code": "14.b",
                "name": "Increase Scientific Knowledge, Research And Technology For Ocean Health",
                "hidden": true
            },
            {
                "code": "14.5",
                "name": "Support Small Scale Fishers",
                "hidden": true
            },
            {
                "code": "14.c",
                "name": "Implement And Enforce International Sea Law",
                "hidden": true
            }
        ]
    },
    {
        "code": "15",
        "name": "Life On Land",
        "subgroups": [
            {
                "code": "15.1",
                "name": "Conserve And Restore Terrestrial And Freshwater Ecosystems"
            },
            {
                "code": "15.2",
                "name": "End Deforestation And Restore Degraded Forests"
            },
            {
                "code": "15.3",
                "name": "End Desertification And Restore Degraded Land"
            },
            {
                "code": "15.4",
                "name": "Ensure Conservation Of Mountain Ecosystems"
            },
            {
                "code": "15.5",
                "name": "Protect Biodiversity And Natural Habitats"
            },
            {
                "code": "15.6",
                "name": "Promote Access To Genetic Resources And Fair Sharing Of The Benefits"
            },
            {
                "code": "15.7",
                "name": "Eliminate Poaching And Trafficking Of Protected Species"
            },
            {
                "code": "15.8",
                "name": "Prevent Invasive Alien Species On Land And In Water Ecosystems"
            },
            {
                "code": "15.9",
                "name": "Integrate Ecosystem And Biodiversity In Governmental Planning"
            },
            {
                "code": "15.a",
                "name": "Increase Financial Resources To Conserve And Sustainably Use Ecosystem And Biodiversity",
                "hidden": true
            },
            {
                "code": "15.b",
                "name": "Finance And Incentivize Sustainable Forest Management",
                "hidden": true
            },
            {
                "code": "15.c",
                "name": "Combat Global Poaching And Trafficking",
                "hidden": true
            }
        ]
    },
    {
        "code": "16",
        "name": "Peace, Justice And Strong Institutions",
        "subgroups": [
            {
                "code": "16.1",
                "name": "Reduce Violence Everywhere"
            },
            {
                "code": "16.2",
                "name": "Protect Children From Abuse, Exploitation, Trafficking And Violence"
            },
            {
                "code": "16.3",
                "name": "Promote The Rule Of Law And Ensure Equal Access To Justice"
            },
            {
                "code": "16.4",
                "name": "Combat Organized Crime And Illicit Financial And Arms Flows"
            },
            {
                "code": "16.5",
                "name": "Substantially Reduce Corruption And Bribery"
            },
            {
                "code": "16.6",
                "name": "Develop Effective, Accountable And Transparent Institutions"
            },
            {
                "code": "16.7",
                "name": "Ensure Responsive, Inclusive And Representative Decision-Making"
            },
            {
                "code": "16.8",
                "name": "Strengthen The Participation In Global Governance"
            },
            {
                "code": "16.9",
                "name": "Provide Universal Legal Identity"
            },
            {
                "code": "16.10",
                "name": "Ensure Public Access To Information And Protect Fundamental Freedoms"
            },
            {
                "code": "16.a",
                "name": "Strengthen National Institutions To Prevent Violence And Combat Terrorism And Crime",
                "hidden": true
            },
            {
                "code": "16.b",
                "name": "Promote And Enforce Non-Discriminatory Laws And Policies",
                "hidden": true
            }
        ]
    },
    {
        "code": "17",
        "name": "Partnership For The Goals",
        "subgroups": [
            {
                "code": "17.1",
                "name": "Mobilize Resources To Improve Domestic Revenue Collection"
            },
            {
                "code": "17.2",
                "name": "Implement All Development Assistance Commitments"
            },
            {
                "code": "17.3",
                "name": "Mobilize Financial Resources For Developing Countries"
            },
            {
                "code": "17.4",
                "name": "Assist Developing Countries In Attaining Debt Sustainability"
            },
            {
                "code": "17.5",
                "name": "Invest In Least Developed Countries"
            },
            {
                "code": "17.6",
                "name": "Knowledge Sharing And Cooperation For Access To Science, Technology And Innovation"
            },
            {
                "code": "17.7",
                "name": "Promote Sustainable Technologies To Developing Countries"
            },
            {
                "code": "17.8",
                "name": "Strengthen The Science, Technology And Innovation Capacity For Least Developed CountRIES"
            },
            {
                "code": "17.9",
                "name": "Enhance SDG Capacity In Developing Countries"
            },
            {
                "code": "17.10",
                "name": "Promote A Universal Trading System Under The Wto"
            },
            {
                "code": "17.11",
                "name": "Increase The Exports Of Developing Countries"
            },
            {
                "code": "17.12",
                "name": "Remove Trade Barriers For Least Developed Countries"
            },
            {
                "code": "17.13",
                "name": "Enhance Global Macroeconomic Stability"
            },
            {
                "code": "17.14",
                "name": "Enhance Policy Coherence For Sustainable Development"
            },
            {
                "code": "17.15",
                "name": "Respect National Leadership To Implement Policies For The Sustainable Development GoALS"
            },
            {
                "code": "17.16",
                "name": "Enhance The Global Partnership For Sustainable Development"
            },
            {
                "code": "17.17",
                "name": "Encourage Effective Partnerships"
            },
            {
                "code": "17.18",
                "name": "Enhance Availability Of Reliable Data"
            },
            {
                "code": "17.19",
                "name": "Further Develop Measurements Of Progress"
            }
        ]
    }
];
const sdgGroup = sdgGroupFull.map(goal => {
    return {
        ...goal,
        subgroups: goal.subgroups?.filter(t => !t.hidden)
    };
});

/** True unless the group is a beta the company does not have, e.g. for validating a scope change. */
const canAccessBetaGroup = (group, features = []) => !group.betaFeature || features.some((f) => f.code === group.betaFeature && f.active);
/** True only for a beta group the company has been given, e.g. to show an otherwise hidden card. */
const isBetaUnlocked = (group, features) => Boolean(group.betaFeature) && canAccessBetaGroup(group, features);
/** A beta group is offered only to companies with its feature; any other group unless it is hidden. */
const isGroupOffered = (group, features) => group.betaFeature ? canAccessBetaGroup(group, features) : !group.hidden;
const getSubGroup = (group, code) => {
    return group.subgroups?.find(g => g.code === code);
};
const findGroupByChildCode = (group, code) => {
    if (!group.subgroups) {
        return undefined;
    }
    for (const groupElement of group.subgroups) {
        if (groupElement.code === code || findGroupByChildCode(groupElement, code)) {
            return groupElement;
        }
    }
};
const findChildByCode = (group, code) => {
    if (!group.subgroups) {
        return undefined;
    }
    for (const groupElement of group.subgroups) {
        if (groupElement.code === code) {
            return groupElement;
        }
        const childGroup = findGroupByChildCode(groupElement, code);
        if (childGroup) {
            return childGroup;
        }
    }
};
const getGroupChildrenTags = (group) => {
    const validCodes = [];
    if (!group.subgroups) {
        return validCodes;
    }
    for (const groupElement of group.subgroups) {
        validCodes.push(groupElement.code, ...getGroupChildrenTags(groupElement));
    }
    return validCodes;
};
/** Descends the subgroups picking the first child whose code is in `tags`, e.g. WFN pillar → Quality. */
const getSubGroupPathByTags = (group, tags) => {
    const path = [];
    let current = group;
    while (current.subgroups) {
        const next = current.subgroups.find((subgroup) => tags.includes(subgroup.code));
        if (!next) {
            break;
        }
        path.push(next);
        current = next;
    }
    return path;
};

const getGroup = (type, code) => {
    if (code === customMetric.code) {
        return customMetric;
    }
    switch (type) {
        case "sdg":
            return sdgGroup.find(g => g.code === code);
        case "standards-and-frameworks":
        case "regulatory":
        case "ratings":
            return standards[code] ?? frameworks[code];
        case "standards":
            return standards[code];
        case "frameworks":
            return frameworks[code];
        default:
            return undefined;
    }
};

const getDefaultScopePacks = () => {
    return {
        access: 'custom',
        scope: {
            standards: [],
            frameworks: [],
        },
        restricted: true,
    };
};

var ValueAggregation;
(function (ValueAggregation) {
    ValueAggregation["ValueSumAggregator"] = "valueSumAggregator";
    ValueAggregation["ValueCountAggregator"] = "valueCountAggregator";
    ValueAggregation["ValueConcatenateAggregator"] = "valueConcatenateAggregator";
    ValueAggregation["ValueAverageAggregator"] = "valueAverageAggregator";
    ValueAggregation["ValueListCountAggregator"] = "valueListCountAggregator";
    ValueAggregation["TextCountAggregator"] = "textCountAggregator";
    ValueAggregation["NumericValueListSumAggregator"] = "numericValueListSumAggregator";
    ValueAggregation["NumericValueListAverageAggregator"] = "numericValueListAverageAggregator";
    ValueAggregation["TableColumnAggregator"] = "tableAggregator";
    ValueAggregation["TableConcatenationAggregator"] = "tableConcatenationAggregator";
    ValueAggregation["LatestAggregator"] = "latestAggregator";
    ValueAggregation["EmptyAggregator"] = "emptyAggregator";
    ValueAggregation["TableRowGroupAggregator"] = "tableRowGroupAggregator";
    ValueAggregation["TextAISummaryAggregator"] = "textAISummaryAggregator";
})(ValueAggregation || (ValueAggregation = {}));
var ColumnValueAggregation;
(function (ColumnValueAggregation) {
    ColumnValueAggregation["ColumnSumAggregator"] = "columnSumAggregator";
    ColumnValueAggregation["ColumnAverageAggregator"] = "columnAverageAggregator";
    ColumnValueAggregation["ColumnLatestAggregator"] = "columnLatestAggregator";
    ColumnValueAggregation["ColumnMaxAggregator"] = "columnMaxAggregator";
    ColumnValueAggregation["ColumnEmptyAggregator"] = "columnEmptyAggregator";
    ColumnValueAggregation["ColumnConcatenateAggregator"] = "columnConcatenateAggregator";
    ColumnValueAggregation["ColumnPostAggregationCalculation"] = "columnPostAggregationCalculation";
    ColumnValueAggregation["ColumnWeightedAverageAggregator"] = "columnWeightedAverageAggregator";
    ColumnValueAggregation["ColumnAISummaryAggregator"] = "columnAISummaryAggregator";
})(ColumnValueAggregation || (ColumnValueAggregation = {}));
// Aggregation mode enum for better organization
var AggregationMode;
(function (AggregationMode) {
    AggregationMode["Children"] = "children";
    AggregationMode["Combined"] = "combined";
})(AggregationMode || (AggregationMode = {}));
const aggregationTypes = {
    latestAggregator: 'LATEST VALUE: Most recently submitted value',
    valueSumAggregator: 'SUM: Add up all values',
    valueAverageAggregator: 'AVERAGE: Simple average',
    valueConcatenateAggregator: 'CONCAT: Concat submitted values',
    valueListCountAggregator: 'TEXT VALUE LIST COUNT: Create a list of possible options with their respective counts',
    numericValueListAverageAggregator: 'VALUE LIST AVERAGE: Simple average from each list option',
    textCountAggregator: 'TEXT LIST COUNT: Create a list of possible text options with their respective counts',
    numericValueListSumAggregator: 'VALUE LIST SUM: Add up each list option',
    tableAggregator: 'TABLE: Aggregation will respect the aggregation method specified in the configuration for the column',
    tableRowGroupAggregator: 'TABLE ROW GROUP: Aggregation will group by columns, and then respect the aggregation method specified in the configuration for the column',
    tableConcatenationAggregator: 'TABLE CONCATENATION: Appends all rows to table',
    emptyAggregator: 'IGNORE: Do not aggregate',
    valueCountAggregator: 'COUNT: Count of submitted instance for this input',
    textAISummaryAggregator: "AI SUMMARY: Generate AI-powered summary of aggregated text values",
};
const columnAggregationTypes = {
    columnSumAggregator: 'SUM: Add up all column values',
    columnAverageAggregator: 'AVERAGE: Simple average of column values',
    columnLatestAggregator: 'LATEST: Most recently submitted column value',
    columnMaxAggregator: 'MAX: Maximum column value',
    columnEmptyAggregator: 'IGNORE: Do not aggregate column',
    columnConcatenateAggregator: 'CONCAT: Concatenate column values',
    columnPostAggregationCalculation: 'CALCULATE: Recalculate after aggregation',
    columnWeightedAverageAggregator: 'WEIGHTED AVERAGE: Weighted average using weight formula',
    columnAISummaryAggregator: "AI SUMMARY: Generate AI-powered summary of aggregated column values",
};
var UtrValueType;
(function (UtrValueType) {
    UtrValueType["Number"] = "number";
    UtrValueType["Sample"] = "sample";
    UtrValueType["Percentage"] = "percentage";
    UtrValueType["Text"] = "text";
    UtrValueType["Date"] = "date";
    UtrValueType["ValueListMulti"] = "valueListMulti";
    UtrValueType["ValueList"] = "valueList";
    UtrValueType["NumericValueList"] = "numericValueList";
    UtrValueType["TextValueList"] = "textValueList";
    UtrValueType["Table"] = "table";
})(UtrValueType || (UtrValueType = {}));
var ColumnType;
(function (ColumnType) {
    ColumnType["Number"] = "number";
    ColumnType["Text"] = "text";
    ColumnType["Date"] = "date";
    ColumnType["Percentage"] = "percentage";
    ColumnType["ValueList"] = "valueList";
    ColumnType["ValueListMulti"] = "valueListMulti";
})(ColumnType || (ColumnType = {}));
const defaultCompatible = [
    ValueAggregation.LatestAggregator,
    ValueAggregation.EmptyAggregator,
    ValueAggregation.ValueCountAggregator,
];
const ValueAggregationSiblingsCompatibility = {
    [UtrValueType.Number]: {
        default: ValueAggregation.ValueSumAggregator,
        compatible: [...defaultCompatible, ValueAggregation.ValueSumAggregator, ValueAggregation.ValueAverageAggregator],
    },
    [UtrValueType.Percentage]: {
        default: ValueAggregation.ValueAverageAggregator,
        compatible: [...defaultCompatible, ValueAggregation.ValueSumAggregator, ValueAggregation.ValueAverageAggregator],
    },
    [UtrValueType.Table]: {
        default: ValueAggregation.TableColumnAggregator,
        compatible: [
            ...defaultCompatible,
            ValueAggregation.TableColumnAggregator,
            ValueAggregation.TableConcatenationAggregator,
            ValueAggregation.TableRowGroupAggregator,
        ],
    },
    [UtrValueType.NumericValueList]: {
        default: ValueAggregation.NumericValueListSumAggregator,
        compatible: [
            ...defaultCompatible,
            ValueAggregation.NumericValueListSumAggregator,
            ValueAggregation.NumericValueListAverageAggregator,
        ],
    },
    [UtrValueType.ValueListMulti]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [...defaultCompatible, ValueAggregation.ValueListCountAggregator],
    },
    [UtrValueType.ValueList]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [...defaultCompatible, ValueAggregation.ValueListCountAggregator],
    },
    [UtrValueType.Text]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [
            ...defaultCompatible,
            ValueAggregation.TextCountAggregator,
            ValueAggregation.ValueConcatenateAggregator,
            ValueAggregation.TextAISummaryAggregator,
        ],
    },
    [UtrValueType.Date]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [...defaultCompatible, ValueAggregation.TextCountAggregator],
    },
    // Unhandled
    [UtrValueType.Sample]: {
        default: ValueAggregation.LatestAggregator,
        compatible: defaultCompatible,
    },
    [UtrValueType.TextValueList]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [...defaultCompatible, ValueAggregation.TextCountAggregator],
    },
};
const ValueAggregationChildrenCompatibility = {
    [UtrValueType.Number]: {
        default: ValueAggregation.ValueSumAggregator,
        compatible: [ValueAggregation.ValueSumAggregator, ValueAggregation.EmptyAggregator],
    },
    [UtrValueType.Percentage]: {
        default: ValueAggregation.ValueAverageAggregator,
        compatible: [ValueAggregation.ValueAverageAggregator, ValueAggregation.EmptyAggregator],
    },
    [UtrValueType.Table]: {
        default: ValueAggregation.TableColumnAggregator,
        compatible: [
            ValueAggregation.TableColumnAggregator,
            ValueAggregation.TableRowGroupAggregator,
            ValueAggregation.EmptyAggregator,
        ],
    },
    [UtrValueType.NumericValueList]: {
        default: ValueAggregation.NumericValueListSumAggregator,
        compatible: [ValueAggregation.NumericValueListSumAggregator, ValueAggregation.EmptyAggregator],
    },
    [UtrValueType.ValueListMulti]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [ValueAggregation.LatestAggregator, ValueAggregation.EmptyAggregator],
    },
    [UtrValueType.ValueList]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [ValueAggregation.LatestAggregator, ValueAggregation.EmptyAggregator],
    },
    [UtrValueType.Text]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [
            ValueAggregation.LatestAggregator,
            ValueAggregation.EmptyAggregator,
            ValueAggregation.ValueConcatenateAggregator,
            ValueAggregation.TextAISummaryAggregator,
        ],
    },
    [UtrValueType.Date]: {
        default: ValueAggregation.LatestAggregator,
        compatible: [ValueAggregation.LatestAggregator, ValueAggregation.EmptyAggregator],
    },
    // Unhandled
    [UtrValueType.Sample]: {
        default: ValueAggregation.LatestAggregator,
        compatible: defaultCompatible,
    },
    [UtrValueType.TextValueList]: {
        default: ValueAggregation.LatestAggregator,
        compatible: defaultCompatible,
    },
};
const ColumnAggregationCompatibility = {
    [ColumnType.Number]: {
        default: ColumnValueAggregation.ColumnSumAggregator,
        compatible: [
            ColumnValueAggregation.ColumnSumAggregator,
            ColumnValueAggregation.ColumnAverageAggregator,
            ColumnValueAggregation.ColumnLatestAggregator,
            ColumnValueAggregation.ColumnMaxAggregator,
            ColumnValueAggregation.ColumnEmptyAggregator,
            ColumnValueAggregation.ColumnPostAggregationCalculation,
            ColumnValueAggregation.ColumnWeightedAverageAggregator,
        ],
    },
    [ColumnType.Percentage]: {
        default: ColumnValueAggregation.ColumnAverageAggregator,
        compatible: [
            ColumnValueAggregation.ColumnAverageAggregator,
            ColumnValueAggregation.ColumnSumAggregator,
            ColumnValueAggregation.ColumnLatestAggregator,
            ColumnValueAggregation.ColumnMaxAggregator,
            ColumnValueAggregation.ColumnEmptyAggregator,
            ColumnValueAggregation.ColumnPostAggregationCalculation,
            ColumnValueAggregation.ColumnWeightedAverageAggregator,
        ],
    },
    [ColumnType.Text]: {
        default: ColumnValueAggregation.ColumnLatestAggregator,
        compatible: [
            ColumnValueAggregation.ColumnLatestAggregator,
            ColumnValueAggregation.ColumnEmptyAggregator,
            ColumnValueAggregation.ColumnConcatenateAggregator,
            ColumnValueAggregation.ColumnAISummaryAggregator,
        ],
    },
    [ColumnType.Date]: {
        default: ColumnValueAggregation.ColumnLatestAggregator,
        compatible: [ColumnValueAggregation.ColumnLatestAggregator, ColumnValueAggregation.ColumnEmptyAggregator],
    },
    [ColumnType.ValueListMulti]: {
        default: ColumnValueAggregation.ColumnLatestAggregator,
        compatible: [ColumnValueAggregation.ColumnLatestAggregator, ColumnValueAggregation.ColumnEmptyAggregator],
    },
    [ColumnType.ValueList]: {
        default: ColumnValueAggregation.ColumnLatestAggregator,
        compatible: [ColumnValueAggregation.ColumnLatestAggregator, ColumnValueAggregation.ColumnEmptyAggregator],
    },
};
function getDefaultAggregation(valueType, mode = AggregationMode.Combined) {
    if (!valueType) {
        return ValueAggregation.EmptyAggregator;
    }
    const isCombinedAggregation = mode === AggregationMode.Combined;
    const compatibility = isCombinedAggregation
        ? ValueAggregationSiblingsCompatibility[valueType]
        : ValueAggregationChildrenCompatibility[valueType];
    return compatibility.default;
}
const getCompatibleAggregations = (valueType, mode) => {
    const compatibility = mode === AggregationMode.Combined ? ValueAggregationSiblingsCompatibility : ValueAggregationChildrenCompatibility;
    const typeConfig = compatibility[valueType];
    return typeConfig ? typeConfig.compatible : [ValueAggregation.EmptyAggregator];
};
function getColumnAggregations(columnType) {
    if (!columnType) {
        return [ColumnValueAggregation.ColumnEmptyAggregator];
    }
    const compatible = ColumnAggregationCompatibility[columnType].compatible ?? [
        ColumnValueAggregation.ColumnEmptyAggregator,
    ];
    return compatible;
}

/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */
var SupportedMeasureUnits;
(function (SupportedMeasureUnits) {
    SupportedMeasureUnits["time"] = "time";
    SupportedMeasureUnits["area"] = "area";
    SupportedMeasureUnits["mass"] = "mass";
    SupportedMeasureUnits["volume"] = "volume";
    SupportedMeasureUnits["energy"] = "energy";
    SupportedMeasureUnits["currency"] = "currency";
    SupportedMeasureUnits["co2Emissions"] = "co2Emissions";
    SupportedMeasureUnits["partsPer"] = "partsPer";
    SupportedMeasureUnits["numberScale"] = "numberScale";
    SupportedMeasureUnits["length"] = "length";
})(SupportedMeasureUnits || (SupportedMeasureUnits = {}));
var NumberScale;
(function (NumberScale) {
    NumberScale["Single"] = "single";
    NumberScale["Hundreds"] = "hundreds";
    NumberScale["Thousands"] = "thousands";
    NumberScale["Millions"] = "millions";
    NumberScale["Billions"] = "billions";
})(NumberScale || (NumberScale = {}));

/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */
/** Failed logins before an account is locked */
const MAX_LOGIN_ATTEMPTS = 5;
var UserType;
(function (UserType) {
    UserType["ServiceAccount"] = "service_account";
})(UserType || (UserType = {}));

/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */
// Blueprint group for both APIs. New GRI 2025 metrics only: reused GRI 2016/2021 metrics join through
// alternatives.gri2025 and must not be listed again.
const gri2025UtrGroup = {
    groupName: 'GRI 2025 (Global Reporting Initiative)',
    groupData: {
        alternativeCode: 'gri2025',
    },
    utrCodes: [
        'gri/2025/102-1/a',
        'gri/2025/102-1/b',
        'gri/2025/102-1/c',
        'gri/2025/102-1/d',
        'gri/2025/102-1/e',
        'gri/2025/102-1/f',
        'gri/2025/102-1/g',
        'gri/2025/102-1/h',
        'gri/2025/102-1/i',
        'gri/2025/102-1/j',
        'gri/2025/102-2/a',
        'gri/2025/102-2/b-i',
        'gri/2025/102-2/b-ii',
        'gri/2025/102-2/b-iii',
        'gri/2025/102-2/b-iv',
        'gri/2025/102-2/b-v',
        'gri/2025/102-2/b-vi',
        'gri/2025/102-2/c',
        'gri/2025/102-2/d',
        'gri/2025/102-3/workforce',
        'gri/2025/102-3/g',
        'gri/2025/102-3/g-actions',
        'gri/2025/102-3/h',
        'gri/2025/102-3/j',
        'gri/2025/102-4/targets',
        'gri/2025/102-4/h',
        'gri/2025/102-4/i',
        'gri/2025/102-4/f',
        'gri/2025/102-4/g',
        'gri/2025/102-4/k',
        'gri/2025/102-5/b',
        'gri/2025/102-6/b',
        'gri/2025/102-6/c',
        'gri/2025/102-7/b',
        'gri/2025/102-7/e',
        'gri/2025/102-8/intensity',
        'gri/2025/102-9/a',
        'gri/2025/102-9/c',
        'gri/2025/102-9/d',
        'gri/2025/102-9/e',
        'gri/2025/102-10/projects',
        'gri/2025/102-10/held',
        'gri/2025/102-10/c',
        'gri/2025/102-10/d',
        'gri/2025/102-10/e',
        'gri/2025/103-1/a',
        'gri/2025/103-1/b',
        'gri/2025/103-2/breakdown',
        'gri/2025/103-2/e',
        'gri/2025/103-3/a',
        'gri/2025/103-4/intensity',
        'gri/2025/103-5/a',
        'gri/2025/103-5/c',
        'gri/2025/103-5/e',
    ],
};

export { AggregationMode, ColumnAggregationCompatibility, ColumnType, ColumnValueAggregation, FeatureCode, FeatureTag, Features, MAX_LOGIN_ATTEMPTS, NumberScale, RequiredTags, SupportedMeasureUnits, Tags, UserType, UtrValueType, ValueAggregation, ValueAggregationChildrenCompatibility, ValueAggregationSiblingsCompatibility, aggregationTypes, canAccessBetaGroup, columnAggregationTypes, customMetric, defaultCompatible, findChildByCode, findGroupByChildCode, frameworks, getColumnAggregations, getCompatibleAggregations, getDefaultAggregation, getDefaultScopePacks, getFeatureDetails, getGriGroup, getGroup, getGroupChildrenTags, getSubGroup, getSubGroupPathByTags, gri2025UtrGroup, isBetaUnlocked, isGroupOffered, ratings, regulatory, sdgGroupFull, standards };
//# sourceMappingURL=index.es.js.map
